import React, {
  useState,
  useEffect,
  FC,
  useCallback,
  useRef,
  useMemo,
} from "react";
import {
  Badge,
  Row,
  Col,
  Button,
  Modal,
  ModalBody,
  Card,
  Spinner,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Alert,
  UncontrolledDropdown,
} from "reactstrap";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
} from "../../components/Component";
import FormatDate from "../masters/DateFormater";
import costCenterApis from "../../api/master/costCenter";
import GeneralLedgerApis from "../../api/master/generalLedger";
import departments from "../../api/master/departments";
import { FormProvider, useForm } from "react-hook-form";
import {
  PaperClipOutlined,
  DownloadOutlined,
  DeleteOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  EditOutlined,
  InfoCircleOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import {
  Form,
  TableColumnsType,
  Input,
  Table,
  Timeline,
  Collapse as AntCollapse,
  Descriptions,
  Modal as AntModal,
  Upload,
  Flex,
  Spin,
  Empty,
  Drawer,
  DatePicker,
  Select,
  InputNumber,
  Button as AntButton,
  message,
} from "antd";
import { nanoid } from "nanoid";
import FormSelect from "../form-components/SelectComponent";
import FormInput from "../form-components/InputComponent";
import FormDatePicker from "../form-components/DatePicker";
import FormTimePicker from "../form-components/FormTimePicker";
import deliveryAddressApis from "../../api/master/deliveryAddress";
import purchaseOrderApis from "../../api/master/PurchaseOrder";
import { Popover, Steps } from "antd";
import Swal from "sweetalert2";
import CropperComponent from "../components/CropperComponent";
import ImageUploadCropper from "../components/ImageUploadCropper";
import SignatureModal from "./SignatureModal";
import dayjs from "dayjs";
import ChangeToBuyerDrawer from "./ChangeToBuyerModal";
import Misc from "../masters/Misc";
import { UploadFile } from "antd/es/upload/interface";
import { AllowedFileTypes } from "../../fileAccess";
import PurchaseOrderAside from "./PurchaseOrderAside";
import statusMapper from "./StatusMapper";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import axios from "axios";
import "react-quill/dist/quill.snow.css";
import budgetApis from "../../api/master/budget";
import purchaseOrderCreation from "../../api/purchase-orders/pruchaseOrderCreation";
import { useSelector } from "react-redux";
import PdfGenerator from "./TestPDF";
import { formatCurrency, formatDecimal } from "../../utils/Utils";
import FormTextArea from "../form-components/TextAreaComponent";
import EmailCreationModal from "../EmailCreationModal";
import contractorsApis from "../../api/master/contractors";
import boqApis from "../../api/boq/boq";
import supplierApis from "../../api/master/supplier";
import sitebreakdownMasterApis from "../../api/master/sitebreakdownMaster";
import MaterialModal from "./EditPOMaterialModal";
import sequenceApis from "../../api/master/sequence";
const { Dragger } = Upload;
const { Panel } = AntCollapse;
const { FormatCurrency, beforeUpload } = Misc;

interface SelectOptions {
  label: string;
  value: string;
}

type Cess = {
  cessName: string;
  cessType?: string;
  cessPercentage?: string;
  cessAmount?: string;
};
interface TaxConfiguration {
  taxType: string;
  gstType?: string; //IGST or CGST+SGST
  cess?: Cess[];
}

interface CurrencyData {
  description: string;
  currency_code: string;
  currency_symbol: string;
  currency_format: string;
  example: string;
}

interface SequenceType {
  module: string;
  level: string;
  siteIds: string[];
}

const SEGMENT_TO_WORK_LEVEL: Record<string, string> = {
  Tower: "TOWER_BLOCK",
  "Tower/Block": "TOWER_BLOCK",
  "Tower / Block": "TOWER_BLOCK",
  Villa: "VILLA",
  Floor: "FLOOR",
  Flat: "FLAT",
};

const HIERARCHY_UNIT_TITLES: Record<string, string> = {
  TOWER_BLOCK: "Tower / Block",
  VILLA: "Villa",
  FLOOR: "Tower / Block",
  FLAT: "Tower / Block",
};

const WORK_LEVEL_TO_SEGMENT: Record<string, string> = {
  TOWER_BLOCK: "Tower",
  VILLA: "Villa",
  FLOOR: "Floor",
  FLAT: "Flat",
};

const ViewOrderDetails: FC<any> = ({ orderNumber, previousPath, extra }) => {
  const [rejectForm] = Form.useForm();
  const pdfBlobData: any = useRef(null);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const { data: accessibility } = useSelector(
    (state: any) => state.accessibility
  );
  const [allowedActions, setAllowedActions] = useState<any>({
    add: 0,
    view: 0,
    edit: 0,
    approve: 0,
    reject: 0,
    cancel: 0,
  });
  const [invoiceAllowedActions, setInvoiceAllowedActions] = useState<any>({
    add: 0,
    view: 0,
    edit: 0,
    approve: 0,
    reject: 0,
    cancel: 0,
  });
  const [materialCategoryOptions, setMaterialCategoryOptions] = useState([]);
  const { data: currentUser } = useSelector((state: any) => state.currentUser);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [disableApprove, setDisableApprove] = useState(false);
  const [disableReject, setDisableReject] = useState(false);
  const [disableAccept, setDisableAccept] = useState(false);
  const [disableRejectS, setDisableRejectS] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const [OriginalData, setOriginalData] = useState<any>({});
  const [poStatus, setPoStatus] = useState<any>("");
  const [showSubmitBtm, setShowSubmitBtm] = useState(false);
  const [sm, setSm] = useState(false);
  const [tab, setTab] = useState("1");
  const [screenSize, setScreenSize] = useState(0);
  const [mobileView, setMobileView] = useState(false);
  const [taxConfiguration, setTaxConfiguration] = useState<TaxConfiguration>();
  const [instructionsVisible, setInstructionsVisible] = useState(false);
  const [termsVisible, setTermsVisible] = useState(false);
  const [materialData, setMaterialData] = useState<any>({});
  const [boqData, setBoqData] = useState<any[]>([]);
  const [supplierList, setSupplierList] = useState<any>([]);
  const [attachments, setAttachments] = useState<any>([]);
  const [deletedAttachments, setDeletedAttachments] = useState<any>([]);
  const [newAttachments, setNewAttachments] = useState<any>([]);
  const [showSignatureModel, setShowSignatureModel] = useState<boolean>(false);
  const [showCropModel, setShowCropModel] = useState<boolean>(false);
  const [signature, setSignature] = useState<any>([]);
  const [deliveryAddressList, setDeliveryAddressList] = useState<any>([]);
  const [crRejectModal, setCrRejectModal] = useState<boolean>(false);
  const [disapprovePO, setDisapprovePO] = useState<boolean>(false);
  const [supplierOptions, setSupplierOptions] = useState<SelectOptions[]>([]);
  const [costCenterOptions, setCostCenterOptions] = useState<SelectOptions[]>(
    []
  );
  const [sitesOptions, setSitesOptions] = useState<SelectOptions[]>([]);
  const [generalLedgerOptions, setGeneralLedgerOptions] = useState<
    SelectOptions[]
  >([]);
  const [departmentOptions, setDepartmentOptions] = useState<SelectOptions[]>(
    []
  );
  const [budgetOptions, setBudgetOptions] = useState<SelectOptions[]>([]);
  const [contractorOptions, setContractorOptions] = useState<SelectOptions[]>(
    []
  );

  const [deliveryAddressOptions, setDeliveryAddressOptions] = useState<
    SelectOptions[]
  >([]);
  const [currency, setCurrency] = useState<CurrencyData>({
    description: "",
    currency_code: "",
    currency_symbol: "",
    currency_format: "",
    example: "",
  });

  const [DMS, setDMS] = useState<any>([]);
  const [editLineRow, setEditLineRow] = useState<any>();
  const [changeToBuyerData, setChangeToBuyerData] = useState<any>();
  const [generalInformationEdit, setGeneralInformationEdit] = useState(false);
  const [termsAndConditions, setTermsAndConditions] = useState<any>("");
  const [newTermsAndConditions, setNewTermsAndConditions] = useState<any>("");
  const [instructions, setInstructions] = useState("");
  const [newInstructions, setNewInstructions] = useState<any>("");
  const [isInstructionsChanged, setIsInstructionsChanged] = useState(false);
  const [currentUserId, setCurrentUserId] = useState<any>(null);
  const [approverIds, setApproverIds] = useState<any>([]);
  const [isTermsAndConditionsChanged, setIsTermsAndConditionsChanged] =
    useState(false);
  const [transferPoDrawerVisible, setTransferPoDrawerVisible] = useState(false);
  const [invoiceDate, setInvoiceDate] = useState<any>();
  const [grnRequired, setGrnRequired] = useState<any>(null);
  const [showMoreTransportFields, setShowMoreTransportFields] = useState(false);

  // Signature states for approve/reject
  const [approveSignature, setApproveSignature] = useState({
    isActive: false,
    label: "Authorised Signatory",
    image: null as string | null,
  });
  const [rejectSignature, setRejectSignature] = useState({
    isActive: false,
    label: "Authorised Signatory",
    image: null as string | null,
  });
  const [activeSignatureContext, setActiveSignatureContext] = useState<
    "APPROVE" | "REJECT" | null
  >(null);
  const [isModalApproveVisible, setIsModalApproveVisible] = useState(false);
  const [isModalRejectedVisible, setIsModalRejectedVisible] = useState(false);
  const [isStrictMode, setIsStrictMode] = useState<boolean>(false);

  const drawerMethods = useForm<any>({
    mode: "onChange",
    defaultValues: {},
  });

  const {
    handleSubmit: handleDrawerSubmit,
    reset: resetDrawer,
    setValue: setDrawerValue,
    watch: watchDrawer,
  } = drawerMethods;
  const [invoiceAttachments, setInvoiceAttachments] = useState<any>([]);
  const [invoiceSignature, setInvoiceSignature] = useState<any>({});
  const [invoiceableLines, setInvoiceableLines] = useState<any>([]);
  const [selectedDeliveryAddress, setSelectedDeliveryAddress] =
    useState<any>(null);
  const [selectedNeedByDate, setSelectedNeedByDate] = useState<any>(null);
  const [transferPoDeliveryAddressList, setTransferPoDeliveryAddressList] =
    useState<any>([]);
  const [transferPoNeedByDateList, setTransferPoNeedByDateList] = useState<any>(
    []
  );
  const [sequenceAccess, setSequenceAccess] = useState<SequenceType>({
    module: "",
    level: "",
    siteIds: [],
  });

  const methods = useForm({
    mode: "onChange",
  });

  const {
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = methods;

  const siteIdWatch = watch("siteId");
  const termsAndConditionsWatch = watch("termsAndConditions");
  const instructionsWatch = watch("instructions");
  useEffect(() => {
    if (termsAndConditionsWatch) {
      setNewTermsAndConditions(termsAndConditionsWatch);
    }
  }, [termsAndConditionsWatch]);

  useEffect(() => {
    if (instructionsWatch) {
      setNewInstructions(instructionsWatch);
    }
  }, [instructionsWatch]);

  useEffect(() => {
    if (siteIdWatch) {
      fetchBudgetDetails(siteIdWatch);
      fetchContractorList(siteIdWatch + "");
    }
  }, [siteIdWatch]);

  useEffect(() => {
    if (grnRequired !== "false") {
      setShowMoreTransportFields(false);
    }
  }, [grnRequired]);

  useEffect(() => {
    if (!transferPoDrawerVisible) {
      resetDrawer();
    }
  }, [transferPoDrawerVisible, resetDrawer]);

  const updatePdfBlobDataRef = (newData: any) => {
    try {
      pdfBlobData.current = newData;
    } catch (error) { }
  };

  const TriggerEmail = async (emailData: any, _methods: any) => {
    try {
      const formData = new FormData();
      formData.append("msgType", "purchaseOrderCreated");
      formData.append("logo", currentUser?.orgLogo);
      formData.append("email", emailData?.to);
      formData.append("cc", emailData?.cc);
      formData.append("bcc", emailData?.bcc);
      if (emailData?.attachments?.length > 0) {
        emailData?.attachments?.forEach((attachment: any, index: number) => {
          if (!attachment) {
            return;
          }
          let file: any = null;
          if (index == 0) {
            file = new File(
              [pdfBlobData.current],
              OriginalData?.orderId + ".pdf",
              {
                type: "application/pdf",
              }
            );
          } else {
            file = attachment?.originFileObj;
          }
          formData.append(`files`, file);
        });
      }
      const response: any = await purchaseOrderApis.sendOrderEmailNotification(
        orderNumber,
        formData
      );
      const { data, status } = response;
      if (status) {
        Swal.fire("Success", "Email has been sent successfully", "success");
        _methods.reset();
        setShowEmailModal(false);
      }
    } catch (error) {
      console.log(error);
      setShowEmailModal(false);
    }
  };

  useEffect(() => {
    if (accessibility) {
      try {
        const poAccess = accessibility["Purchase Order"];
        const invoiceAccess = accessibility["Invoice"];
        if (poAccess) {
          const { add, view, edit, approve, reject, cancel } = poAccess;
          setAllowedActions({ add, view, edit, approve, reject, cancel });
        }
        if (invoiceAccess) {
          const { add, view, edit, approve, reject, cancel } = invoiceAccess;
          setInvoiceAllowedActions({
            add,
            view,
            edit,
            approve,
            reject,
            cancel,
          });
        }
      } catch (error) {
        console.log(error);
      }
    }
  }, [accessibility]);

  useEffect(() => {
    if (disapprovePO == false) {
      setDisableReject(false);
    }
  }, [disapprovePO]);
  useEffect(() => {
    if (crRejectModal == false) {
      setDisableRejectS(false);
    }
  }, [crRejectModal]);
  const fetchCategorys = async () => {
    try {
      const { data, status } = await supplierApis.fetchSupplierCategory();
      if (status) {
        const categoryOption = data.map((item: any) => ({
          label: item.category,
          value: item.id.toString(),
        }));
        setMaterialCategoryOptions(categoryOption);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchBudgetDetails = async (siteId: any) => {
    try {
      const { data, status } = await budgetApis.getBudgetBySite(siteId);

      if (status) {
        let budgetOptions = data.map((item: any) => ({
          label: item.budgetName,
          value: item.headerId,
        }));
        setBudgetOptions(budgetOptions);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchContractorList = async (siteId: any) => {
    try {
      const { data, status } = await contractorsApis.fetchContractorBySiteId({
        id: siteId,
      });
      if (status) {
        let contractorOptions = data.map((item: any) => ({
          label: item?.companyName,
          value: item?.contractorID?.toString(),
        }));
        setContractorOptions(contractorOptions);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const [addNewRowModel, setAddNewRowModel] = useState<boolean>(false);

  useEffect(() => {
    if (currentUser) {
      const { siteAccessibility, id } = currentUser;
      setCurrentUserId(id);
      if (siteAccessibility) {
        const sitesOptions = siteAccessibility?.map((item: any) => ({
          label: item.siteName,
          value: item.siteID.toString(),
        }));
        setSitesOptions(sitesOptions);
      }
    }
  }, [currentUser]);
  useEffect(() => {
    fetchCategorys();
    fetchOrderDetails();
    fetchDeliveryAddress();
    fetchSupplier();
    fetchCostCenter();
    fetchGeneralLedger();
    fetchDepartment();
    fetchSequenceAccess();
    viewChange();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);
    const headerClick = () => setSm(false);
    document
      .getElementsByClassName("nk-header")[0]
      ?.addEventListener("click", headerClick);

    return () => {
      window.removeEventListener("resize", viewChange);
      window.removeEventListener("load", viewChange);
      document
        .getElementsByClassName("nk-header")[0]
        ?.removeEventListener("click", headerClick);
    };
  }, []);

  const viewChange = () => {
    setScreenSize(window.innerWidth);
    if (window.innerWidth < 990) {
      setMobileView(true);
    } else {
      setMobileView(false);
      setSm(false);
    }
  };

  const handleAttachmentChange = (info: { fileList: UploadFile[] }) => {
    setNewAttachments((pre: any) => {
      return [...pre, ...info.fileList];
    });
    setShowSubmitBtm(true);
  };

  const fetchHtmlContentFromUrl = async (url: string) => {
    try {
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "text/html",
        },
      });

      return response?.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  const fetchOrderDetails = async () => {
    try {
      const res = await purchaseOrderApis.fetchOrder(orderNumber);
      const { data, status, message } = res;
      if (status) {
        let data = res.data;

        const isStrict = data?.isStrictApproval === true || data?.isStrictApproval === 1;;
        setIsStrictMode(isStrict);

        if (data?.orderApprovals) {
          const processedApprovals = data.orderApprovals.map((approval: any) => ({
            ...approval,
            level: approval.level?.toLowerCase() || approval.level,
            status: approval.status?.toLowerCase() || approval.status
          }));
          data.orderApprovals = processedApprovals;

          // Filter pending approvals
          let ids = processedApprovals
            ?.filter((item: any) => item?.status?.toLowerCase() !== "approved")
            ?.map((item: any) => item?.userId);
          setApproverIds(ids);
        }

        setOriginalData(data);
        setPoStatus(data?.orderStatus);
        // if (data?.orderApprovals) {
        //   let ids = data?.orderApprovals
        //     ?.filter((item: any) => item?.status != "Approved")
        //     ?.map((item: any) => item?.userId);
        //   setApproverIds(ids);
        // }

        const {
          currencyCode,
          currencySymbol,
          currencyFormat,
          dms,
          signatureLabel,
          igst,
        } = data;
        if (Number(igst) == 0) {
          setTaxConfiguration({
            taxType: "GST",
            gstType: "CGST+SGST",
            cess: [
              // {
              //   cessName: "Cess",
              //   cessType: "CGST",
              //   cessPercentage: "0",
              //   cessAmount: "0",
              // },
              // {
              //   cessName: "Cess",
              //   cessType: "SGST",
              //   cessPercentage: "0",
              //   cessAmount: "0",
              // },
            ],
          });
        } else {
          setTaxConfiguration({
            taxType: "GST",
            gstType: "IGST",
            cess: [
              // {
              //   cessName: "Cess",
              //   cessType: "IGST",
              //   cessPercentage: "0",
              //   cessAmount: "0",
              // },
            ],
          });
        }

        if (dms?.length > 0) {
          setDMS(dms);
          const _signature = dms?.find(
            (item: any) => item.moduleFileType == "signature"
          );
          if (_signature) {
            setSignature({
              docId: _signature?.docId,
              fileName: _signature?.fileName,
              image: _signature?.filePath,
              moduleFileType: _signature?.moduleFileType,
              module: _signature?.module,
              label: signatureLabel,
              isActive: true,
            });
          }
          const _termsAndConditions = dms?.find(
            (item: any) => item.moduleFileType == "termsAndConditions"
          );
          if (_termsAndConditions) {
            const data: any = await fetchHtmlContentFromUrl(
              _termsAndConditions?.filePath
            );
            setTermsAndConditions(data);
            setNewTermsAndConditions(data);
          }
          const _instructions = dms?.find(
            (item: any) => item.moduleFileType == "instructions"
          );
          if (_instructions) {
            const data: any = await fetchHtmlContentFromUrl(
              _instructions?.filePath
            );
            setInstructions(data);
            setNewInstructions(data);
          }
          const _attachments = dms?.filter(
            (item: any) => item.moduleFileType == "attachments" && item.docHash
          );
          if (_attachments) {
            setAttachments(
              _attachments.map((attachment: any) => ({
                docId: attachment?.docId,
                name: attachment?.fileName,
                link: attachment?.filePath,
                moduleFileType: attachment?.moduleFileType,
                module: attachment?.module,
                label: "attachments",
                isActive: true,
              }))
            );
          }
        }
        const [unitsResponse, locationsResponse] = await Promise.all([
          data?.siteId
            ? sitebreakdownMasterApis.fetchUnitsBySiteId({
              siteId: data.siteId,
            })
            : Promise.resolve(null),
          data?.siteId
            ? sitebreakdownMasterApis.fetchLocationsBySiteId({
              siteId: data.siteId,
            })
            : Promise.resolve(null),
        ]);

        const unitNameMap = new Map<string, string>();
        if (unitsResponse?.status && Array.isArray(unitsResponse.data)) {
          unitsResponse.data.forEach((unit: any) => {
            if (unit?.id) {
              unitNameMap.set(String(unit.id), unit?.unitName ?? "");
            }
          });
        }

        const locationNameMap = new Map<string, string>();
        if (
          locationsResponse?.status &&
          Array.isArray(locationsResponse.data)
        ) {
          locationsResponse.data.forEach((location: any) => {
            if (location?.id) {
              locationNameMap.set(
                String(location.id),
                location?.locationName ?? ""
              );
            }
          });
        }

        const subUnitCache = new Map<string, any[]>();

        const getSubUnitsFor = async (
          unitId?: number | string,
          floorNo?: string | null
        ) => {
          if (!unitId) {
            return [];
          }
          if (!data?.siteId) {
            return [];
          }
          const cacheKey = `${unitId}-${floorNo ?? ""}`;
          if (subUnitCache.has(cacheKey)) {
            return subUnitCache.get(cacheKey) ?? [];
          }
          try {
            const response =
              await sitebreakdownMasterApis.fetchSubUnitsByUnitId({
                siteId: data?.siteId,
                unitId,
                floorNo: floorNo ?? undefined,
              });
            if (response?.status && Array.isArray(response.data)) {
              subUnitCache.set(cacheKey, response.data);
              return response.data;
            }
          } catch (error) {
            console.error("Failed to fetch sub units", error);
          }
          subUnitCache.set(cacheKey, []);
          return [];
        };

        const lineItemsWithHierarchy: any[] = [];
        for (const item of data?.lineItems ?? []) {
          const originalSegmentLevelValue =
            item?.segmentLevel &&
              item.segmentLevel.toString().toLowerCase() !== "null"
              ? item.segmentLevel
              : null;
          const updatedItem: any = { ...item };
          updatedItem.segmentLevel = originalSegmentLevelValue;
          const file = dms?.find((doc: any) => doc.lineNo == item.lineNo);
          if (file) {
            updatedItem.file = file;
            updatedItem.attachment = true;
          } else {
            updatedItem.attachment = false;
          }

          if (item?.siteStructureUnitId) {
            updatedItem.siteStructureUnitName =
              unitNameMap.get(String(item.siteStructureUnitId)) ?? "";
          }

          if (item?.locationId) {
            updatedItem.locationName =
              locationNameMap.get(String(item.locationId)) ??
              updatedItem.locationName;
          }

          if (item?.siteStructureSubUnitId) {
            const subUnits = await getSubUnitsFor(
              item.siteStructureUnitId,
              item.floorNo
            );
            const matchedSubUnit = subUnits.find(
              (sub: any) => sub?.id == item.siteStructureSubUnitId
            );
            if (matchedSubUnit) {
              updatedItem.siteStructureSubUnitName =
                matchedSubUnit?.subUnitName ?? matchedSubUnit?.unitName ?? "";
            }
          }

          lineItemsWithHierarchy.push(updatedItem);
        }

        const hierarchyStrings = lineItemsWithHierarchy
          .map((record: any) => {
            const parts: string[] = [];
            const recordSegmentLevel =
              record?.segmentLevel &&
                record.segmentLevel.toString().toLowerCase() !== "null"
                ? record.segmentLevel
                : materialData?.segmentLevel &&
                  materialData.segmentLevel.toString().toLowerCase() !== "null"
                  ? materialData.segmentLevel
                  : null;
            if (recordSegmentLevel) {
              parts.push(recordSegmentLevel);
            }
            const unitName =
              record?.siteStructureUnitName ||
              record?.towerBlockVillaName ||
              record?.towerBlockName ||
              null;
            if (unitName && unitName.toString().trim().length > 0) {
              parts.push(unitName);
            }
            if (record?.floorNo) {
              parts.push(`Floor ${record.floorNo}`);
            }
            if (record?.siteStructureSubUnitName || record?.flatName) {
              const subUnitName =
                record?.siteStructureSubUnitName || record?.flatName || "";
              if (subUnitName.trim().length > 0) {
                parts.push(subUnitName);
              }
            }
            if (record?.locationName) {
              parts.push(record.locationName);
            }
            return parts
              .filter((item) => item && item.trim().length > 0)
              .join(" • ");
          })
          .filter((item: string) => item && item.trim().length > 0);

        const uniqueHierarchyStrings = Array.from(new Set(hierarchyStrings));

        setMaterialData({
          ...data,
          lineItems: lineItemsWithHierarchy,
          siteHierarchySummary: uniqueHierarchyStrings.join("\n"),
          hierarchyVisibility: {
            segmentLevel: lineItemsWithHierarchy.some((item) => {
              if (
                item?.segmentLevel &&
                item.segmentLevel.toString().toLowerCase() !== "null"
              ) {
                return true;
              }
              return (
                materialData?.segmentLevel &&
                materialData.segmentLevel.toString().toLowerCase() !== "null"
              );
            }),
            tower: lineItemsWithHierarchy.some(
              (item) =>
                item?.siteStructureUnitId ||
                item?.siteStructureUnitName ||
                item?.towerBlockVillaName ||
                item?.towerBlockName
            ),
            floor: lineItemsWithHierarchy.some((item) => item?.floorNo),
            flat: lineItemsWithHierarchy.some(
              (item) => item?.siteStructureSubUnitId || item?.flatId
            ),
            location: lineItemsWithHierarchy.some((item) => item?.locationId),
          },
          orderWorkLevel:
            data?.segmentLevel && SEGMENT_TO_WORK_LEVEL[data.segmentLevel]
              ? SEGMENT_TO_WORK_LEVEL[data.segmentLevel]
              : lineItemsWithHierarchy.reduce((acc: string | null, item) => {
                if (acc) return acc;
                const seg =
                  item?.segmentLevel &&
                    item.segmentLevel.toString().toLowerCase() !== "null"
                    ? item.segmentLevel
                    : materialData?.segmentLevel &&
                      materialData.segmentLevel.toString().toLowerCase() !==
                      "null"
                      ? materialData.segmentLevel
                      : null;
                if (!seg) return acc;
                return SEGMENT_TO_WORK_LEVEL[seg] || acc;
              }, null),
        });

        // Map advanceMilestones (or legacy advancePaymentDetails) for view + edit
        const materialDataObj: any = {
          ...data,
          lineItems: lineItemsWithHierarchy,
        };
        if (Array.isArray(data?.advanceMilestones) && data.advanceMilestones.length > 0) {
          materialDataObj.advanceMilestones = data.advanceMilestones;
        } else if (data?.advancePaymentDetails) {
          materialDataObj.paymentMode = data.advancePaymentDetails.mode || "";
          materialDataObj.transactionNumber =
            data.advancePaymentDetails.transactionNumber || "";
          materialDataObj.bankName = data.advancePaymentDetails.bankName || "";
          materialDataObj.paymentDate = data.advancePaymentDetails.paymentDate
            ? dayjs(data.advancePaymentDetails.paymentDate).toDate()
            : null;
          materialDataObj.paymentRemarks =
            data.advancePaymentDetails.remarks || "";
        }

        setMaterialData(materialDataObj);

        // Fetch BOQ data for quantity validation
        const headerSiteId = materialDataObj?.siteId;
        const headerContractorId = materialDataObj?.contractorId;
        if (headerSiteId && headerContractorId) {
          try {
            const boqResponse = await boqApis.fetchContractorBoqDropdown({
              siteIds: headerSiteId.toString(),
              contractorIds: headerContractorId.toString(),
            });
            const boqList = boqResponse?.data || boqResponse?.response || [];
            setBoqData(Array.isArray(boqList) ? boqList : []);
          } catch (err) {
            console.log("Failed to fetch BOQ data:", err);
            setBoqData([]);
          }
        }

        // setData(LineItems);

        setShowSubmitBtm(false);
        setDeletedAttachments([]);
        setNewAttachments([]);
        setCurrency({
          description: currencyCode,
          currency_code: currencyCode,
          currency_symbol: currencySymbol,
          currency_format: currencyFormat,
          example: currencyCode,
        });
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const parseLevelNum = (level: any) => {
    if (!level && level !== 0) return NaN;
    const str = String(level).toLowerCase();

    // Handle various level formats: level1, Level2, L1, L2, etc.
    if (str.includes('level')) {
      const match = str.match(/\d+/);
      return match ? parseInt(match[0], 10) : NaN;
    } else if (str.startsWith('l')) {
      const match = str.match(/\d+/);
      return match ? parseInt(match[0], 10) : NaN;
    }
    return NaN;
  };

  const hasUserAlreadyApproved = materialData?.orderApprovals?.some(
    (a: any) =>
      a.userId === currentUserId &&
      a.status?.toUpperCase() === "APPROVED"
  );

  const canUserApproveReject = useCallback(() => {
    // 1. Admin can Approve/Reject anytime - Buttons are always ENABLED
    if (currentUser?.genericRole?.toLowerCase() === "admin") {
      return true;
    }

    const approvals = materialData?.orderApprovals || [];

    // Find current user's approval entry
    const userApproval = approvals.find(
      (approval: any) => approval.userId === currentUserId
    );

    if (!userApproval || userApproval.status?.toLowerCase() !== "pending") {
      return false;
    }

    const userLevelNum = parseLevelNum(userApproval.level ?? currentUser?.approvalLevel);

    // 2. Strict = 0 (Flexible mode)
    // Anyone in the approval list can approve at any time
    if (isStrictMode === false) {
      // In flexible mode, just check if user is in the approval list and pending
      return true;
    }

    // 3. Strict = 1 (Sequential mode)
    // Must follow the order. Level 2 cannot see buttons until Level 1 is "Approved"
    if (isStrictMode === true) {
      // Get all pending approvals sorted by level
      const pendingApprovals = approvals
        .filter((approval: any) => approval.status?.toLowerCase() === "pending")
        .sort((a: any, b: any) => {
          const aNum = parseLevelNum(a.level);
          const bNum = parseLevelNum(b.level);
          if (isNaN(aNum) || isNaN(bNum)) return 0;
          return aNum - bNum;
        });

      // If there are no pending approvals, user can't approve
      if (pendingApprovals.length === 0) return false;

      // Get the first pending approval (lowest level)
      const firstPending = pendingApprovals[0];
      const firstPendingLevelNum = parseLevelNum(firstPending.level);

      // Check if user is the first pending approver
      return userApproval.userId === firstPending.userId &&
        userLevelNum === firstPendingLevelNum;
    }

    return false;
  }, [currentUser, currentUserId, materialData?.orderApprovals, isStrictMode]);

  const getPendingStatusMessage = () => {
    const approvals = materialData?.orderApprovals || [];
    const pendingApprovals = approvals
      .filter((approval: any) => approval.status?.toLowerCase() === "pending")
      .sort((a: any, b: any) => {
        const aNum = parseLevelNum(a.level);
        const bNum = parseLevelNum(b.level);
        if (isNaN(aNum) || isNaN(bNum)) return 0;
        return aNum - bNum;
      });

    if (pendingApprovals?.length > 0) {
      if (!isStrictMode) {
        // Flexible mode - any approver can approve
        const approverNames = pendingApprovals.map((approval: any) => approval.userName).join(", ");
        return `Status is pending. Any of these approvers can approve: ${approverNames}`;
      } else {
        // Strict mode - must follow sequence
        const nextApprover = pendingApprovals[0];
        const lvl = parseLevelNum(nextApprover.level);
        const levelText = !isNaN(lvl) ? `Level ${lvl}` : nextApprover.roleName || "";
        return `Status is pending. Waiting for ${nextApprover.userName} (${levelText}) to approve first.`;
      }
    }

    return "Status is pending by other approvers";
  };

  const ShowAddressPopOver = ({ type, id }: any) => {
    if (!id) {
      return <></>;
    }
    let address = deliveryAddressList?.find((item: any) => item?.id == id);
    if (!address) {
      return <></>;
    }
    const { cin, gstin, pan, phoneNumber } = OriginalData?.orgDetails;
    return (
      <ul>
        <li>
          <strong style={{ color: "#2263b3" }}>
            {address?.deliveryLocationName}
          </strong>
        </li>
        <li>{address?.addressLine1}</li>
        <li>{address?.addressLine2}</li>
        <li>
          {address?.city}, {address?.stateName}, {address?.countryName} -{" "}
          {address?.pincode}
        </li>
        {type == "billing" && (
          <>
            <li>
              <strong>GSTIN</strong> : {gstin}
            </li>
            <li>
              <strong>CIN</strong> : {cin}
            </li>
            <li>
              <strong>PAN</strong> : {pan}
            </li>
            <li>
              <strong>Phone</strong> : {phoneNumber}
            </li>
          </>
        )}
        {type == "delivery" && (
          <>
            <li>
              <strong>Contact Person</strong> : {address?.contactPersonName}
            </li>
            <li>
              <strong>Mobile Number</strong> : {address?.mobileNumber}
            </li>
          </>
        )}
      </ul>
    );
  };

  const fetchSupplier = async () => {
    try {
      const res: any =
        await purchaseOrderCreation.fetchBuyerLinkedSupplierListMethod();
      const { data, status } = res;
      if (status) {
        let supplierOptions = data.map((item: any) => ({
          label: item?.sellerOrg?.name,
          value: item?.sellerOrg?.orgId?.toString(),
        }));
        setSupplierOptions(supplierOptions);
        setSupplierList(data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchCostCenter = async () => {
    try {
      const { data, status, message } = await costCenterApis.fetchCostCenter();
      if (status) {
        let costCenterOptions = data.map((item: any) => {
          return { label: item.costCenterName, value: item.id.toString() };
        });
        setCostCenterOptions(costCenterOptions);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchGeneralLedger = async () => {
    try {
      const { data, status, message } = await GeneralLedgerApis.fetchLedger();
      if (status) {
        let generalLedgerOptions = data.map((item: any) => {
          return { label: item.ledgerName, value: item.ledgerID.toString() };
        });
        setGeneralLedgerOptions(generalLedgerOptions);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchDepartment = async () => {
    try {
      const { data, status, message } = await departments.fetchDeptData();
      if (status) {
        let departmentOptions = data.map((item: any) => {
          return { label: item.deptName, value: item.deptID.toString() };
        });
        setDepartmentOptions(departmentOptions);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchSequenceAccess = async () => {
    try {
      const response = await sequenceApis.fetchSequence();
      const { data } = response;
      const today = new Date();
      const _sequenceAccess = data?.filter(
        (item: any) =>
          item.moduleName === "Purchase Order" &&
          new Date(item.endDate) > today &&
          item.status === "Active"
      );
      if (_sequenceAccess.length > 0) {
        setSequenceAccess({
          module: "Purchase Order",
          level: _sequenceAccess[0].level,
          siteIds: _sequenceAccess?.map((item: any) =>
            item?.siteId?.toString()
          ),
        });
      } else
        setSequenceAccess({
          module: "",
          level: "",
          siteIds: [],
        });
    } catch (error: any) {
      console.log(error.response?.data?.message || "An error occurred");
    }
  };

  const fetchDeliveryAddress = async () => {
    try {
      const { data, status } = await deliveryAddressApis.fetchDeliveryAddress();
      if (status) {
        let deliveryAddressOptions = data.map((item: any) => ({
          label: item.deliveryLocationName,
          value: item.id.toString(),
        }));
        setDeliveryAddressOptions(deliveryAddressOptions);
        setDeliveryAddressList(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const hierarchyVis = useMemo(() => {
    const vis = materialData?.hierarchyVisibility;
    return {
      segmentLevel: vis?.segmentLevel ?? false,
      tower: vis?.tower ?? false,
      floor: vis?.floor ?? false,
      flat: vis?.flat ?? false,
      location: vis?.location ?? false,
    };
  }, [materialData?.hierarchyVisibility]);

  const towerColumnTitle = useMemo(() => {
    const level = materialData?.orderWorkLevel;
    if (!level) {
      return "Tower / Block / Villa";
    }
    return HIERARCHY_UNIT_TITLES[level] ?? "Tower / Block";
  }, [materialData?.orderWorkLevel]);

  const configColumns = (
    taxConfiguration: any,
    currency: any,
    poStatus: any,
    dataSource: any,
    OriginalData: any
  ) => {
    return [
      {
        ...Table.EXPAND_COLUMN,
        fixed: "left",
      },
      {
        title: "#",
        key: "#",
        width: 50,
        fixed: "left",
        render: (text: any, record: any, index: number) => index + 1,
        onCell: (record: any, index: number) => {
          if (record?.key == "lastRow") {
            return {
              colSpan: 0,
            };
          }
          return {};
        },
      },
      {
        title: "Material Name",
        dataIndex: "materialName",
        key: "materialName",
        width: 200,
        fixed: "left",
        onCell: (record: any, index: number) => {
          if (record?.key == "lastRow") {
            return {
              colSpan: 0,
            };
          }
          return {};
        },
      },
      {
        title: "Make",
        dataIndex: "makeInfo",
        key: "makeInfo",
        width: 150,
        render: (_: any, record: any) => {
          if (record?.makeInfo?.length > 0) {
            return record.makeInfo.map((m: any) => m.makeName).join(", ");
          }
          return record?.makeLabel || "-";
        },
      },
      {
        title: "Need By Date",
        dataIndex: "needByDate",
        key: "needByDate",
        width: 150,
        hidden: OriginalData?.needByDateType == "Order Level",
        render: (text: any) => FormatDate(text),
        onCell: (record: any, index: number) => {
          if (record?.key == "lastRow") {
            return {
              colSpan: 0,
            };
          }
          return {};
        },
      },
      {
        title: "HSN / SAC",
        dataIndex: "hsnCode",
        key: "hsnCode",
        width: 100,
        render: (text: any, record: any) => {
          if (record?.key == "lastRow") {
            return <b className="justify-end">Total Qty: </b>;
          } else {
            return text;
          }
        },
        onCell: (record: any, index: number) => {
          if (record?.key == "lastRow") {
            return {
              colSpan: 3,
            };
          }
          return {};
        },
      },
      {
        title: "Qty",
        dataIndex: "quantity",
        key: "quantity",
        width: 150,
        render: (text: any, record: any) => {
          if (record?.key == "lastRow") {
            const total = dataSource.reduce((a: any, b: any) => {
              return +a + +b.quantity;
            }, 0);
            return (
              <div className="justify-end">{Number(total).toFixed(2)}</div>
            );
          }
          return (
            <div className="justify-end">
              {Number(text).toFixed(2)} {record?.uom || record?.uomLabel}
            </div>
          );
        },
      },
      {
        title: "Invoiced Qty",
        dataIndex: "quantityInvoiced",
        key: "quantityInvoiced",
        width: 150,
        render: (text: any, record: any) => {
          if (record?.key == "lastRow") {
            const total = dataSource.reduce((a: any, b: any) => {
              const value = Number(b.quantityInvoiced) || 0;
              return +a + value;
            }, 0);
            return (
              <div className="justify-end">{Number(total).toFixed(2)}</div>
            );
          }
          const value = Number(text) || 0;
          return (
            <div className="justify-end">
              {Number(value).toFixed(2)} {record?.uom || record?.uomLabel}
            </div>
          );
        },
      },
      {
        title: " Delivered Qty",
        dataIndex: "quantityDelivered",
        key: "quantityDelivered",
        width: 150,
        render: (text: any, record: any) => {
          if (record?.key == "lastRow") {
            const total = dataSource.reduce((a: any, b: any) => {
              const value = Number(b.quantityDelivered) || 0;
              return +a + value;
            }, 0);
            return (
              <div className="justify-end">{Number(total).toFixed(2)}</div>
            );
          }
          const value = Number(text) || 0;
          return (
            <div className="justify-end">
              {Number(value).toFixed(2)} {record?.uom || record?.uomLabel}
            </div>
          );
        },
      },
      {
        title: "Transfer Qty",
        dataIndex: "quantityTransferred",
        key: "quantityTransferred",
        width: 150,
        hidden: OriginalData?.isOrderTransferred === 0,
        render: (text: any, record: any) => {
          if (record?.key == "lastRow") {
            const total = dataSource.reduce((a: any, b: any) => {
              const value = Number(b.quantityTransferred) || 0;
              return +a + value;
            }, 0);
            return (
              <div className="justify-end">{Number(total).toFixed(2)}</div>
            );
          }
          const value = Number(text) || 0;
          return (
            <div className="justify-end">
              {Number(value).toFixed(2)} {record?.uom || record?.uomLabel}
            </div>
          );
        },
      },
      {
        title: "Unit Price",
        dataIndex: "unitPrice",
        key: "unitPrice",
        width: 150,
        render: (text: any) => (
          <div className="justify-end">
            {FormatCurrency(text, currency?.currency_code)}
          </div>
        ),
        onCell: (record: any, index: number) => {
          if (record?.key == "lastRow") {
            return {
              colSpan: 0,
            };
          }
          return {};
        },
      },
      // Site hierarchy columns removed (tower, floor, flat, location)
      {
        title: "Basic Amount",
        key: "amount",
        width: 150,
        render: (text: any, record: any) => (
          <p className="text-right">
            {FormatCurrency(
              Number(record?.unitPrice) * Number(record?.quantity),
              currency?.currency_code
            )}
          </p>
        ),
        onCell: (record: any, index: number) => {
          if (record?.key == "lastRow") {
            return {
              colSpan: 0,
            };
          }
          return {};
        },
      },
      {
        title: "CGST",
        hidden: taxConfiguration?.gstType == "IGST",
        children: [
          {
            title: "%",
            dataIndex: "cgstPercentage",
            key: "cgstPercentage",
            width: 100,
            onCell: (record: any, index: number) => {
              if (record?.key == "lastRow") {
                return {
                  colSpan: 0,
                };
              }
              return {};
            },
            render: (text: any, record: any) =>
              `${!Number(record?.igst) ? Number(text) + "%" : "N/A"}`,
          },
          {
            title: "Amount",
            dataIndex: "cgst",
            key: "cgst",
            width: 150,
            onCell: (record: any, index: number) => {
              if (record?.key == "lastRow") {
                return {
                  colSpan: 0,
                };
              }
              return {};
            },
            render: (text: any, record: any) => (
              <div style={{ textAlign: "right" }}>
                <span>
                  {!Number(record?.igst) ? formatCurrency(text, "INR") : "N/A"}
                </span>
              </div>
            ),
          },
        ],
      },
      {
        title: "SGST",
        hidden: taxConfiguration?.gstType == "IGST",
        children: [
          {
            title: "%",
            dataIndex: "sgstPercentage",
            key: "sgstPercentage",
            width: 100,
            onCell: (record: any, index: number) => {
              if (record?.key == "lastRow") {
                return {
                  colSpan: 0,
                };
              }
              return {};
            },
            render: (text: any, record: any) =>
              `${!Number(record?.igst) ? Number(text) + "%" : "N/A"}`,
          },
          {
            title: "Amount",
            dataIndex: "sgst",
            key: "sgst",
            width: 150,
            onCell: (record: any, index: number) => {
              if (record?.key == "lastRow") {
                return {
                  colSpan: 0,
                };
              }
              return {};
            },
            render: (text: any, record: any) => (
              <div style={{ textAlign: "right" }}>
                <span>
                  {!Number(record?.igst) ? formatCurrency(text, "INR") : "N/A"}
                </span>
              </div>
            ),
          },
        ],
      },
      {
        title: "IGST",
        hidden: taxConfiguration?.gstType != "IGST",
        children: [
          {
            title: "%",
            dataIndex: "igstPercentage",
            key: "igstPercentage",
            width: 100,
            onCell: (record: any, index: number) => {
              if (record?.key == "lastRow") {
                return {
                  colSpan: 0,
                };
              }
              return {};
            },
            render: (text: any, record: any) =>
              `${Number(record?.igst) ? Number(text) + "%" : "N/A"}`,
          },
          {
            title: "Amount",
            dataIndex: "igst",
            key: "igst",
            width: 150,
            onCell: (record: any, index: number) => {
              if (record?.key == "lastRow") {
                return {
                  colSpan: 0,
                };
              }
              return {};
            },
            render: (text: any, record: any) => (
              <div style={{ textAlign: "right" }}>
                <span>
                  {Number(record?.igst) ? formatCurrency(text, "INR") : "N/A"}
                </span>
              </div>
            ),
          },
        ],
      },
      {
        title: "Line Total",
        key: "lineTotal",
        width: 150,
        render: (text: any, record: any) => {
          return (
            <p className="text-right">
              {FormatCurrency(
                Number(record?.grossTotal),
                currency?.currency_code
              )}
            </p>
          );
        },
        onCell: (record: any, index: number) => {
          if (record?.key == "lastRow") {
            return {
              colSpan: 0,
            };
          }
          return {};
        },
      },
      {
        title: "Action",
        key: "operation",
        fixed: "right",
        width: 150,
        hidden: [
          "Rejected by Supplier",
          "Short Closed",
          "To be Dispatched",
          "To be Delivered",
          "Partially Delivered",
          "Fully Delivered",
        ].includes(poStatus),
        render: (text: any, record: any, index: any) =>
          [
            "Rejected by Supplier",
            "Short Closed",
            "To be Dispatched",
            "To be Delivered",
            "Partially Delivered",
            "Fully Delivered",
          ].includes(poStatus) ? (
            <>
              <Button
                size="sm"
                color=""
                onClick={() => {
                  setEditLineRow(record);
                }}
              >
                <Icon name="focus" />
              </Button>
            </>
          ) : ["Changes to Buyer"].includes(poStatus) ? (
            <Button
              size="sm"
              color=""
              onClick={() => {
                setChangeToBuyerData(record);
              }}
            >
              <Icon name="focus" />
            </Button>
          ) : (
            <Button
              size="sm"
              color=""
              onClick={() => {
                setEditLineRow(record);
              }}
            >
              <Icon name="edit" />
            </Button>
          ),
        onCell: (record: any, index: number) => {
          if (record?.key == "lastRow") {
            return {
              colSpan: 0,
            };
          }
          return {};
        },
      },
    ].filter(Boolean);
  };

  const ShowSupplierInfo = ({ id }: any) => {
    let supplier = OriginalData?.supplierDetails;
    if (!supplier) {
      return <></>;
    }
    return (
      <ul>
        <li>
          <strong>Name</strong> : {OriginalData?.supplierName}
        </li>
        <li>
          <strong>GSTIN</strong> : {supplier.gstin}
        </li>
        <li>
          <strong>PAN</strong> : {supplier.pan}
        </li>
        <li>
          <strong>CIN</strong> : {supplier.cin}
        </li>
      </ul>
    );
  };
  useEffect(() => {
    if (editLineRow) {
      setAddNewRowModel(true);
    }
  }, [editLineRow]);

  const ApprovalTimelineContent = ({ approvals }: { approvals?: any[] }) => {
    const approvalsData = approvals || materialData?.orderApprovals;

    if (!approvalsData || approvalsData?.length === 0) {
      return <Badge color="outline-danger">No</Badge>;
    }

    return (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <Popover
          content={
            <Timeline className="approval-timeline">
              {approvalsData?.map((approval: any, index: number) => {
                const isApproved = approval.status?.toLowerCase() == "approved";
                const isRejected = approval.status?.toLowerCase() == "rejected";
                return (
                  <Timeline.Item
                    key={index}
                    dot={
                      isApproved ? (
                        <CheckCircleOutlined style={{ color: "green" }} />
                      ) : isRejected ? (
                        <CloseCircleOutlined style={{ color: "red" }} />
                      ) : undefined
                    }
                  >
                    {approval?.userName}
                    <div className="designation">{approval?.roleName}</div>
                    {approval?.approvalDate && (
                      <div className="designation">
                        {dayjs(approval?.approvalDate).format("DD-MMM-YYYY")}
                      </div>
                    )}
                  </Timeline.Item>
                );
              })}
            </Timeline>
          }
          title={<span style={{ color: "#2263b3" }}>Approval Hierarchy</span>}
        >
          <div style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            cursor: "pointer"
          }}>
            <span
              style={{
                color: "#2263b3",
              }}
            >
              <Badge color="outline-success">Yes</Badge>
            </span>
            {isStrictMode && (
              <Badge
                color="warning"
                style={{
                  fontSize: "11px",
                  cursor: "pointer",
                  marginLeft: "4px"
                }}
                title="Sequential approvals required, Approvals must follow the sequence"
              >
                Strict
              </Badge>
            )}
          </div>
        </Popover>
      </div>
    );
  };

  const SubmitChanges = async () => {
    try {
      const _formData = new FormData();
      const updatedLineItems: any = [];
      const newLineItems: any = [];
      const deletedLineItems: any = [];

      const newfiledata: any = [];
      const deletedFileData: any = [...deletedAttachments];
      const updatedFileData: any = [];

      materialData?.lineItems?.forEach((data: any) => {
        if (!data?.lineNo) {
          // new item
          newLineItems.push({
            uuid: data.uuid,
            needByDate: dayjs(data?.needByDate).format("YYYY-MM-DD"),
            materialId: Number(data.materialId),
            hsnCode: data?.hsnCode ? Number(data.hsnCode) : null,
            categoryId: Number(data.categoryId),
            description: data.description,
            deliveryAddressId: Number(data.deliveryAddressId),
            quantity: Number(data.quantity),
            uomId: Number(data.uomId),
            unitPrice: Number(data.unitPrice),
            discountPercentage: 0,
            sgstPercentage: Number(data.sgstPercentage),
            cgstPercentage: Number(data.cgstPercentage),
            igstPercentage: Number(data.igstPercentage),
            additionalCharges: 0,
            segmentLevel: data?.segmentLevel || null,
            siteStructureUnitId: data?.siteStructureUnitId
              ? Number(data.siteStructureUnitId)
              : null,
            siteStructureSubUnitId: data?.siteStructureSubUnitId
              ? Number(data.siteStructureSubUnitId)
              : null,
            floorNo:
              data?.floorNo != null && data?.floorNo !== "null"
                ? data.floorNo
                : null,
            locationId: data?.locationId ? Number(data.locationId) : null,
            makeInfo: data?.makeInfo?.length > 0 ? data.makeInfo : [],
          });
          if (data?.file && data?.file[0]) {
            _formData.append("files", data?.file[0]);
            newfiledata.push({
              indexOfFileLocated: newfiledata.length,
              module: "po",
              purpose: "special instructions",
              level: "Line Level",
              uniqueId: data.uuid,
              action: "Create",
            });
          }
        } else {
          // check for update
          const OData = OriginalData?.lineItems?.find(
            (item: any) => item.lineNo == data.lineNo
          );

          let updatedItem: any = {};

          if (Number(OData.quantity) !== Number(data.quantity)) {
            updatedItem.quantity = Number(data.quantity);
          }

          if (Number(OData.unitPrice) !== Number(data.unitPrice)) {
            updatedItem.unitPrice = Number(data.unitPrice);
          }

          if (Number(OData.hsnCode) !== Number(data.hsnCode)) {
            updatedItem.hsnCode = data.hsnCode;
          }

          if (Number(OData.categoryId) !== Number(data.categoryId)) {
            updatedItem.categoryId = Number(data.categoryId);
          }

          if (OData.description !== data.description) {
            updatedItem.description = data.description;
          }

          if (Number(OData.uomId) !== Number(data.uomId)) {
            updatedItem.uomId = Number(data.uomId);
          }

          if (Number(OData.discountPercentage) !== 0) {
            updatedItem.discountPercentage = 0;
          }

          if (Number(OData.sgstPercentage) !== Number(data.sgstPercentage)) {
            updatedItem.sgstPercentage = Number(data.sgstPercentage);
          }

          if (Number(OData.cgstPercentage) !== Number(data.cgstPercentage)) {
            updatedItem.cgstPercentage = Number(data.cgstPercentage);
          }

          if (Number(OData.igstPercentage) !== Number(data.igstPercentage)) {
            updatedItem.igstPercentage = Number(data.igstPercentage);
          }

          if (Number(OData.additionalCharges) !== 0) {
            updatedItem.additionalCharges = 0;
          }

          const originalSegmentLevel =
            OData.segmentLevel &&
              OData.segmentLevel.toString().toLowerCase() !== "null"
              ? OData.segmentLevel
              : null;
          let currentSegmentLevel =
            data.segmentLevel &&
              data.segmentLevel.toString().toLowerCase() !== "null"
              ? data.segmentLevel
              : null;
          if (
            originalSegmentLevel == null &&
            currentSegmentLevel != null &&
            materialData?.segmentLevel &&
            materialData.segmentLevel.toString().toLowerCase() !== "null" &&
            currentSegmentLevel === materialData.segmentLevel
          ) {
            currentSegmentLevel = null;
          }
          if (originalSegmentLevel !== currentSegmentLevel) {
            updatedItem.segmentLevel = currentSegmentLevel;
          }
          const originalUnitId =
            OData.siteStructureUnitId != null
              ? Number(OData.siteStructureUnitId)
              : null;
          const currentUnitId =
            data.siteStructureUnitId != null
              ? Number(data.siteStructureUnitId)
              : null;
          if (originalUnitId !== currentUnitId) {
            updatedItem.siteStructureUnitId = currentUnitId;
          }
          const originalFloorNo =
            OData.floorNo != null && OData.floorNo !== "null"
              ? OData.floorNo
              : null;
          const currentFloorNo =
            data.floorNo != null && data.floorNo !== "null"
              ? data.floorNo
              : null;
          if (originalFloorNo !== currentFloorNo) {
            updatedItem.floorNo = currentFloorNo;
          }
          const originalSubUnitId =
            OData.siteStructureSubUnitId != null
              ? Number(OData.siteStructureSubUnitId)
              : null;
          const currentSubUnitId =
            data.siteStructureSubUnitId != null
              ? Number(data.siteStructureSubUnitId)
              : null;
          if (originalSubUnitId !== currentSubUnitId) {
            updatedItem.siteStructureSubUnitId = currentSubUnitId;
          }
          const originalLocationId =
            OData.locationId != null ? Number(OData.locationId) : null;
          const currentLocationId =
            data.locationId != null ? Number(data.locationId) : null;
          if (originalLocationId !== currentLocationId) {
            updatedItem.locationId = currentLocationId;
          }

          // Always include makeInfo if it exists on the current data
          if (data?.makeInfo?.length > 0) {
            updatedItem.makeInfo = data.makeInfo;
          }

          if (Object.keys(updatedItem).length > 0) {
            if (OriginalData?.needByDateType == "Line Level") {
              updatedItem.needByDate = dayjs(data.needByDate).format(
                "YYYY-MM-DD"
              );
            }
            if (OriginalData?.deliveryAddressType == "Line Level") {
              updatedItem.deliveryAddressId = Number(data.deliveryAddressId);
            }
            updatedItem.materialId = Number(data.materialId);
            updatedItem.lineNo = data.lineNo;
            updatedItem.uuid = OData.uuid;
            updatedLineItems.push(updatedItem);
          }

          if (data?.file && data?.file[0]) {
            if (OData?.file?.docId) {
              deletedFileData.push({
                docId: OData?.file?.docId,
              });
            }
            newfiledata.push({
              indexOfFileLocated: newfiledata.length,
              module: "po",
              purpose: "special instructions",
              level: "Line Level",
              uniqueId: OData.uuid,
              action: "Create",
            });
            console.log("newfiledata");

            _formData.append("files", data.file[0]);
          }
        }
      });

      newAttachments.forEach((attachment: any, index: number) => {
        if (!attachment) {
          return;
        }
        const file = attachment?.originFileObj;

        _formData.append("files", file);
        newfiledata.push({
          indexOfFileLocated: newfiledata.length,
          module: "po",
          purpose: "attachments",
          level: "Header Level",
          uniqueId: "",
          action: "Create",
        });
      });

      const includeSegmentLevel = Boolean(
        materialData?.workLevelSetting &&
        materialData.workLevelSetting !== "NONE"
      );
      const updatedLineNumbers = new Set(
        updatedLineItems
          .map((item: any) =>
            item?.lineNo != null ? Number(item.lineNo) : null
          )
          .filter((lineNo: any) => lineNo != null)
      );

      const existingLineItems: any = [];
      OriginalData?.lineItems?.forEach((item: any) => {
        if (item?.lineNo) {
          if (updatedLineNumbers.has(Number(item.lineNo))) {
            return;
          }
          const obj: any = {
            lineNo: item.lineNo,
            uuid: item.uuid,
            materialId: item.materialId,
          };
          if (OriginalData?.needByDateType == "Line Level") {
            obj.needByDate = item.needByDate;
          }
          if (OriginalData?.deliveryAddressType == "Line Level") {
            obj.deliveryAddressId = item.deliveryAddressId;
          }
          existingLineItems.push(obj);
        }
      });

      const submitData: any = {
        mode: ["Pending Approval", "Approved"].includes(
          OriginalData?.orderStatus
        )
          ? "U"
          : "UCR",
        needByDateType: OriginalData?.needByDateType,
        deliveryAddressType: OriginalData?.deliveryAddressType,
        combinedLineItems: {
          existingLineItems,
          updatedLineItems,
          newLineItems,
          deletedLineItems,
        },
      };
      submitData.segmentLevel =
        materialData?.segmentLevel && materialData.segmentLevel !== "null"
          ? materialData.segmentLevel
          : null;
      if (OriginalData?.needByDateType != "Line Level") {
        submitData.needByDate = OriginalData?.needByDate;
      }
      if (OriginalData?.deliveryAddressType != "Line Level") {
        submitData.deliveryAddressId = OriginalData?.deliveryAddressId;
      }

      const addIfDifferent = (
        key: string,
        dataValue: any,
        materialValue: any
      ) => {
        if (dataValue != materialValue) {
          submitData[key] = dataValue;
        }
      };

      const checkAndAdd = (key: string, dataValue: any, materialValue: any) => {
        // if (OriginalData.hasOwnProperty(key)) {
        addIfDifferent(key, dataValue, materialValue);
        // }
      };

      checkAndAdd(
        "supplierId",
        Number(materialData?.supplierId),
        Number(OriginalData?.supplierId)
      );
      checkAndAdd(
        "description",
        materialData?.description,
        OriginalData?.description
      );
      checkAndAdd(
        "costCenterId",
        materialData?.costCenterId ? Number(materialData?.costCenterId) : null,
        OriginalData?.costCenterId ? Number(OriginalData?.costCenterId) : null
      );
      checkAndAdd(
        "siteId",
        Number(materialData?.siteId),
        Number(OriginalData?.siteId)
      );
      checkAndAdd(
        "ledgerId",
        materialData?.ledgerId ? Number(materialData?.ledgerId) : null,
        OriginalData?.ledgerId ? Number(OriginalData?.ledgerId) : null
      );
      checkAndAdd(
        "departmentId",
        Number(materialData?.departmentId),
        Number(OriginalData?.departmentId)
      );
      checkAndAdd(
        "budgetId",
        Number(materialData?.budgetId),
        Number(OriginalData?.budgetId)
      );
      checkAndAdd(
        "contractorId",
        materialData?.contractorId ? Number(materialData?.contractorId) : null,
        OriginalData?.contractorId ? Number(OriginalData?.contractorId) : null
      );
      if (
        materialData?.paymentTerms != OriginalData?.paymentTerms ||
        materialData?.advancePercentage != OriginalData?.advancePercentage ||
        materialData?.creditDays != OriginalData?.creditDays ||
        materialData?.paymentMode !=
        OriginalData?.advancePaymentDetails?.mode ||
        materialData?.transactionNumber !=
        OriginalData?.advancePaymentDetails?.transactionNumber ||
        materialData?.bankName !=
        OriginalData?.advancePaymentDetails?.bankName ||
        (materialData?.paymentDate &&
          OriginalData?.advancePaymentDetails?.paymentDate &&
          dayjs(materialData.paymentDate).format("YYYY-MM-DD") !=
          OriginalData?.advancePaymentDetails?.paymentDate) ||
        materialData?.paymentRemarks !=
        OriginalData?.advancePaymentDetails?.remarks
      ) {
        if (materialData?.paymentTerms == "Cash and Carry") {
          submitData["paymentTerms"] = materialData?.paymentTerms;
        } else if (materialData?.paymentTerms == "Credit") {
          submitData["paymentTerms"] = materialData?.paymentTerms;
          submitData["creditDays"] = Number(materialData?.creditDays);
        } else if (materialData?.paymentTerms == "Advance") {
          submitData["paymentTerms"] = materialData?.paymentTerms;
          submitData["advancePercentage"] = Number(
            materialData?.advancePercentage
          );
          submitData["creditDays"] = Number(materialData?.creditDays);

          // Include advance payment details
          submitData["advancePaymentDetails"] = {
            mode: materialData?.paymentMode
              ? String(materialData.paymentMode)
              : "",
            transactionNumber: materialData?.transactionNumber
              ? String(materialData.transactionNumber)
              : "",
            bankName: materialData?.bankName
              ? String(materialData.bankName)
              : "",
            paymentDate: materialData?.paymentDate
              ? dayjs(materialData.paymentDate).format("YYYY-MM-DD")
              : "",
            remarks: materialData?.paymentRemarks
              ? String(materialData.paymentRemarks)
              : "",
          };
        }
      }
      checkAndAdd(
        "inwardRequired",
        materialData?.inwardRequired,
        OriginalData?.inwardRequired
      );
      if (
        dayjs(OriginalData?.needByDate).format("YYYY-MM-DD") !==
        dayjs(materialData?.needByDate).format("YYYY-MM-DD")
      ) {
        submitData.needByDate = dayjs(materialData?.needByDate).format(
          "YYYY-MM-DD"
        );
      }
      checkAndAdd(
        "needByDateType",
        materialData?.needByDateType,
        OriginalData?.needByDateType
      );
      if (OriginalData?.needByDateType == "order Level") {
        checkAndAdd(
          "needByDate",
          materialData?.needByDate,
          OriginalData?.needByDate
        );
      }
      checkAndAdd(
        "billingAddressId",
        Number(materialData?.billingAddressId),
        Number(OriginalData?.billingAddressId)
      );
      checkAndAdd(
        "deliveryAddressType",
        materialData?.deliveryAddressType,
        OriginalData?.deliveryAddressType
      );
      checkAndAdd(
        "segmentLevel",
        materialData?.segmentLevel ?? null,
        OriginalData?.segmentLevel ?? null
      );

      if (isInstructionsChanged) {
        const instructionsFile = new Blob([newInstructions], {
          type: "text/html",
        });
        _formData.append(
          `files`,
          new File([instructionsFile], "instructions.html", {
            type: "text/html",
          })
        );
        newfiledata.push({
          indexOfFileLocated: newfiledata.length,
          module: "po",
          purpose: "instructions",
          level: "Header Level",
          uniqueId: nanoid(4),
          action: "Create",
        });
        setIsInstructionsChanged(false);
        const _instructions = DMS?.filter(
          (item: any) => item.moduleFileType == "instructions"
        );
        if (_instructions?.length > 0) {
          _instructions.map((oldFile: any) => {
            deletedFileData.push({
              docId: oldFile.docId,
            });
          });
        }
      }
      if (isTermsAndConditionsChanged) {
        const termsAndConditionsFile = new Blob([newTermsAndConditions], {
          type: "text/html",
        });
        _formData.append(
          `files`,
          new File([termsAndConditionsFile], "termsAndConditions.html", {
            type: "text/html",
          })
        );
        newfiledata.push({
          indexOfFileLocated: newfiledata.length,
          module: "po",
          purpose: "termsAndConditions",
          level: "Header Level",
          uniqueId: nanoid(4),
          action: "Create",
        });
        setIsTermsAndConditionsChanged(false);
        const _termsAndConditions = DMS?.filter(
          (item: any) => item.moduleFileType == "termsAndConditions"
        );
        if (_termsAndConditions?.length > 0) {
          _termsAndConditions.map((oldFile: any) => {
            deletedFileData.push({
              docId: oldFile.docId,
            });
          });
        }
      }

      const filesData = {
        newfiledata,
        deletedFileData,
        updatedFileData,
      };

      _formData.append("filesData", JSON.stringify(filesData));

      _formData.append("files", JSON.stringify([]));
      _formData.append("orderData", JSON.stringify(submitData));
      console.log("submitData", submitData);
      const res = await purchaseOrderApis.purchaseOrderUpdate(
        orderNumber,
        _formData
      );
      const { status, message, data: responseData } = res || {};
      const successMessage =
        (typeof responseData === "string" && responseData) ||
        message ||
        "Updated successfully";
      if (status) {
        fetchOrderDetails();
        Swal.fire("Updated!", successMessage, "success");
        navigate(previousPath, {
          state: { previousState: extra?.previousState },
        });
      } else {
        const errorMessage =
          (typeof responseData === "string" && responseData) ||
          message ||
          "Error";
        Swal.fire("Error!", errorMessage, "error");
      }
    } catch (error) {
      console.log(error);
    }
    setDisableSubmit(false);
  };

  const ApprovePo = async (files: File[] = []) => {
    try {
      const _formData = new FormData();
      // Append files if any
      if (files.length > 0) {
        files.forEach((file) => {
          _formData.append("files", file);
        });
      }
      _formData.append("filesData", JSON.stringify([]));
      _formData.append("files", JSON.stringify([]));
      // Pass files array instead of _formData
      const res = await purchaseOrderApis.approvePo(orderNumber, files); // <-- CHANGE HERE
      const { status, message } = res;
      if (status) {
        // //refresh();
        fetchOrderDetails();
        Swal.fire("Approved!", message, "success");
        navigate(previousPath, {
          state: { previousState: extra?.previousState },
        });
      } else {
        Swal.fire("Error!", message, "error");
      }
    } catch (error) {
      console.log(error);
    }
    setDisableApprove(false);
  };

  const disapprovePo = async (rejectedReason: string, files: File[] = []) => {
    try {
      // Remove the FormData creation and directly pass parameters
      const res = await purchaseOrderApis.disapprovePo(
        orderNumber,
        rejectedReason, // <-- Add rejectedReason parameter
        files           // <-- Pass files array
      );
      const { status, message } = res;
      if (status) {
        //refresh();
        fetchOrderDetails();
        Swal.fire("Disapproved!", message, "success");
        navigate(previousPath, {
          state: { previousState: extra?.previousState },
        });
      } else {
        Swal.fire("Error!", message, "error");
      }
    } catch (error) {
      console.log(error);
    }
    setDisableReject(false);
  };

  const rejectCR = async (reason: string) => {
    try {
      const res = await purchaseOrderApis.rejectChangeRequestOrder(
        orderNumber,
        reason
      );
      const { status, message } = res;
      if (status) {
        fetchOrderDetails();
        Swal.fire("Rejected!", message, "success");
        navigate(previousPath, {
          state: { previousState: extra?.previousState },
        });
      } else {
        Swal.fire("Error!", message, "error");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const AcceptCR = async () => {
    try {
      const res = await purchaseOrderApis.acceptChangeRequestOrder(orderNumber);
      const { status, message } = res;
      if (status) {
        fetchOrderDetails();
        Swal.fire("Accepted!", message, "success");
        navigate(previousPath, {
          state: { previousState: extra?.previousState },
        });
      } else {
        Swal.fire("Error!", message, "error");
      }
    } catch (error) {
      console.log(error);
    }
    setDisableAccept(false);
  };

  const handleGrnRequiredChange = (value: any) => {
    setGrnRequired(value);
  };

  const closeTransferPoDrawer = () => {
    resetDrawer();
    setTransferPoDrawerVisible(false);
    setShowMoreTransportFields(false);
    setInvoiceAttachments([]);
    setInvoiceSignature({});
    setGrnRequired(null);
    setInvoiceDate(null);
  };

  const handleShortClose = async () => {
    try {
      Swal.fire({
        title: "Are you sure?",
        text: "You are about to short close this order!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Short Close!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const res = await purchaseOrderApis.shortCloseOrder(orderNumber);
          const { status, message } = res;
          if (status) {
            Swal.fire("Short Closed!", message || "Order has been short closed successfully.", "success");
            fetchOrderDetails();
            const dropdown = document.querySelector(".dropdown-menu.show");
            if (dropdown) {
              dropdown.classList.remove("show");
            }
          } else {
            Swal.fire("Error!", message || "Failed to short close order.", "error");
          }
        }
      });
    } catch (error) {
      console.log(error);
      Swal.fire("Error!", "Failed to short close order.", "error");
    }
  };

  const handleInvoiceAttachmentChange = (info: { fileList: UploadFile[] }) => {
    // Limit to 3 files and update state
    let files = info.fileList.slice(-3);
    setInvoiceAttachments(files);
  };

  // Custom beforeUpload for transfer PO drawer to prevent auto-upload
  const beforeUploadTransferPO = (file: UploadFile) => {
    const isAllowedType = Object.values(AllowedFileTypes)
      .filter((value) => typeof value === "string")
      .includes(file.type as AllowedFileTypes);
    
    if (!isAllowedType) {
      message.error("Invalid file type!");
      return Upload.LIST_IGNORE;
    }
    
    // Check file size - 5MB limit
    if (file.size && file.size / 1024 / 1024 > 5) {
      message.error("File must be smaller than 5MB!");
      return Upload.LIST_IGNORE;
    }
    
    // Return false to prevent auto-upload (we'll handle upload on form submit)
    return false;
  };

  const ViewTableTotals = ({ data, additionalCharges, invoice }: any) => {
    let totalNetAmmount = 0,
      cgst = 0,
      sgst = 0,
      igst = 0,
      TotalAmount = 0;
    data?.forEach((item: any) => {
      const totalAmmount = Number(item.unitPrice) * Number(item.quantity);
      cgst = cgst + (totalAmmount * Number(item.cgstPercentage)) / 100;
      sgst = sgst + (totalAmmount * Number(item.sgstPercentage)) / 100;
      igst = igst + (totalAmmount * Number(item.igstPercentage)) / 100;
      totalNetAmmount = totalNetAmmount + totalAmmount;
    });
    TotalAmount = totalNetAmmount + cgst + sgst + igst;
    additionalCharges?.forEach((item: any) => {
      TotalAmount = TotalAmount + Number(item.price);
    });
    return (
      <Row
        className={`${invoice && "w-50 mt-2"}`}
        style={{
          margin: "20px",
        }}
      >
        <Col className={`justify-end`}>
          <div className={`${invoice ? "w-100" : "w-40"}`}>
            <div className="d-flex justify-content-between">
              <div className="w-50 justify-end">
                <strong>Taxable Amount</strong>
              </div>
              <span className="r_align">
                {FormatCurrency(totalNetAmmount, currency?.currency_code)}
              </span>
            </div>
            {cgst && sgst ? (
              <>
                <div className="d-flex justify-content-between">
                  <div className="w-50 justify-end">
                    <strong>CGST</strong>
                  </div>
                  <span className="r_align">
                    {FormatCurrency(cgst, currency?.currency_code)}
                  </span>
                </div>
                <div className="d-flex justify-content-between">
                  <div className="w-50 justify-end">
                    <strong>SGST</strong>
                  </div>
                  <span className="r_align">
                    {FormatCurrency(sgst, currency?.currency_code)}
                  </span>
                </div>
              </>
            ) : (
              <div className="d-flex justify-content-between">
                <div className="w-50 justify-end">
                  <strong>IGST</strong>
                </div>
                <span className="r_align">
                  {FormatCurrency(igst, currency?.currency_code)}
                </span>
              </div>
            )}

            <div
              className="d-flex justify-content-between"
              style={{ fontSize: "18px", marginTop: "10px" }}
            >
              <div className="w-50 justify-end">
                <strong>Total</strong>
              </div>
              <strong className="r_align">
                {FormatCurrency(TotalAmount, currency?.currency_code)}
              </strong>
            </div>
          </div>
        </Col>
      </Row>
    );
  };

  const ShowBillingAddress = ({ address }: any) => {
    if (!address) return <></>;
    const {
      deliveryLocationName,
      addressLine1,
      addressLine2,
      city,
      pincode,
      state,
      district,
      countryInfo,
    } = address;
    return (
      <ul>
        <li>
          <strong style={{ color: "#2263b3" }}>{deliveryLocationName}</strong>
        </li>
        <li>
          {[addressLine1, addressLine2, city, district?.districtName]
            .filter(Boolean)
            .join(", ")}
        </li>
        <li>
          {[state?.stateName, countryInfo?.countryName, pincode]
            .filter(Boolean)
            .join(", ")}
        </li>
      </ul>
    );
  };

  const ShowDeliveryAddress = ({ address }: any) => {
    if (!address) return <></>;
    const {
      deliveryLocationName,
      addressLine1,
      addressLine2,
      city,
      pincode,
      state,
      district,
      countryInfo,
    } = address;
    return (
      <ul>
        <li>
          <strong style={{ color: "#2263b3" }}>{deliveryLocationName}</strong>
        </li>
        <li>
          {[addressLine1, addressLine2, city, district?.districtName]
            .filter(Boolean)
            .join(", ")}
        </li>
        <li>
          {[state?.stateName, countryInfo?.countryName, pincode]
            .filter(Boolean)
            .join(", ")}
        </li>
      </ul>
    );
  };

  const ShowApprovals = ({ approvals }: any) => {
    if (!approvals || approvals?.length === 0) return <></>;
    return (
      <Timeline className="approval-timeline">
        {approvals?.map((approval: any, index: number) => {
          const isApproved = approval.status == "Approved";
          const isRejected = approval.status == "Rejected";
          return (
            <Timeline.Item
              key={index}
              dot={
                isApproved ? (
                  <CheckCircleOutlined style={{ color: "green" }} />
                ) : isRejected ? (
                  <CloseCircleOutlined style={{ color: "red" }} />
                ) : undefined
              }
            >
              {approval?.userName}
              <div className="designation">{approval?.roleName}</div>
              {approval?.approvalDate && (
                <div className="designation">
                  {dayjs(approval?.approvalDate).format("DD-MMM-YYYY")}
                </div>
              )}
            </Timeline.Item>
          );
        })}
      </Timeline>
    );
  };

  const returnBillingDetails = () => {
    const id = materialData?.billingAddressId;
    if (!id) {
      return {};
    }
    let address = deliveryAddressList?.find((item: any) => item?.id == id);
    if (!address) {
      return {};
    }
    return {
      name: currentUser?.orgName || "",
      addressLine1: address.addressLine1,
      addressLine2: address.addressLine2,
      city: address.city,
      state: address.stateName,
      pincode: address.pincode,
      country: address.countryName,
      gstin: OriginalData?.orgDetails?.gstin || "N/A",
      pan: currentUser?.pan || "",
      cin: currentUser?.cin || "",
    };
  };

  const returnSupplierDetails = () => {
    let seller = OriginalData?.supplierDetails;
    if (!seller) {
      return {};
    }
    const {
      city,
      stateInfo,
      countryInfo,
      pincode,
      addressline1,
      addressline2,
    } = seller?.address || {};
    return {
      name: OriginalData?.supplierName || "",
      addressLine1: addressline1 || "",
      addressLine2: addressline2 || "",
      city: city || "",
      state: stateInfo?.stateName || "",
      pincode: pincode || "",
      country: countryInfo?.countryName || "",
      gstin: seller?.gstin || "",
      pan: seller?.pan || "",
      cin: seller?.cin || "",
    };
  };

  const returnPoDetails = () => {
    const id = materialData?.deliveryAddressId;
    let address: any = {};
    if (!id) {
      address = {};
    }
    address = deliveryAddressList?.find((item: any) => item?.id == id);
    return {
      poNumber: OriginalData?.orderId,
      poDate: dayjs(OriginalData?.orderDate).format("DD-MMM-YYYY"),
      terms:
        materialData?.paymentTerms +
        (materialData?.advancePercentage
          ? `(${materialData?.advancePercentage}%)`
          : ""),
      expectedShipmentDate:
        materialData?.needByDateType == "Order Level"
          ? dayjs(materialData?.needByDate).format("DD-MMM-YYYY")
          : "Line Level Date",
      placeofSupply: address?.city || "--",
      contactPersonName: address?.contactPersonName,
      mobileNumber: address?.mobileNumber,
      creditDays:
        materialData?.paymentTerms != "Cash and Carry"
          ? materialData?.creditDays
          : 0,
      deliveryAddressString:
        [
          address?.addressLine1,
          address?.addressLine2,
          address?.city,
          address?.stateName,
          address?.pincode?.toString(),
          address?.countryName,
        ]
          ?.filter(Boolean)
          ?.join(", ") || "--",
      totals: {
        taxableAmount: formatDecimal(
          materialData?.lineItems?.reduce(
            (a: any, b: any) => a + Number(b.quantity) * Number(b.unitPrice),
            0
          )
        ),
        cgst: formatDecimal(
          materialData?.lineItems?.reduce(
            (a: any, b: any) => a + Number(b.cgst),
            0
          )
        ),
        sgst: formatDecimal(
          materialData?.lineItems?.reduce(
            (a: any, b: any) => a + Number(b.sgst),
            0
          )
        ),
        igst: formatDecimal(
          materialData?.lineItems?.reduce(
            (a: any, b: any) => a + Number(b.igst),
            0
          )
        ),
        total: formatDecimal(
          materialData?.lineItems?.reduce(
            (a: any, b: any) => a + Number(b.grossTotal),
            0
          )
        ),
      },
      lines: materialData?.lineItems?.map((item: any, index: any) => {
        let itemDescription = item?.materialName;
        if (item?.description) {
          itemDescription += "\t" + item?.description;
        }
        if (materialData?.deliveryAddressType === "Line Level") {
          let _address = deliveryAddressList?.find(
            (_item: any) => _item?.id == item?.deliveryAddressId
          );
          if (_address) {
            const addressString = [
              _address.addressLine1,
              _address.addressLine2,
              _address.city,
              _address.stateName,
              _address.pincode?.toString(),
              _address.countryName,
            ]
              .filter(Boolean)
              .join(", ");
            itemDescription += "\n\nDelivery Address: " + addressString;
          }
        }
        if (materialData?.needByDateType != "Order Level") {
          itemDescription +=
            "\n\nNeed By Date: " +
            dayjs(item?.needByDate).format("DD-MMM-YYYY");
        }
        return {
          sno: index + 1,
          itemDescription,
          hsnSac: item?.hsnCode || "",
          rate: formatDecimal(item?.unitPrice),
          cgstPercentage: Number(item?.cgstPercentage),
          cgstAmount: formatDecimal(Number(item?.cgst)),
          sgstPercentage: Number(item?.sgstPercentage),
          sgstAmount: formatDecimal(Number(item?.sgst)),
          igstPercentage: Number(item?.igstPercentage),
          igstAmount: formatDecimal(Number(item?.igst)),
          taxableAmount: formatDecimal(Number(item?.grossTotal)),
          qty: Number(item?.quantity),
          uom: item?.uomLabel,
        };
      }),
    };
  };

  const rejectedData = OriginalData?.orderApprovals?.find(
    (item: any) => item?.status == "Rejected"
  );

  // Helper function to convert data URL to File
  const dataURLToFile = (dataUrl: string, fileName: string): File => {
    const arr = dataUrl.split(",");
    const mimeMatch = arr[0].match(/:(.*?);/);
    const mime = mimeMatch ? mimeMatch[1] : "image/png";
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], fileName, { type: mime });
  };

  // Open approve modal
  const openApproveModal = () => {
    setActiveSignatureContext("APPROVE");
    setApproveSignature({ isActive: false, label: "Authorised Signatory", image: null });
    setIsModalApproveVisible(true);
  };

  // Open reject modal
  const openRejectModal = () => {
    setActiveSignatureContext("REJECT");
    setRejectSignature({ isActive: false, label: "Authorised Signatory", image: null });
    rejectForm.resetFields();
    setIsModalRejectedVisible(true);
  };

  // Handle approve with signature
  const handleApproveWithSignature = () => {
    if (!approveSignature.image) {
      Swal.fire({
        icon: "info",
        title: "Signature Required",
        text: "Please add your signature before approving.",
      });
      setDisableApprove(false);
      return;
    }

    setIsModalApproveVisible(false);

    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Approve it!",
      cancelButtonText: "No, keep it",
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        const file = dataURLToFile(approveSignature.image as string, "signature.png");
        await ApprovePo([file]);
      } else {
        setIsModalApproveVisible(true);
        setDisableApprove(false);
      }
    });
  };

  // Handle reject with signature
  const handleRejectWithSignature = (reason: string) => {
    if (!rejectSignature.image) {
      Swal.fire({
        icon: "info",
        title: "Signature Required",
        text: "Please add your signature before rejecting.",
      });
      setDisableReject(false);
      return;
    }

    setIsModalRejectedVisible(false);

    Swal.fire({
      title: "Confirm Rejection?",
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Reject it!",
      cancelButtonText: "Cancel",
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        const file = dataURLToFile(rejectSignature.image as string, "signature.png");
        await disapprovePo(reason, [file]);
        rejectForm.resetFields();
        setRejectSignature({ isActive: false, label: "Authorised Signatory", image: null });
      } else {
        setIsModalRejectedVisible(true);
        setDisableReject(false);
      }
    });
  };

  return (
    <>
      <Head title="Purchase Order - Track" />
      <Modal
        isOpen={generalInformationEdit}
        toggle={() => setGeneralInformationEdit(false)}
        className="modal-dialog-centered"
        size="xl"
        backdrop="static"
      >
        <a
          href="#cancel"
          onClick={(ev) => {
            ev.preventDefault();
            setGeneralInformationEdit(false);
          }}
          className="close"
        >
          <Icon name="cross-sm"></Icon>
        </a>

        <ModalBody>
          {tab === "1" && (
            <>
              <h5 className="title">Update General Information</h5>
              <div style={{ marginTop: "15px" }}></div>

              <FormProvider {...methods}>
                <form
                  className="content clearfix"
                  onSubmit={handleSubmit((data) => {
                    setMaterialData((pre: any) => {
                      const obj: any = {};

                      obj.siteName = sitesOptions.find(
                        (item) => item.value == data?.siteId
                      )?.label;

                      obj.orgName = supplierOptions.find(
                        (item) => item.value == data?.supplierId
                      )?.label;

                      obj.budgetName = budgetOptions.find(
                        (item) => item.value == data?.budgetId
                      )?.label;

                      obj.contractorName = contractorOptions.find(
                        (item) => item.value == data?.contractId
                      )?.label;

                      obj.costCenterName = costCenterOptions.find(
                        (item) => item.value == data?.costCenterId
                      )?.label;

                      obj.ledgerName = generalLedgerOptions.find(
                        (item) => item.value == data?.ledgerId
                      )?.label;

                      obj.departmentName = departmentOptions.find(
                        (item) => item.value == data?.departmentId
                      )?.label;

                      return {
                        ...pre,
                        ...data,
                        ...obj,
                      };
                    });
                    setGeneralInformationEdit(false);
                    setAddNewRowModel(false);
                    setEditLineRow(null);
                    console.log(data);
                    setShowSubmitBtm(true);
                  })}
                >
                  <Row className="gy-4">
                    <Col lg="4">
                      <FormSelect
                        name="supplierId"
                        label={`Supplier/Vendor`}
                        options={supplierOptions}
                        required={true}
                        placeholder="-Select-"
                        disabled={true}
                        tooltipText="Select the supplier or vendor for the purchase order."
                      />
                    </Col>
                    <Col lg="8">
                      <FormInput
                        name="description"
                        label="PO Description"
                        required={true}
                        type="text"
                        minLength={2}
                        maxLength={500}
                        placeholder="Enter Description"
                        tooltipText="Enter a brief description of the purchase order."
                      />
                    </Col>
                  </Row>
                  <Row className="gy-4 mt-1">
                    <Col lg="4" style={{ display: "none" }}>
                      <FormSelect
                        name="costCenterId"
                        label={`Cost Center`}
                        options={costCenterOptions}
                        placeholder="-Select-"
                        tooltipText="Select the cost center associated with this purchase order."
                      />
                    </Col>
                    <Col lg="4">
                      <FormSelect
                        name="siteId"
                        label={`Site`}
                        options={sitesOptions}
                        required={true}
                        placeholder="-Select-"
                        disabled={true}
                        tooltipText="Select the site where the materials will be used."
                      />
                    </Col>
                    <Col lg="4">
                      <FormSelect
                        name="ledgerId"
                        label={`General Ledger`}
                        options={generalLedgerOptions}
                        placeholder="-Select-"
                        tooltipText="Select the general ledger account for financial tracking."
                      />
                    </Col>
                    <Col lg="4">
                      <FormSelect
                        name="departmentId"
                        label={`Department`}
                        options={departmentOptions}
                        required={true}
                        placeholder="-Select-"
                        tooltipText="Select the department responsible for the purchase order."
                      />
                    </Col>
                  </Row>
                  <Row className="gy-4 mt-1">
                    <Col lg="4">
                      <FormSelect
                        name="budgetId"
                        label={`Budget`}
                        options={budgetOptions}
                        required={true}
                        placeholder="-Select-"
                        tooltipText="Select the budget for this purchase order."
                      />
                    </Col>
                    <Col lg="4">
                      <FormSelect
                        name="contractorId"
                        label={`Contractor`}
                        required={true}
                        options={contractorOptions}
                        placeholder="-Select-"
                        tooltipText="Select the contractor for this purchase order."
                      />
                    </Col>
                    <Col lg="4">
                      <FormSelect
                        name="paymentTerms"
                        label="Payment Terms"
                        options={[
                          {
                            label: "Cash & Carry",
                            value: "Cash and Carry",
                          },
                          { label: "Advance", value: "Advance" },
                          { label: "Credit", value: "Credit" },
                        ]}
                        required={true}
                        placeholder="Select Payment Terms"
                        tooltipText="Select the payment terms for the purchase order."
                      />
                    </Col>
                    {watch("paymentTerms") === "Advance" && (
                      <>
                        <Col lg="4">
                          <FormInput
                            name="advancePercentage"
                            label="Advance Percentage"
                            required={true}
                            isPercentage={true}
                            placeholder="Enter Advance Percentage"
                            tooltipText="Enter the advance percentage for the purchase order."
                          />
                        </Col>
                        {watch("advancePercentage") < 100 && (
                          <Col lg="4">
                            <FormInput
                              name="creditDays"
                              label="Credit Days"
                              required={true}
                              type="number"
                              placeholder="Enter Credit Days"
                              tooltipText="Enter the credit days for the purchase order."
                              pattern={/^[1-9][0-9]*$/}
                            />
                          </Col>
                        )}
                        <Col lg="4">
                          <FormDatePicker
                            name="paymentDate"
                            label="Payment Date"
                            required={true}
                            maxDate={new Date()}
                            placeholder="Select Payment Date"
                          />
                        </Col>
                        <Col lg="4">
                          <FormSelect
                            name="paymentMode"
                            label="Payment Mode"
                            options={[
                              {
                                label:
                                  "National Electronic Fund Transfer (NEFT)",
                                value: "neft",
                              },
                              {
                                label: "Real Time Gross Settlement (RTGS)",
                                value: "rtgs",
                              },
                              {
                                label: "Immediate Payment Service (IMPS)",
                                value: "imps",
                              },
                              { label: "CHEQUE", value: "cheque" },
                              { label: "UPI", value: "upi" },
                              { label: "CASH", value: "cash" },
                            ]}
                            required={true}
                            placeholder="Select Payment Mode"
                            tooltipText="Select the payment mode for the advance payment."
                          />
                        </Col>
                        {watch("paymentMode") && (
                          <>
                            {["neft", "rtgs", "imps"].includes(
                              watch("paymentMode")
                            ) && (
                                <Col lg="4">
                                  <FormInput
                                    name="transactionNumber"
                                    label="UTR"
                                    required={true}
                                    type="text"
                                    placeholder="Enter UTR"
                                    tooltipText="Enter the UTR number for the transaction."
                                    pattern={/^[a-zA-Z0-9/-]*$/}
                                    patternErrorMessage="Only alphanumeric characters, hyphens, and slashes are allowed"
                                    onInput={(
                                      event: React.FormEvent<HTMLInputElement>
                                    ) => {
                                      const target = event.currentTarget;
                                      target.value = target.value.replace(
                                        /[^a-zA-Z0-9/-]/g,
                                        ""
                                      );
                                    }}
                                  />
                                </Col>
                              )}
                            {["upi"].includes(watch("paymentMode")) && (
                              <Col lg="4">
                                <FormInput
                                  name="transactionNumber"
                                  label="Transaction ID"
                                  required={true}
                                  type="text"
                                  placeholder="Enter Transaction ID"
                                  tooltipText="Enter the transaction ID for the UPI payment."
                                  pattern={/^[a-zA-Z0-9/-]*$/}
                                  patternErrorMessage="Only alphanumeric characters, hyphens, and slashes are allowed"
                                  onInput={(
                                    event: React.FormEvent<HTMLInputElement>
                                  ) => {
                                    const target = event.currentTarget;
                                    target.value = target.value.replace(
                                      /[^a-zA-Z0-9/-]/g,
                                      ""
                                    );
                                  }}
                                />
                              </Col>
                            )}
                            {["cheque"].includes(watch("paymentMode")) && (
                              <Col lg="4">
                                <FormInput
                                  name="transactionNumber"
                                  label="Cheque #"
                                  required={true}
                                  type="number"
                                  placeholder="Enter Cheque Number"
                                  tooltipText="Enter the cheque number."
                                  pattern={/^[0-9]*$/}
                                  patternErrorMessage="Only numbers are allowed"
                                  onInput={(
                                    event: React.FormEvent<HTMLInputElement>
                                  ) => {
                                    const target = event.currentTarget;
                                    target.value = target.value.replace(
                                      /[^0-9]/g,
                                      ""
                                    );
                                  }}
                                />
                              </Col>
                            )}
                          </>
                        )}
                        <Col lg="4">
                          <FormInput
                            name="bankName"
                            label="Bank Name"
                            required={true}
                            type="text"
                            placeholder="Enter Bank Name"
                            tooltipText="Enter the bank name for the payment."
                          />
                        </Col>
                        <Col lg="4">
                          <FormInput
                            name="paymentRemarks"
                            label="Remarks"
                            required={true}
                            type="textarea"
                            rows={2}
                            placeholder="Enter Remark"
                            tooltipText="Enter remarks for the payment."
                          />
                        </Col>
                      </>
                    )}
                    {watch("paymentTerms") === "Credit" && (
                      <Col lg="4">
                        <FormInput
                          name="creditDays"
                          label="Credit Days"
                          required={true}
                          type="number"
                          placeholder="Enter Credit Days"
                          tooltipText="Enter the credit days for the purchase order."
                          pattern={/^[1-9][0-9]*$/}
                        />
                      </Col>
                    )}
                  </Row>
                  <Row className="mt-4">
                    <Col lg="12">
                      <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                        <li>
                          <Button
                            className="btn btn-primary btn-md"
                            type="submit"
                            color="primary"
                          >
                            Save
                          </Button>
                        </li>
                        <li>
                          <a
                            href="#cancel"
                            onClick={(ev) => {
                              ev.preventDefault();
                              setGeneralInformationEdit(false);
                              reset();
                            }}
                            className="link link-light"
                          >
                            Cancel
                          </a>
                        </li>
                      </ul>
                    </Col>
                  </Row>
                </form>
              </FormProvider>
            </>
          )}
          {tab == "2" && (
            <>
              <h5 className="title"> Update Delivery Info</h5>
              <div style={{ marginTop: "15px" }}></div>
              <FormProvider {...methods}>
                <form
                  onSubmit={handleSubmit((data) => {
                    setMaterialData((pre: any) => {
                      return {
                        ...pre,
                        ...data,
                      };
                    });
                    setGeneralInformationEdit(false);
                    setAddNewRowModel(false);
                    setEditLineRow(null);
                    console.log(data);
                    setShowSubmitBtm(true);
                  })}
                >
                  <Row className="gy-4 mt-1">
                    <Col lg="4">
                      <FormSelect
                        name="inwardRequired"
                        label="Inward Required ?"
                        options={[
                          { label: "Yes", value: true },
                          { label: "No", value: false },
                        ]}
                        placeholder="-Select-"
                        tooltipText=" If GRN (Inward Process) is required for the line items then you can select 'Yes' otherwise select 'No'."
                        disabled={!["Pending Approval", "Rejected"].includes(poStatus)}
                      />
                    </Col>
                    <Col lg="4">
                      <FormSelect
                        name="needByDateType"
                        disabled
                        label="Line Level Delivery ?"
                        options={[
                          { label: "Yes", value: "Line Level" },
                          { label: "No", value: "Order Level" },
                        ]}
                        placeholder="-Select-"
                        tooltipText="delivery date will be based on the line level. If you select 'No' then delivery date will be based on the Order Level."
                      />
                    </Col>
                    {watch("needByDateType") == "Order Level" && (
                      <Col lg="4">
                        <FormDatePicker
                          name="needByDate"
                          label="Delivery Date"
                          required={true}
                          minDate={new Date()}
                        />
                      </Col>
                    )}
                    <Col lg="4">
                      <FormSelect
                        name="billingAddressId"
                        label={`Billing Address`}
                        options={deliveryAddressOptions}
                        disabled={!["Pending Approval", "Rejected"].includes(poStatus)}
                        placeholder="-Select-"
                        tooltipText="Select the billing address for the purchase order."
                      />
                    </Col>
                    <Col lg="4">
                      <FormSelect
                        name="deliveryAddressType"
                        label={`Delivery Address`}
                        disabled
                        options={[
                          { label: "Order Level", value: "Order Level" },
                          { label: "Line Level", value: "Line Level" },
                        ]}
                        placeholder="-Select-"
                        tooltipText="Select the delivery address type for the purchase order."
                      />
                    </Col>
                    {watch("deliveryAddressType") === "Order Level" && (
                      <Col lg="4">
                        <FormSelect
                          name="deliveryAddressId"
                          label="Delivery Address"
                          options={deliveryAddressOptions}
                          required={true}
                          placeholder="-Select-"
                          tooltipText="Select the delivery address for the purchase order."
                          dropdownRender={(menu) => <>{menu}</>}
                          disabled={!["Pending Approval", "Rejected"].includes(poStatus)}
                        />
                      </Col>
                    )}
                  </Row>
                  <Row className="mt-4">
                    <Col lg="12">
                      <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                        <li>
                          <Button
                            className="btn btn-primary btn-md"
                            type="submit"
                            color="primary"
                          >
                            Save
                          </Button>
                        </li>
                        <li>
                          <a
                            href="#cancel"
                            onClick={(ev) => {
                              ev.preventDefault();
                              setGeneralInformationEdit(false);
                              reset();
                            }}
                            className="link link-light"
                          >
                            Cancel
                          </a>
                        </li>
                      </ul>
                    </Col>
                  </Row>
                </form>
              </FormProvider>
            </>
          )}
        </ModalBody>
      </Modal>

      <RejectCR
        isModalVisible={crRejectModal}
        setIsModalVisible={setCrRejectModal}
        rejectCR={rejectCR}
        onRestore={() => setDisableRejectS(false)}
      />
      <RejectPo
        isModalVisible={disapprovePO}
        setIsModalVisible={setDisapprovePO}
        rejectPo={disapprovePo}
        onRestore={() => setDisableReject(false)}
      />

      {/* Approve Modal with Signature */}
      <AntModal
        title="Approve Purchase Order"
        visible={isModalApproveVisible}
        onOk={handleApproveWithSignature}
        onCancel={() => {
          setIsModalApproveVisible(false);
          setApproveSignature({ isActive: false, label: "Authorised Signatory", image: null });
          setDisableApprove(false);
        }}
        okText="Submit"
        cancelText="Cancel"
        width={600}
      >
        <div className="p-3">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <span style={{ fontSize: 14, fontWeight: 600 }}>Signature</span>

            {approveSignature.image && (
              <button
                type="button"
                onClick={() =>
                  setApproveSignature({
                    isActive: true,
                    label: "Authorised Signatory",
                    image: null,
                  })
                }
                style={{
                  border: "none",
                  background: "transparent",
                  padding: 0,
                  cursor: "pointer",
                }}
              >
                {/* <EditOutlined style={{ color: "#2263b3" }} /> */}
              </button>
            )}
          </div>

          {approveSignature.image ? (
            <>
              <div
                className="border mb-3 d-flex justify-content-center align-items-center"
                style={{
                  padding: 16,
                  borderRadius: 8,
                  background: "#fff",
                }}
              >
                <img
                  src={approveSignature.image}
                  alt="Signed"
                  style={{ maxWidth: 220, maxHeight: 120, objectFit: "contain" }}
                />
              </div>

              <div className="d-flex justify-content-between align-items-center mb-3">
                <Button
                  size="sm"
                  color="outline-secondary"
                  onClick={() =>
                    setApproveSignature({
                      isActive: true,
                      label: "Authorised Signatory",
                      image: null,
                    })
                  }
                >
                  Reset
                </Button>
              </div>
            </>
          ) : (
            <div
              style={{
                width: "100%",
                minHeight: 220,
                border: "2px dashed #dee2e6",
                borderRadius: 8,
                backgroundColor: "#f8f9fa",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: 24,
              }}
            >
              <div
                style={{
                  display: "flex",
                  gap: 12,
                  justifyContent: "center",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <ImageUploadCropper
                  onOpenCrop={() => {
                    setIsModalApproveVisible(false);
                  }}
                  onCloseCrop={() => {
                    if (activeSignatureContext === "APPROVE") {
                      setIsModalApproveVisible(true);
                      setDisableApprove(false);
                    } else if (activeSignatureContext === "REJECT") {
                      setIsModalRejectedVisible(true);
                      setDisableReject(false);
                    }
                  }}
                  onSave={(data: string) => {
                    if (activeSignatureContext === "APPROVE") {
                      setApproveSignature((prev: any) => ({ ...prev, image: data }));
                      setDisableApprove(false);
                    } else if (activeSignatureContext === "REJECT") {
                      setRejectSignature((prev: any) => ({ ...prev, image: data }));
                      setDisableReject(false);
                    }
                  }}
                >
                  <Button
                    color="primary"
                    size="sm"
                    outline
                    style={{ minWidth: 140 }}
                    onClick={() => setActiveSignatureContext("APPROVE")}
                  >
                    <Icon name="upload-cloud" className="me-1" />
                    Upload Image
                  </Button>
                </ImageUploadCropper>

                <Button
                  color="outline-primary"
                  size="sm"
                  style={{ minWidth: 140 }}
                  onClick={() => {
                    setIsModalApproveVisible(false);
                    setShowSignatureModel(true);
                  }}
                >
                  <Icon name="pen" className="me-1" />
                  Signature Pad
                </Button>
              </div>
            </div>
          )}
        </div>
      </AntModal>

      {/* Reject Modal with Signature */}
      <AntModal
        title="Reject Purchase Order"
        visible={isModalRejectedVisible}
        onOk={() => {
          rejectForm.validateFields()
            .then((values: any) => {
              const reason = values.rejectionReason;
              handleRejectWithSignature(reason);
            })
            .catch((info: any) => {
              console.log('Validate Failed:', info);
            });
        }}
        onCancel={() => {
          setIsModalRejectedVisible(false);
          setRejectSignature({ isActive: false, label: "Authorised Signatory", image: null });
          rejectForm.resetFields();
          setDisableReject(false);
        }}
        okText="Submit"
        cancelText="Cancel"
        width={600}
      >
        <div className="p-3">
          <Form layout="vertical" form={rejectForm}>
            <Form.Item
              name="rejectionReason"
              label="Reason for Rejection"
              rules={[{ required: true, message: 'Please provide a reason for rejection' }]}
            >
              <Input.TextArea
                rows={3}
                placeholder="Enter reason for rejection..."
                maxLength={500}
                showCount
              />
            </Form.Item>
          </Form>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <span style={{ fontSize: 14, fontWeight: 600 }}>Signature</span>

            {rejectSignature.image && (
              <button
                type="button"
                onClick={() =>
                  setRejectSignature({
                    isActive: true,
                    label: "Authorised Signatory",
                    image: null,
                  })
                }
                style={{
                  border: "none",
                  background: "transparent",
                  padding: 0,
                  cursor: "pointer",
                }}
              >
                <EditOutlined style={{ color: "#2263b3" }} />
              </button>
            )}
          </div>

          {rejectSignature.image ? (
            <>
              <div
                className="border mb-3 d-flex justify-content-center align-items-center"
                style={{
                  padding: 16,
                  borderRadius: 8,
                  background: "#fff",
                }}
              >
                <img
                  src={rejectSignature.image}
                  alt="Signed"
                  style={{ maxWidth: 220, maxHeight: 120, objectFit: "contain" }}
                />
              </div>

              <div className="d-flex justify-content-between align-items-center mb-3">
                <Button
                  size="sm"
                  color="outline-secondary"
                  onClick={() =>
                    setRejectSignature({
                      isActive: true,
                      label: "Authorised Signatory",
                      image: null,
                    })
                  }
                >
                  Reset
                </Button>
              </div>
            </>
          ) : (
            <div
              style={{
                width: "100%",
                minHeight: 220,
                border: "2px dashed #dee2e6",
                borderRadius: 8,
                backgroundColor: "#f8f9fa",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: 24,
              }}
            >
              <div
                style={{
                  display: "flex",
                  gap: 12,
                  justifyContent: "center",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <ImageUploadCropper
                  onOpenCrop={() => {
                    setIsModalRejectedVisible(false);
                    setActiveSignatureContext("REJECT");
                  }}
                  onCloseCrop={() => {
                    if (activeSignatureContext === "APPROVE") {
                      setIsModalApproveVisible(true);
                      setDisableApprove(false);
                    } else if (activeSignatureContext === "REJECT") {
                      setIsModalRejectedVisible(true);
                      setDisableReject(false);
                    }
                  }}
                  onSave={(data: string) => {
                    if (activeSignatureContext === "APPROVE") {
                      setApproveSignature((prev: any) => ({ ...prev, image: data }));
                      setDisableApprove(false);
                    } else if (activeSignatureContext === "REJECT") {
                      setRejectSignature((prev: any) => ({ ...prev, image: data }));
                      setDisableReject(false);
                    }
                  }}
                >
                  <Button
                    color="primary"
                    size="sm"
                    outline
                    style={{ minWidth: 140 }}
                    onClick={() => setActiveSignatureContext("REJECT")}
                  >
                    <Icon name="upload-cloud" className="me-1" />
                    Upload Image
                  </Button>
                </ImageUploadCropper>

                <Button
                  color="outline-primary"
                  size="sm"
                  style={{ minWidth: 140 }}
                  onClick={() => {
                    setIsModalRejectedVisible(false);
                    setShowSignatureModel(true);
                    setActiveSignatureContext("REJECT");
                  }}
                >
                  <Icon name="pen" className="me-1" />
                  Signature Pad
                </Button>
              </div>
            </div>
          )}
        </div>
      </AntModal>

      <Content>
        <Card className="card-bordered">
          <div className="card-aside-wrap">
            {!extra?.hideAside && (
              <div
                className={`card-aside card-aside-left user-aside toggle-slide toggle-slide-left toggle-break-lg ${sm ? "content-active" : ""
                  }`}
              >
                <PurchaseOrderAside updateSm={setSm} sm={sm} />
              </div>
            )}
            {isLoading == true ? (
              <>
                <Flex align="center" gap="middle" className="pageLoader">
                  <Spin size="large" className="m-auto" />
                </Flex>
              </>
            ) : (
              <div className="card-inner card-inner-lg">
                {sm && mobileView && (
                  <div
                    className="toggle-overlay"
                    onClick={() => setSm(!sm)}
                  ></div>
                )}
                <BlockHead size="lg">
                  <BlockBetween>
                    <BlockHeadContent>
                      <BlockTitle tag="h4">
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <span>
                            {OriginalData.orderId} |{" "}
                            {(statusMapper[poStatus] &&
                              statusMapper[poStatus]?.buyer?.title) ||
                              poStatus}{" "}
                          </span>
                          {OriginalData?.isOrderTransferred === 1 && (
                            <span
                              className="badge bg-outline-primary"
                              style={{
                                position: "relative",
                                border: "1px solid currentColor",
                                lineHeight: "1.125rem",
                                fontFamily: "Roboto, sans-serif",
                                fontSize: "0.675rem",
                                letterSpacing: "0.01em",
                                verticalAlign: "middle",
                                display: "inline-flex",
                                borderRadius: "3px",
                                color: "#ffa500",
                              }}
                            >
                              Transfer
                            </span>
                          )}
                        </span>
                      </BlockTitle>
                    </BlockHeadContent>
                    {showSubmitBtm ? (
                      <div className="d-flex align-items-center">
                        <div className="actions clearfix paddingLeft10">
                          <ul
                            className="m-auto d-flex align-items-center justify-content-center p-0"
                            style={{
                              flexDirection: "row-reverse",
                            }}
                          >
                            <li className="pt-0 pb-0">
                              <Button
                                color="primary"
                                type="button"
                                onClick={() => {
                                  if (disableSubmit) return;
                                  setDisableSubmit(true);
                                  Swal.fire({
                                    title: "Are you sure?",
                                    text: "Do you want to submit the changes?",
                                    icon: "warning",
                                    showCancelButton: true,
                                    confirmButtonColor: "#3085d6",
                                    cancelButtonColor: "#d33",
                                    confirmButtonText: "Yes, submit it!",
                                    cancelButtonText: "No, cancel",
                                  }).then(async (result) => {
                                    if (result.isConfirmed) {
                                      await SubmitChanges();
                                    } else {
                                      setDisableSubmit(false);
                                    }
                                  });
                                }}
                              >
                                Save Changes
                              </Button>
                            </li>
                            <li className="p-0">
                              <Button
                                color="secondary"
                                onClick={() => {
                                  Swal.fire({
                                    title: "Are you sure?",
                                    text: "Do you want to revert the changes?",
                                    icon: "warning",
                                    showCancelButton: true,
                                    confirmButtonColor: "#3085d6",
                                    cancelButtonColor: "#d33",
                                    confirmButtonText: "Yes, revert it!",
                                    cancelButtonText: "No, cancel",
                                  }).then((result) => {
                                    if (result.isConfirmed) {
                                      fetchOrderDetails();
                                      Swal.fire(
                                        "Reverted!",
                                        "Your changes have been reverted.",
                                        "success"
                                      );
                                    }
                                  });
                                }}
                                type="button"
                                className="btn-dim btn btn-secondary"
                              >
                                Revert Changes
                              </Button>
                            </li>
                          </ul>
                        </div>
                        <div className="paddingLeft10">
                          <Button
                            className="toggle"
                            color="primary"
                            onClick={async () => {
                              navigate(previousPath, {
                                state: { previousState: extra?.previousState },
                              });
                            }}
                          >
                            <Icon name="arrow-left" />
                            <span>Back</span>
                          </Button>
                        </div>

                        <ul className="nk-tb-actions ms-2">
                          <li>
                            <UncontrolledDropdown>
                              <DropdownToggle
                                tag="a"
                                className="dropdown-toggle btn btn-icon btn-trigger"
                              >
                                <Icon name="more-v"></Icon>
                              </DropdownToggle>
                              <DropdownMenu end>
                                <ul className="link-list-opt no-bdr">
                                  {["Pending Approval"].includes(poStatus) &&
                                    allowedActions?.approve == 1 &&
                                    (approverIds.includes(currentUserId) || currentUser?.genericRole?.toLowerCase() === "admin") &&
                                    !hasUserAlreadyApproved &&
                                    !showSubmitBtm && (
                                      <>
                                        {canUserApproveReject() ? (
                                          <>
                                            <li
                                              onClick={(e) => {
                                                e.preventDefault();
                                                if (disableApprove) return;
                                                setDisableApprove(true);
                                                openApproveModal();
                                                const dropdown = document.querySelector(
                                                  ".dropdown-menu.show"
                                                );
                                                if (dropdown) {
                                                  dropdown.classList.remove("show");
                                                }
                                              }}
                                            >
                                              <Link to={`#`}>
                                                <Icon name="check" /> Approve
                                              </Link>
                                            </li>
                                            <li
                                              onClick={(e) => {
                                                e.preventDefault();
                                                if (disableReject) return;
                                                setDisableReject(true);
                                                openRejectModal();
                                                const dropdown = document.querySelector(
                                                  ".dropdown-menu.show"
                                                );
                                                if (dropdown) {
                                                  dropdown.classList.remove("show");
                                                }
                                              }}
                                            >
                                              <Link to={`#`}>
                                                <Icon name="cross" /> Reject
                                              </Link>
                                            </li>
                                          </>
                                        ) : (
                                          <>
                                            <li className="disabled" style={{ position: 'relative' }}>
                                              <div
                                                className="d-flex align-items-center justify-content-between w-100"
                                                style={{
                                                  padding: "8px 16px",
                                                  opacity: 0.6,
                                                  cursor: "not-allowed",
                                                }}
                                              >
                                                <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                                                  <Icon name="check" />
                                                  <span>Approve</span>
                                                </div>
                                                <Popover
                                                  content={
                                                    <div style={{ padding: "8px", maxWidth: "300px" }}>
                                                      <p style={{ margin: 0 }}>{getPendingStatusMessage()}</p>
                                                    </div>
                                                  }
                                                  title="Approval Status"
                                                  trigger="hover"
                                                >
                                                  <InfoCircleOutlined
                                                    style={{
                                                      fontSize: "16px",
                                                      cursor: "pointer",
                                                      color: "#2263b3",
                                                      marginLeft: "8px"
                                                    }}
                                                  />
                                                </Popover>
                                              </div>
                                            </li>
                                            <li className="disabled">
                                              <div
                                                className="d-flex align-items-center"
                                                style={{
                                                  padding: "8px 16px",
                                                  opacity: 0.6,
                                                  cursor: "not-allowed",
                                                  gap: "8px"
                                                }}
                                              >
                                                <Icon name="cross" />
                                                <span>Reject</span>
                                              </div>
                                            </li>
                                          </>
                                        )}
                                      </>
                                    )}

                                  {["Changes to Buyer"].includes(poStatus) &&
                                    allowedActions?.approve == 1 &&
                                    !showSubmitBtm && (
                                      <>
                                        <li
                                          onClick={(e) => {
                                            e.preventDefault();
                                            if (disableAccept) return;
                                            setDisableAccept(true);
                                            Swal.fire({
                                              title: "Are you sure?",
                                              text: "Do you want to accept the changes?",
                                              icon: "warning",
                                              showCancelButton: true,
                                              confirmButtonColor: "#3085d6",
                                              cancelButtonColor: "#d33",
                                              confirmButtonText:
                                                "Yes, Accept it!",
                                            }).then((result) => {
                                              if (result.isConfirmed) {
                                                AcceptCR();
                                              } else {
                                                setDisableAccept(false);
                                              }
                                            });
                                            const dropdown =
                                              document.querySelector(
                                                ".dropdown-menu.show"
                                              );
                                            if (dropdown) {
                                              dropdown.classList.remove("show");
                                            }
                                          }}
                                        >
                                          <Link to={`#`}>
                                            <Icon name="check" /> Accept Change
                                            Request
                                          </Link>
                                        </li>
                                        <li
                                          onClick={(e) => {
                                            e.preventDefault();
                                            if (disableRejectS) return;
                                            setDisableRejectS(true);
                                            setCrRejectModal(true);
                                            const dropdown =
                                              document.querySelector(
                                                ".dropdown-menu.show"
                                              );
                                            if (dropdown) {
                                              dropdown.classList.remove("show");
                                            }
                                          }}
                                        >
                                          <Link to={`#`}>
                                            <Icon name="cross" /> Reject Change
                                            Request
                                          </Link>
                                        </li>
                                      </>
                                    )}

                                  {!showSubmitBtm && invoiceAllowedActions?.add && (
                                    <>
                                      {poStatus !== "Fully Delivered" &&
                                        OriginalData?.closureStatus === "Open" &&
                                        OriginalData?.approvalStatus === "Approved" &&
                                        OriginalData?.invoiceStatus !== "FullyInvoiced" && (
                                          <li
                                            onClick={(e) => {
                                              e.preventDefault();
                                              navigate(
                                                `/add-purchase-invoice/${orderNumber}`
                                              );
                                              const dropdown =
                                                document.querySelector(
                                                  ".dropdown-menu.show"
                                                );
                                              if (dropdown) {
                                                dropdown.classList.remove("show");
                                              }
                                            }}
                                          >
                                            <Link to={`#`}>
                                              <Icon name="file-text" />{" "}
                                              Convert To Invoice
                                            </Link>
                                          </li>
                                        )}
                                      {poStatus === "Fully Delivered" && (
                                        <li
                                          onClick={(e) => {
                                            e.preventDefault();
                                            navigate(`/view-invoice-list`, {
                                              state: { orderNumber },
                                            });
                                            const dropdown =
                                              document.querySelector(
                                                ".dropdown-menu.show"
                                              );
                                            if (dropdown) {
                                              dropdown.classList.remove("show");
                                            }
                                          }}
                                        >
                                          <Link to={`#`}>
                                            <Icon name="file-text" />{" "}
                                            View Invoice Details
                                          </Link>
                                        </li>
                                      )}
                                    </>
                                  )}

                                  {!showSubmitBtm &&
                                    (["To be Invoiced", "Approved"]?.includes(
                                      poStatus
                                    ) ||
                                      (OriginalData?.approvalStatus === "Approved" &&
                                        (OriginalData?.invoiceStatus === "PartiallyInvoiced" ||
                                          OriginalData?.invoiceStatus === "Pending"))) &&
                                    !OriginalData?.rateContractId &&
                                    OriginalData?.closureStatus !== 'FullyTransferred' && (
                                      <li
                                        onClick={(e) => {
                                          e.preventDefault();
                                          setTransferPoDrawerVisible(true);
                                          // Initialize invoiceable lines from materialData
                                          // Filter and map lines with available quantity > 0
                                          const lines =
                                            materialData?.lineItems
                                              ?.map((item: any, index: number) => {
                                                const qty = Number(item.quantity) || 0;
                                                const invoicedQty = Number(item.quantityInvoiced) || 0;
                                                const originalTransferredQty = Number(item.quantityTransferred) || 0;
                                                const availableQty = qty - invoicedQty - originalTransferredQty;
                                                
                                                // Only include lines with available quantity > 0
                                                if (availableQty > 0) {
                                                  return {
                                                    ...item,
                                                    uuid: item.uuid || `temp-${index}`,
                                                    key: index,
                                                    // Keep original quantity for calculations
                                                    quantity: qty,
                                                    // Keep original quantityTransferred for available qty calculation
                                                    originalQuantityTransferred: originalTransferredQty,
                                                    // Pre-populate quantityTransferred with available quantity for editing
                                                    quantityTransferred: availableQty,
                                                    basicAmount:
                                                      availableQty *
                                                      Number(item.unitPrice),
                                                  };
                                                }
                                                return null;
                                              })
                                              .filter((item: any) => item !== null) || [];
                                          setInvoiceableLines(lines || []);

                                          // Initialize delivery address and need by date lists
                                          const _DeliveryAddressList: any = [];
                                          const _needByDateList: any = [];
                                          materialData?.lineItems?.forEach(
                                            (item: any) => {
                                              if (
                                                materialData?.deliveryAddressType ==
                                                "Line Level"
                                              ) {
                                                if (
                                                  !_DeliveryAddressList?.find(
                                                    (address: any) =>
                                                      address?.id ==
                                                      item?.deliveryAddress?.id
                                                  )
                                                ) {
                                                  _DeliveryAddressList.push({
                                                    ...item?.deliveryAddress,
                                                  });
                                                }
                                              }
                                              if (
                                                materialData?.needByDateType ==
                                                "Line Level"
                                              ) {
                                                if (
                                                  !_needByDateList?.find(
                                                    (date: any) =>
                                                      date == item?.needByDate
                                                  )
                                                ) {
                                                  _needByDateList.push(
                                                    item?.needByDate
                                                  );
                                                }
                                              }
                                            }
                                          );
                                          setTransferPoNeedByDateList(
                                            _needByDateList
                                          );
                                          if (_needByDateList?.length == 1) {
                                            setSelectedNeedByDate(
                                              _needByDateList[0]
                                            );
                                          }
                                          setTransferPoDeliveryAddressList(
                                            _DeliveryAddressList
                                          );
                                          if (
                                            _DeliveryAddressList?.length == 1
                                          ) {
                                            setSelectedDeliveryAddress(
                                              _DeliveryAddressList[0]?.id
                                            );
                                          }
                                          const dropdown =
                                            document.querySelector(
                                              ".dropdown-menu.show"
                                            );
                                          if (dropdown) {
                                            dropdown.classList.remove("show");
                                          }
                                        }}
                                      >
                                        <Link to={`#`}>
                                          <Icon name="arrow-right" /> Transfer
                                          PO
                                        </Link>
                                      </li>
                                    )}

                                  {!showSubmitBtm &&
                                    OriginalData?.invoiceStatus === "PartiallyInvoiced" &&
                                    OriginalData?.closureStatus === "Open" && (
                                      <li
                                        onClick={(e) => {
                                          e.preventDefault();
                                          handleShortClose();
                                        }}
                                      >
                                        <Link to={`#`}>
                                          <Icon name="check-circle" /> Short Close
                                        </Link>
                                      </li>
                                    )}

                                  {!showSubmitBtm &&
                                    OriginalData.version > 1 && (
                                      <li
                                        onClick={(e) => {
                                          e.preventDefault();
                                          navigate(
                                            `/poHistory/${OriginalData.orderNumber}`
                                          );
                                          const dropdown =
                                            document.querySelector(
                                              ".dropdown-menu.show"
                                            );
                                          if (dropdown) {
                                            dropdown.classList.remove("show");
                                          }
                                        }}
                                      >
                                        <Link to={`#`}>
                                          <Icon name="history" /> Version
                                          History
                                        </Link>
                                      </li>
                                    )}

                                  <li
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setShowEmailModal(true);
                                      const dropdown = document.querySelector(
                                        ".dropdown-menu.show"
                                      );
                                      if (dropdown) {
                                        dropdown.classList.remove("show");
                                      }
                                    }}
                                  >
                                    <Link to={`#`}>
                                      <Icon name="mail" /> Send Mail
                                    </Link>
                                  </li>

                                  <li>
                                    <PdfGenerator
                                      buyerDetails={returnBillingDetails()}
                                      poDetails={returnPoDetails()}
                                      supplierDetails={returnSupplierDetails()}
                                      buyerOrgLogo={currentUser?.orgLogo}
                                      hasIGST={
                                        taxConfiguration?.gstType == "IGST"
                                      }
                                      TermsAndConditions={termsAndConditions}
                                      getPdfUrl={updatePdfBlobDataRef}
                                      poApprovals={
                                        materialData?.orderApprovals ||
                                        OriginalData?.orderApprovals ||
                                        []
                                      }
                                    />
                                  </li>
                                </ul>
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </li>
                        </ul>
                      </div>
                    ) : (
                      <div className="d-flex align-items-center">
                        <div className="paddingLeft10">
                          <Button
                            className="toggle"
                            color="primary"
                            onClick={async () => {
                              navigate(previousPath, {
                                state: { previousState: extra?.previousState },
                              });
                            }}
                          >
                            <Icon name="arrow-left" />
                            <span>Back</span>
                          </Button>
                        </div>

                        <ul className="nk-tb-actions ms-2">
                          <li>
                            <UncontrolledDropdown>
                              <DropdownToggle
                                tag="a"
                                className="dropdown-toggle btn btn-icon btn-trigger"
                              >
                                <Icon name="more-v"></Icon>
                              </DropdownToggle>
                              <DropdownMenu end>
                                <ul className="link-list-opt no-bdr">
                                  {["Pending Approval"].includes(poStatus) &&
                                    allowedActions?.approve == 1 &&
                                    (approverIds.includes(currentUserId) || currentUser?.genericRole?.toLowerCase() === "admin") &&
                                    !showSubmitBtm && (
                                      <>
                                        {canUserApproveReject() ? (
                                          <>
                                            <li
                                              onClick={(e) => {
                                                e.preventDefault();
                                                if (disableApprove) return;
                                                setDisableApprove(true);
                                                openApproveModal();
                                                const dropdown = document.querySelector(
                                                  ".dropdown-menu.show"
                                                );
                                                if (dropdown) {
                                                  dropdown.classList.remove("show");
                                                }
                                              }}
                                            >
                                              <Link to={`#`}>
                                                <Icon name="check" /> Approve
                                              </Link>
                                            </li>
                                            <li
                                              onClick={(e) => {
                                                e.preventDefault();
                                                if (disableReject) return;
                                                setDisableReject(true);
                                                openRejectModal();
                                                const dropdown = document.querySelector(
                                                  ".dropdown-menu.show"
                                                );
                                                if (dropdown) {
                                                  dropdown.classList.remove("show");
                                                }
                                              }}
                                            >
                                              <Link to={`#`}>
                                                <Icon name="cross" /> Reject
                                              </Link>
                                            </li>
                                          </>
                                        ) : (
                                          <>
                                            <li className="disabled" style={{ position: 'relative' }}>
                                              <div
                                                className="d-flex align-items-center justify-content-between w-100"
                                                style={{
                                                  padding: "8px 16px",
                                                  opacity: 0.6,
                                                  cursor: "not-allowed",
                                                }}
                                              >
                                                <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                                                  <Icon name="check" />
                                                  <span>Approve</span>
                                                </div>
                                                <Popover
                                                  content={
                                                    <div style={{ padding: "8px", maxWidth: "300px" }}>
                                                      <p style={{ margin: 0 }}>{getPendingStatusMessage()}</p>
                                                    </div>
                                                  }
                                                  title="Approval Status"
                                                  trigger="hover"
                                                >
                                                  <InfoCircleOutlined
                                                    style={{
                                                      fontSize: "16px",
                                                      cursor: "pointer",
                                                      color: "#2263b3",
                                                      marginLeft: "8px"
                                                    }}
                                                  />
                                                </Popover>
                                              </div>
                                            </li>
                                            <li className="disabled">
                                              <div
                                                className="d-flex align-items-center"
                                                style={{
                                                  padding: "8px 16px",
                                                  opacity: 0.6,
                                                  cursor: "not-allowed",
                                                  gap: "8px"
                                                }}
                                              >
                                                <Icon name="cross" />
                                                <span>Reject</span>
                                              </div>
                                            </li>
                                          </>
                                        )}
                                      </>
                                    )}

                                  {["Changes to Buyer"].includes(poStatus) &&
                                    allowedActions?.approve == 1 &&
                                    !showSubmitBtm && (
                                      <>
                                        <li
                                          onClick={(e) => {
                                            e.preventDefault();
                                            if (disableAccept) return;
                                            setDisableAccept(true);
                                            Swal.fire({
                                              title: "Are you sure?",
                                              text: "Do you want to accept the changes?",
                                              icon: "warning",
                                              showCancelButton: true,
                                              confirmButtonColor: "#3085d6",
                                              cancelButtonColor: "#d33",
                                              confirmButtonText:
                                                "Yes, Accept it!",
                                            }).then((result) => {
                                              if (result.isConfirmed) {
                                                AcceptCR();
                                              } else {
                                                setDisableAccept(false);
                                              }
                                            });
                                            const dropdown =
                                              document.querySelector(
                                                ".dropdown-menu.show"
                                              );
                                            if (dropdown) {
                                              dropdown.classList.remove("show");
                                            }
                                          }}
                                        >
                                          <Link to={`#`}>
                                            <Icon name="check" /> Accept Change
                                            Request
                                          </Link>
                                        </li>
                                        <li
                                          onClick={(e) => {
                                            e.preventDefault();
                                            if (disableRejectS) return;
                                            setDisableRejectS(true);
                                            setCrRejectModal(true);
                                            const dropdown =
                                              document.querySelector(
                                                ".dropdown-menu.show"
                                              );
                                            if (dropdown) {
                                              dropdown.classList.remove("show");
                                            }
                                          }}
                                        >
                                          <Link to={`#`}>
                                            <Icon name="cross" /> Reject Change
                                            Request
                                          </Link>
                                        </li>
                                      </>
                                    )}

                                  {!showSubmitBtm && invoiceAllowedActions?.add && (
                                    <>
                                      {poStatus !== "Fully Delivered" &&
                                        OriginalData?.closureStatus === "Open" &&
                                        OriginalData?.approvalStatus === "Approved" &&
                                        OriginalData?.invoiceStatus !== "FullyInvoiced" && (
                                          <li
                                            onClick={(e) => {
                                              e.preventDefault();
                                              navigate(
                                                `/add-purchase-invoice/${orderNumber}`
                                              );
                                              const dropdown =
                                                document.querySelector(
                                                  ".dropdown-menu.show"
                                                );
                                              if (dropdown) {
                                                dropdown.classList.remove("show");
                                              }
                                            }}
                                          >
                                            <Link to={`#`}>
                                              <Icon name="file-text" />{" "}
                                              Convert To Invoice
                                            </Link>
                                          </li>
                                        )}
                                      {poStatus === "Fully Delivered" && (
                                        <li
                                          onClick={(e) => {
                                            e.preventDefault();
                                            navigate(`/view-invoice-list`, {
                                              state: { orderNumber },
                                            });
                                            const dropdown =
                                              document.querySelector(
                                                ".dropdown-menu.show"
                                              );
                                            if (dropdown) {
                                              dropdown.classList.remove("show");
                                            }
                                          }}
                                        >
                                          <Link to={`#`}>
                                            <Icon name="file-text" />{" "}
                                            View Invoice Details
                                          </Link>
                                        </li>
                                      )}
                                    </>
                                  )}

                                  {!showSubmitBtm &&
                                    (["To be Invoiced", "Approved"]?.includes(
                                      poStatus
                                    ) ||
                                      (OriginalData?.approvalStatus === "Approved" &&
                                        (OriginalData?.invoiceStatus === "PartiallyInvoiced" ||
                                          OriginalData?.invoiceStatus === "Pending"))) &&
                                    !OriginalData?.rateContractId &&
                                    OriginalData?.closureStatus !== 'FullyTransferred' && (
                                      <li
                                        onClick={(e) => {
                                          e.preventDefault();
                                          setTransferPoDrawerVisible(true);
                                          // Initialize invoiceable lines from materialData
                                          // Filter and map lines with available quantity > 0
                                          const lines =
                                            materialData?.lineItems
                                              ?.map((item: any, index: number) => {
                                                const qty = Number(item.quantity) || 0;
                                                const invoicedQty = Number(item.quantityInvoiced) || 0;
                                                const originalTransferredQty = Number(item.quantityTransferred) || 0;
                                                const availableQty = qty - invoicedQty - originalTransferredQty;
                                                
                                                // Only include lines with available quantity > 0
                                                if (availableQty > 0) {
                                                  return {
                                                    ...item,
                                                    uuid: item.uuid || `temp-${index}`,
                                                    key: index,
                                                    // Keep original quantity for calculations
                                                    quantity: qty,
                                                    // Keep original quantityTransferred for available qty calculation
                                                    originalQuantityTransferred: originalTransferredQty,
                                                    // Pre-populate quantityTransferred with available quantity for editing
                                                    quantityTransferred: availableQty,
                                                    basicAmount:
                                                      availableQty *
                                                      Number(item.unitPrice),
                                                  };
                                                }
                                                return null;
                                              })
                                              .filter((item: any) => item !== null) || [];
                                          setInvoiceableLines(lines || []);

                                          // Initialize delivery address and need by date lists
                                          const _DeliveryAddressList: any = [];
                                          const _needByDateList: any = [];
                                          materialData?.lineItems?.forEach(
                                            (item: any) => {
                                              if (
                                                materialData?.deliveryAddressType ==
                                                "Line Level"
                                              ) {
                                                if (
                                                  !_DeliveryAddressList?.find(
                                                    (address: any) =>
                                                      address?.id ==
                                                      item?.deliveryAddress?.id
                                                  )
                                                ) {
                                                  _DeliveryAddressList.push({
                                                    ...item?.deliveryAddress,
                                                  });
                                                }
                                              }
                                              if (
                                                materialData?.needByDateType ==
                                                "Line Level"
                                              ) {
                                                if (
                                                  !_needByDateList?.find(
                                                    (date: any) =>
                                                      date == item?.needByDate
                                                  )
                                                ) {
                                                  _needByDateList.push(
                                                    item?.needByDate
                                                  );
                                                }
                                              }
                                            }
                                          );
                                          setTransferPoNeedByDateList(
                                            _needByDateList
                                          );
                                          if (_needByDateList?.length == 1) {
                                            setSelectedNeedByDate(
                                              _needByDateList[0]
                                            );
                                          }
                                          setTransferPoDeliveryAddressList(
                                            _DeliveryAddressList
                                          );
                                          if (
                                            _DeliveryAddressList?.length == 1
                                          ) {
                                            setSelectedDeliveryAddress(
                                              _DeliveryAddressList[0]?.id
                                            );
                                          }
                                          const dropdown =
                                            document.querySelector(
                                              ".dropdown-menu.show"
                                            );
                                          if (dropdown) {
                                            dropdown.classList.remove("show");
                                          }
                                        }}
                                      >
                                        <Link to={`#`}>
                                          <Icon name="arrow-right" /> Transfer
                                          PO
                                        </Link>
                                      </li>
                                    )}

                                  {!showSubmitBtm &&
                                    OriginalData?.invoiceStatus === "PartiallyInvoiced" &&
                                    OriginalData?.closureStatus === "Open" && (
                                      <li
                                        onClick={(e) => {
                                          e.preventDefault();
                                          handleShortClose();
                                        }}
                                      >
                                        <Link to={`#`}>
                                          <Icon name="check-circle" /> Short Close
                                        </Link>
                                      </li>
                                    )}

                                  {!showSubmitBtm &&
                                    OriginalData.version > 1 && (
                                      <li
                                        onClick={(e) => {
                                          e.preventDefault();
                                          navigate(
                                            `/poHistory/${OriginalData.orderNumber}`
                                          );
                                          const dropdown =
                                            document.querySelector(
                                              ".dropdown-menu.show"
                                            );
                                          if (dropdown) {
                                            dropdown.classList.remove("show");
                                          }
                                        }}
                                      >
                                        <Link to={`#`}>
                                          <Icon name="history" /> Version
                                          History
                                        </Link>
                                      </li>
                                    )}

                                  <li
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setShowEmailModal(true);
                                      const dropdown = document.querySelector(
                                        ".dropdown-menu.show"
                                      );
                                      if (dropdown) {
                                        dropdown.classList.remove("show");
                                      }
                                    }}
                                  >
                                    <Link to={`#`}>
                                      <Icon name="mail" /> Send Mail
                                    </Link>
                                  </li>

                                  <li>
                                    <PdfGenerator
                                      buyerDetails={returnBillingDetails()}
                                      poDetails={returnPoDetails()}
                                      supplierDetails={returnSupplierDetails()}
                                      buyerOrgLogo={currentUser?.orgLogo}
                                      hasIGST={
                                        taxConfiguration?.gstType == "IGST"
                                      }
                                      TermsAndConditions={termsAndConditions}
                                      getPdfUrl={updatePdfBlobDataRef}
                                      poApprovals={
                                        materialData?.orderApprovals ||
                                        OriginalData?.orderApprovals ||
                                        []
                                      }
                                    />
                                  </li>
                                </ul>
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </li>
                        </ul>
                      </div>
                    )}
                    <BlockHeadContent className="align-self-start d-lg-none">
                      <Button
                        className={`toggle btn btn-icon btn-trigger mt-n1 ${sm ? "active" : ""
                          }`}
                        onClick={() => setSm(!sm)}
                      >
                        <Icon name="menu-alt-r" />
                      </Button>
                    </BlockHeadContent>
                  </BlockBetween>
                </BlockHead>

                <Alert color={"danger"} isOpen={poStatus == "Rejected"}>
                  <strong>
                    {rejectedData?.userName} ({rejectedData?.roleName}) :{" "}
                  </strong>{" "}
                  {OriginalData?.rejectedReason}
                </Alert>

                <Alert
                  color={"danger"}
                  isOpen={poStatus == "Rejected by Supplier"}
                >
                  <strong>{OriginalData?.rejectedReason}</strong>
                </Alert>

                <div className="content clearfix">
                  <AntCollapse defaultActiveKey={["1", "2", "3"]}>
                    <Panel
                      header={
                        <div className="d-flex align-items-center justify-content-between">
                          <>General Information</>
                        </div>
                      }
                      key="1"
                    >
                      <ul className="nav nav-tabs nav-tabs-card nav-tabs-xs w-100 p-0 m-0 position-relative">
                        <li className="nav-item" onClick={() => setTab("1")}>
                          <a
                            onClick={(ev) => {
                              ev.preventDefault();
                            }}
                            className={`nav-link${tab === "1" ? " active" : ""
                              }`}
                            href="#year"
                          >
                            General Info
                          </a>
                        </li>
                        <li className="nav-item" onClick={() => setTab("2")}>
                          <a
                            href="#overview"
                            onClick={(ev) => {
                              ev.preventDefault();
                            }}
                            className={`nav-link${tab === "2" ? " active" : ""
                              }`}
                          >
                            Delivery Info
                          </a>
                        </li>
                        {(["Pending Approval", "Rejected"].includes(poStatus) ||
                          (tab == "2" &&
                            ["Pending Approval", "Approved", "Rejected"].includes(
                              poStatus
                            ) &&
                            OriginalData?.needByDateType == "Order Level")) &&
                          allowedActions?.edit == 1 ? (
                          <span
                            className="cursor-pointer position-absolute"
                            style={{
                              right: 20,
                              top: 10,
                              fontSize: "18px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              // if(["Pending Approval"].includes(poStatus)){
                              if (tab === "1") {
                                setValue("siteId", materialData?.siteId);
                                setValue(
                                  "supplierId",
                                  materialData?.supplierId
                                );
                                setValue(
                                  "description",
                                  materialData?.description
                                );
                                setValue("budgetId", materialData?.budgetId);
                                setValue(
                                  "contractorId",
                                  materialData?.contractorId
                                );
                                setValue(
                                  "paymentTerms",
                                  materialData?.paymentTerms
                                );
                                setValue(
                                  "advancePercentage",
                                  materialData?.advancePercentage
                                );
                                setValue(
                                  "creditDays",
                                  materialData?.creditDays
                                );

                                // Set advance milestones if available
                                if (Array.isArray(OriginalData?.advanceMilestones)) {
                                  const nameToKey: Record<string, string> = {
                                    "along with the po": "milestone0",
                                    "before dispatch": "milestone1",
                                    "on grn": "milestone2",
                                    "post-installation/commissioning": "milestone3",
                                  };
                                  OriginalData.advanceMilestones.forEach((ms: any) => {
                                    const key = nameToKey[String(ms?.milestoneName ?? "").toLowerCase()];
                                    if (!key) return;
                                    if (ms.advancePercentage != null && ms.advancePercentage !== "")
                                      setValue(`${key}_advancePercentage`, ms.advancePercentage);
                                    if (ms.bankName) setValue(`${key}_bankName`, ms.bankName);
                                    if (ms.paymentMode) setValue(`${key}_paymentMode`, ms.paymentMode);
                                    if (ms.paymentDate) setValue(`${key}_paymentDate`, dayjs(ms.paymentDate));
                                    if (ms.transactionNumber) setValue(`${key}_transactionNumber`, ms.transactionNumber);
                                    if (ms.remarks) setValue(`${key}_remarks`, ms.remarks);
                                  });
                                } else if (OriginalData?.advancePaymentDetails) {
                                  setValue(
                                    "paymentMode",
                                    OriginalData?.advancePaymentDetails?.mode || ""
                                  );
                                  setValue(
                                    "transactionNumber",
                                    OriginalData?.advancePaymentDetails?.transactionNumber || ""
                                  );
                                  setValue(
                                    "bankName",
                                    OriginalData?.advancePaymentDetails?.bankName || ""
                                  );
                                  setValue(
                                    "paymentDate",
                                    OriginalData?.advancePaymentDetails?.paymentDate
                                      ? dayjs(OriginalData?.advancePaymentDetails?.paymentDate)
                                      : null
                                  );
                                  setValue(
                                    "paymentRemarks",
                                    OriginalData?.advancePaymentDetails?.remarks || ""
                                  );
                                }

                                setValue(
                                  "costCenterId",
                                  materialData?.costCenterId
                                );
                                setValue("ledgerId", materialData?.ledgerId);
                                setValue(
                                  "departmentId",
                                  materialData?.departmentId
                                );
                              } else if (tab === "2") {
                                setValue(
                                  "inwardRequired",
                                  materialData?.inwardRequired
                                );
                                setValue(
                                  "needByDateType",
                                  materialData?.needByDateType
                                );
                                setValue(
                                  "needByDate",
                                  dayjs(materialData?.needByDate)
                                );
                                setValue(
                                  "billingAddressId",
                                  materialData?.billingAddressId
                                );
                                setValue(
                                  "deliveryAddressType",
                                  materialData?.deliveryAddressType
                                );
                                setValue(
                                  "deliveryAddressId",
                                  materialData?.deliveryAddressId
                                );
                              }
                              // }else if(tab=="2"&&OriginalData?.needByDateType=="Order Level"){

                              // }
                              setGeneralInformationEdit(true);
                            }}
                          >
                            <Icon name="edit" />
                          </span>
                        ) : (
                          <></>
                        )}
                      </ul>

                      <div className="tab-content mt-0">
                        {tab === "1" && (
                          <div
                            className={`tab-pane${tab === "1" && " active"}`}
                          >
                            <Col className="justify-start w-100  flex-wrap mt-3 p-3">
                              <div className="w-30 border-end ">
                                <div className="data-col align-center pt-1">
                                  <div className="data-label w-30">
                                    Order Date
                                  </div>
                                  <div className="data-value w-70">
                                    {OriginalData?.orderDate
                                      ? dayjs(OriginalData?.orderDate)?.format(
                                        "DD-MMM-YYYY"
                                      )
                                      : "N/A"}
                                  </div>
                                </div>
                                <div className="data-col align-center pt-1 ">
                                  <div className="data-label w-30">Site</div>
                                  <div className="data-value w-70 ">
                                    {materialData?.siteName}
                                  </div>
                                </div>
                                <div className="data-col align-center pt-1 ">
                                  <div className="data-label w-30">
                                    Contractor
                                  </div>
                                  <div className="data-value w-70 ">
                                    {materialData?.contractorName || "--"}
                                  </div>
                                </div>
                                <div className="data-col align-center pt-1">
                                  <div className="data-label w-30">
                                    Description
                                  </div>
                                  <div className="data-value w-70">
                                    <Popover
                                      content={
                                        <div>
                                          <p>{materialData?.description}</p>
                                        </div>
                                      }
                                      title={"Description"}
                                    >
                                      {materialData?.description?.length >
                                        20 ? (
                                        <span
                                          style={{
                                            color: "#2263b3",
                                            textDecoration: "underline",
                                            cursor: "pointer",
                                          }}
                                        >
                                          {materialData?.description?.substring(
                                            0,
                                            20
                                          )}
                                          ...
                                        </span>
                                      ) : (
                                        materialData?.description || "--"
                                      )}
                                    </Popover>
                                  </div>
                                </div>
                                <div className="data-col align-center pt-1">
                                  <div className="data-label w-30">
                                    Order Date
                                  </div>
                                  <div className="data-value w-70">
                                    {OriginalData?.orderDate
                                      ? dayjs(OriginalData?.orderDate)?.format(
                                        "DD-MMM-YYYY"
                                      )
                                      : "N/A"}
                                  </div>
                                </div>
                              </div>
                              <div className="w-30 border-end paddingLeft10 ">
                                {OriginalData?.contractReferenceId && (
                                  <div className="data-col align-center pt-1 ">
                                    <div className="data-label w-40">
                                      Contract #
                                    </div>
                                    <div className="data-value w-60 ">
                                      {OriginalData?.contractReferenceId || "--"}
                                    </div>
                                  </div>
                                )}
                                {OriginalData?.covertedFrom === "RFQ" && (
                                  <div className="data-col align-center pt-1 ">
                                    <div className="data-label w-40">
                                      Quotation #
                                    </div>
                                    <div className="data-value w-60 ">
                                      {OriginalData?.quotationId ? (
                                        <a
                                          onClick={() => {
                                            navigate("/rfq-full-view", {
                                              state: {
                                                rfq: {
                                                  quotationId:
                                                    OriginalData?.quotationNumber,
                                                  rfqId:
                                                    OriginalData?.quotationNumber,
                                                  siteName:
                                                    OriginalData?.siteName ||
                                                    materialData?.siteName,
                                                  quotationDescription:
                                                    OriginalData?.description ||
                                                    materialData?.description,
                                                  deadlineType:
                                                    OriginalData?.deadlineType,
                                                  lastSubmissionDate:
                                                    OriginalData?.lastSubmissionDate,
                                                  costCenterName:
                                                    OriginalData?.costCenterName ||
                                                    materialData?.costCenterName,
                                                  status:
                                                    OriginalData?.status ||
                                                    "Quoted",
                                                },
                                                from: "qc",
                                              },
                                            });
                                          }}
                                          style={{
                                            color: "#2263b3",
                                            fontWeight: "600",
                                            cursor: "pointer",
                                            textDecoration: "underline",
                                          }}
                                        >
                                          {OriginalData?.quotationId}
                                        </a>
                                      ) : (
                                        "N/A"
                                      )}
                                    </div>
                                  </div>
                                )}
                                <div className="data-col align-center pt-1 ">
                                  <div className="data-label w-40">Budget</div>
                                  <div className="data-value w-60 ">
                                    {materialData?.budgetName}
                                  </div>
                                </div>
                                <div className="data-col align-center pt-1 ">
                                  <div className="data-label w-40">
                                    Payment Terms
                                  </div>
                                  <div className="data-value w-60 ">
                                    <Badge color="outline-success">
                                      {materialData?.paymentTerms || "--"}
                                    </Badge>
                                  </div>
                                </div>
                                {materialData?.paymentTerms == "Advance" &&
                                  Array.isArray(materialData?.advanceMilestones) && (() => {
                                    const isAlongWithPO = (ms: any) =>
                                      String(ms?.milestoneName || "").trim().toLowerCase() === "along with the po";
                                    const activeAdvance = materialData.advanceMilestones.filter(
                                      (ms: any) =>
                                        isAlongWithPO(ms) &&
                                        ms.advancePercentage &&
                                        Number(ms.advancePercentage) > 0
                                    );
                                    const activeMilestones = materialData.advanceMilestones.filter(
                                      (ms: any) =>
                                        !isAlongWithPO(ms) &&
                                        ms.advancePercentage &&
                                        Number(ms.advancePercentage) > 0
                                    );
                                    return (
                                      <>
                                        {activeAdvance.length > 0 && (
                                          <div className="data-col align-start pt-1">
                                            <div className="data-label w-40">
                                              Advance Payment
                                            </div>
                                            <div className="data-value w-60">
                                              {activeAdvance.map((ms: any, idx: number) => (
                                                <div key={idx} style={{ marginBottom: 6 }}>
                                                  <div style={{ fontSize: 12, fontWeight: 600 }}>
                                                    {ms.milestoneName} —
                                                    <span className="text-danger" style={{ marginLeft: 4 }}>
                                                      {ms.advancePercentage}%
                                                    </span>
                                                  </div>
                                                  <div style={{ fontSize: 11, color: "#8094ae" }}>
                                                    {[
                                                      ms.bankName && `Bank: ${ms.bankName}`,
                                                      ms.paymentMode && `Mode: ${String(ms.paymentMode).toUpperCase()}`,
                                                      ms.paymentDate && `Date: ${dayjs(ms.paymentDate).format("DD-MMM-YYYY")}`,
                                                      ms.transactionNumber && `Txn: ${ms.transactionNumber}`,
                                                    ]
                                                      .filter(Boolean)
                                                      .join(" | ")}
                                                  </div>
                                                  {ms.remarks && (
                                                    <div style={{ fontSize: 11, color: "#8094ae" }}>
                                                      Remarks: {ms.remarks}
                                                    </div>
                                                  )}
                                                </div>
                                              ))}
                                            </div>
                                          </div>
                                        )}
                                        {activeMilestones.length > 0 && (
                                          <div className="data-col align-start pt-1">
                                            <div className="data-label w-40">
                                              Payment Milestones
                                            </div>
                                            <div className="data-value w-60">
                                              {activeMilestones.map((ms: any, idx: number) => (
                                                <div key={idx} style={{ marginBottom: 6 }}>
                                                  <div style={{ fontSize: 12, fontWeight: 600 }}>
                                                    {ms.milestoneName} —
                                                    <span className="text-danger" style={{ marginLeft: 4 }}>
                                                      {ms.advancePercentage}%
                                                    </span>
                                                  </div>
                                                  {ms.remarks && (
                                                    <div style={{ fontSize: 11, color: "#8094ae" }}>
                                                      Remarks: {ms.remarks}
                                                    </div>
                                                  )}
                                                </div>
                                              ))}
                                            </div>
                                          </div>
                                        )}
                                      </>
                                    );
                                  })()}
                                {materialData?.paymentTerms == "Advance" &&
                                  !Array.isArray(materialData?.advanceMilestones) &&
                                  materialData?.advancePercentage && (
                                    <div className="data-col align-center pt-1 ">
                                      <div className="data-label w-40">
                                        Advance
                                      </div>
                                      <div className="data-value w-60 ">
                                        <span className="change up text-danger">
                                          {materialData?.advancePercentage || "--"}%
                                        </span>
                                      </div>
                                    </div>
                                  )}
                                {(() => {
                                  if (materialData?.paymentTerms === "Cash and Carry") return null;
                                  if (!materialData?.creditDays) return null;
                                  if (materialData?.paymentTerms === "Advance") {
                                    const totalAdvancePct = Array.isArray(materialData?.advanceMilestones)
                                      ? materialData.advanceMilestones.reduce(
                                          (sum: number, ms: any) =>
                                            ms?.advancePercentage && Number(ms.advancePercentage) > 0
                                              ? sum + Number(ms.advancePercentage)
                                              : sum,
                                          0
                                        )
                                      : Number(materialData?.advancePercentage) || 0;
                                    if (totalAdvancePct >= 100) return null;
                                  }
                                  return (
                                    <div className="data-col align-center pt-1 ">
                                      <div className="data-label w-40">
                                        Credit Days
                                      </div>
                                      <div className="data-value w-60 ">
                                        <Badge color="outline-primary">
                                          {materialData?.creditDays || "--"} days
                                        </Badge>
                                      </div>
                                    </div>
                                  );
                                })()}
                                <div className="data-col align-center pt-1">
                                  <div
                                    className="data-label w-40"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "8px",
                                    }}
                                  >
                                    Approvals
                                    {materialData?.conversionRemarks && (
                                      <Popover
                                        content={
                                          <div style={{ maxWidth: "300px" }}>
                                            <strong>Remarks:</strong>{" "}
                                            {materialData?.conversionRemarks}
                                          </div>
                                        }
                                        title=""
                                      >
                                        <InfoCircleOutlined
                                          style={{
                                            color: "#2263b3",
                                            cursor: "pointer",
                                            fontSize: "12px",
                                          }}
                                        />
                                      </Popover>
                                    )}
                                  </div>
                                  <div className="data-value w-60">
                                    <ApprovalTimelineContent />
                                  </div>
                                </div>
                              </div>
                              <div className="w-30 paddingLeft10">
                                <div className="data-col align-center pt-1 ">
                                  <div
                                    className="data-label w-40"
                                    style={{ whiteSpace: "nowrap" }}
                                  >
                                    Cost Center
                                  </div>
                                  <div
                                    className="data-value w-60 "
                                    style={{ marginLeft: "16px" }}
                                  >
                                    {materialData?.costCenterName || "--"}
                                  </div>
                                </div>

                                <div className="data-col align-center pt-1 ">
                                  <div
                                    className="data-label w-40"
                                    style={{ whiteSpace: "nowrap" }}
                                  >
                                    Ledger
                                  </div>
                                  <div
                                    className="data-value w-60 "
                                    style={{ marginLeft: "16px" }}
                                  >
                                    {materialData?.ledgerName || "--"}
                                  </div>
                                </div>

                                <div className="data-col align-center pt-1 ">
                                  <div
                                    className="data-label w-40"
                                    style={{ whiteSpace: "nowrap" }}
                                  >
                                    Department
                                  </div>
                                  <div
                                    className="data-value w-60 "
                                    style={{ marginLeft: "16px" }}
                                  >
                                    {materialData?.departmentName || "--"}
                                  </div>
                                </div>
                                {OriginalData?.transferFromOrderId && (
                                  <>
                                    <div className="data-col align-center pt-1 ">
                                      <div
                                        className="data-label w-40"
                                        style={{ whiteSpace: "nowrap" }}
                                      >
                                        Transfer From PO
                                      </div>
                                      <div
                                        className="data-value w-60 "
                                        style={{ marginLeft: "16px" }}
                                      >
                                        {OriginalData?.transferFromOrderSequenceId ||
                                          "--"}
                                      </div>
                                    </div>
                                    <div className="data-col align-center pt-1 ">
                                      <div
                                        className="data-label w-40"
                                        style={{ whiteSpace: "nowrap" }}
                                      >
                                        Transfer Date
                                      </div>
                                      <div
                                        className="data-value w-60 "
                                        style={{ marginLeft: "16px" }}
                                      >
                                        {OriginalData?.transferDate
                                          ? dayjs(
                                            OriginalData.transferDate
                                          ).format("DD-MMM-YYYY")
                                          : "--"}
                                      </div>
                                    </div>
                                    <div className="data-col align-center pt-1 ">
                                      <div
                                        className="data-label w-40"
                                        style={{ whiteSpace: "nowrap" }}
                                      >
                                        Transfer Reason
                                      </div>
                                      <div
                                        className="data-value w-60 "
                                        style={{ marginLeft: "16px" }}
                                      >
                                        {OriginalData?.transferReason || "--"}
                                      </div>
                                    </div>
                                    <div className="data-col align-center pt-1 ">
                                      <div
                                        className="data-label w-40"
                                        style={{ whiteSpace: "nowrap" }}
                                      >
                                        Transfer From Supplier
                                      </div>
                                      <div
                                        className="data-value w-60 "
                                        style={{ marginLeft: "24px" }}
                                      >
                                        {OriginalData?.transferFromSupplierName ||
                                          "--"}
                                      </div>
                                    </div>
                                  </>
                                )}
                              </div>
                            </Col>
                          </div>
                        )}
                        {tab === "2" && (
                          <div
                            className={`tab-pane${tab === "2" && " active"}`}
                          >
                            <Col className="justify-start w-100  flex-wrap mt-3 p-3">
                              <div className="w-25 border-end">
                                <div className="data-col align-center pt-1">
                                  <div className="data-label w-50">
                                    Inward Required
                                  </div>
                                  <div className="data-value w-50">
                                    {materialData?.inwardRequired ? (
                                      <Badge color="outline-success">Yes</Badge>
                                    ) : (
                                      <Badge color="outline-danger">No</Badge>
                                    )}
                                  </div>
                                </div>
                                <div className="data-col align-center pt-1">
                                  <div className="data-label w-50">
                                    Line Level Delivery
                                  </div>
                                  <div className="data-value w-50">
                                    {materialData?.needByDateType !=
                                      "Order Level" ? (
                                      <Badge color="outline-success">Yes</Badge>
                                    ) : (
                                      <Badge color="outline-danger">No</Badge>
                                    )}
                                  </div>
                                </div>

                                <div className="data-col align-center pt-1">
                                  <div className="data-label w-50">
                                    Delivery Type
                                  </div>
                                  <div className="data-value w-50">
                                    {materialData?.deliveryAddressType || "--"}
                                  </div>
                                </div>

                                {materialData?.needByDateType ==
                                  "Order Level" && (
                                    <div className="data-col pt-1">
                                      <div className="data-label w-50">
                                        Delivery Date
                                      </div>
                                      <div className="data-value w-50">
                                        {/* <Badge color="outline-primary"> */}
                                        {dayjs(materialData?.needByDate).format(
                                          "DD-MMM-YYYY"
                                        )}
                                        {/* </Badge> */}
                                      </div>
                                    </div>
                                  )}
                              </div>
                              <div className="w-25 border-end paddingLeft10">
                                <div className=" pt-1">
                                  <div className="data-label w-90 mb-1">
                                    Billing Address
                                  </div>
                                  <div className="data-value w-90">
                                    <ShowAddressPopOver
                                      type={"billing"}
                                      id={materialData?.billingAddressId}
                                    />
                                  </div>
                                </div>
                              </div>
                              {materialData?.deliveryAddressId && (
                                <div className="w-25 border-end paddingLeft10 ">
                                  <div className=" pt-1">
                                    <div className="data-label w-90 mb-1">
                                      Delivery Address
                                    </div>
                                    <div className="data-value w-90">
                                      <ShowAddressPopOver
                                        type={"delivery"}
                                        id={materialData?.deliveryAddressId}
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}
                              <div className="w-25 paddingLeft10">
                                <div className="  pt-1">
                                  <div className="data-label w-90 mb-1">
                                    Supplier Info
                                  </div>
                                  <div className="data-value w-100">
                                    <ShowSupplierInfo
                                      id={materialData?.supplierId}
                                    />
                                  </div>
                                </div>
                              </div>{" "}
                            </Col>
                          </div>
                        )}
                      </div>
                    </Panel>
                    <Panel header="Material Information" key="2">
                      <div className="table-responsive poTable">
                        <div
                          style={{
                            width:
                              screenSize -
                              (extra?.reduceTableWidth || 380) +
                              "px",
                            margin: "15px auto",
                          }}
                        >
                          <Table
                            className="customTable"
                            columns={
                              configColumns(
                                taxConfiguration,
                                currency,
                                poStatus,
                                materialData?.lineItems,
                                OriginalData
                              ) as any
                            }
                            dataSource={[
                              ...materialData?.lineItems?.map(
                                (item: any, index: any) => ({
                                  ...item,
                                  key: index,
                                })
                              ),
                              {
                                key: "lastRow",
                                materialName: "Total",
                                quantity: 0,
                                unitPrice: 0,
                                amount: 0,
                              },
                            ]}
                            scroll={{ x: 1000 }}
                            expandable={{
                              expandedRowRender: (record: any) => {
                                if (record?.key == "lastRow") {
                                  return <></>;
                                }
                                return (
                                  <div className="expandableBody">
                                    <div style={{ flex: 1, textAlign: "left" }}>
                                      <p style={{ margin: 0 }}>
                                        {record.description}
                                      </p>
                                      {record.attachment && (
                                        <div>
                                          <PaperClipOutlined /> &nbsp;
                                          {record?.file[0]?.name ? (
                                            <a
                                              href={URL.createObjectURL(
                                                record.file[0]
                                              )}
                                              download={record.file[0]?.name}
                                            >
                                              {record.file[0]?.name}
                                            </a>
                                          ) : (
                                            <a
                                              href={record?.file?.filePath}
                                              download={record?.file?.filePath}
                                              target="_blank"
                                            >
                                              {record?.file?.fileName}
                                            </a>
                                          )}
                                        </div>
                                      )}
                                    </div>
                                    {materialData?.deliveryAddressType ===
                                      "Line Level" &&
                                      record.deliveryAddressId && (
                                        <div
                                          className="lineAddress"
                                          style={{ flex: 1 }}
                                        >
                                          <h6>Delivery Address</h6>
                                          <ShowAddressPopOver
                                            id={record.deliveryAddressId}
                                          />
                                        </div>
                                      )}
                                  </div>
                                );
                              },
                            }}
                            locale={{
                              emptyText: (
                                <span
                                  style={{
                                    height: "300px",
                                    color: "#333",
                                    fontSize: "16px",
                                  }}
                                >
                                  Please click on "Add New Item" to add purchase
                                  order lines.
                                </span>
                              ),
                            }}
                            bordered
                            size="middle"
                            pagination={false}
                          />
                        </div>
                        <Row
                          style={{
                            margin: "20px",
                          }}
                        >
                          <Col
                            className={`${poStatus == "Pending Approval" &&
                              allowedActions?.edit == 1
                              ? "justify-between"
                              : "justify-end"
                              }`}
                          >
                            {(poStatus == "Pending Approval" || poStatus == "Rejected") &&
                              allowedActions?.edit == 1 ? (
                              <a
                                onClick={() => {
                                  setAddNewRowModel(true);
                                  setEditLineRow(null);
                                }}
                                href="#add"
                                className="addNewItem"
                              >
                                <Icon name="plus-round" />
                                <span>Add New Item</span>
                              </a>
                            ) : (
                              <></>
                            )}
                            <div className="w-40">
                              <div className="d-flex justify-content-between">
                                <div className="w-50 justify-end">
                                  <strong>Taxable Amount</strong>
                                </div>
                                <span className="r_align">
                                  {FormatCurrency(
                                    materialData?.lineItems?.reduce(
                                      (a: any, b: any) =>
                                        a +
                                        Number(b.quantity) *
                                        Number(b.unitPrice),
                                      0
                                    ),
                                    currency?.currency_code
                                  )}
                                </span>
                              </div>
                              {taxConfiguration?.gstType == "CGST+SGST" ? (
                                <>
                                  <div className="d-flex justify-content-between">
                                    <div className="w-50 justify-end">
                                      <strong>CGST</strong>
                                    </div>
                                    <span className="r_align">
                                      {FormatCurrency(
                                        materialData?.lineItems?.reduce(
                                          (a: any, b: any) =>
                                            a + Number(b.cgst),
                                          0
                                        ),
                                        currency?.currency_code
                                      )}
                                    </span>
                                  </div>
                                  <div className="d-flex justify-content-between">
                                    <div className="w-50 justify-end">
                                      <strong>SGST</strong>
                                    </div>
                                    <span className="r_align">
                                      {FormatCurrency(
                                        materialData?.lineItems?.reduce(
                                          (a: any, b: any) =>
                                            a + Number(b.sgst),
                                          0
                                        ),
                                        currency?.currency_code
                                      )}
                                    </span>
                                  </div>
                                </>
                              ) : (
                                <div className="d-flex justify-content-between">
                                  <div className="w-50 justify-end">
                                    <strong>IGST</strong>
                                  </div>
                                  <span className="r_align">
                                    {FormatCurrency(
                                      materialData?.lineItems?.reduce(
                                        (a: any, b: any) => a + Number(b.igst),
                                        0
                                      ),
                                      currency?.currency_code
                                    )}
                                  </span>
                                </div>
                              )}
                              <div
                                className="d-flex justify-content-between"
                                style={{
                                  fontSize: "18px",
                                  marginTop: "10px",
                                }}
                              >
                                <div className="w-50 justify-end">
                                  <strong>Total</strong>
                                </div>
                                <strong className="r_align">
                                  {FormatCurrency(
                                    materialData?.lineItems?.reduce(
                                      (a: any, b: any) =>
                                        a + Number(b.grossTotal),
                                      0
                                    ),
                                    currency?.currency_code
                                  )}
                                </strong>
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row className="m-4 justify-content-end ">
                          {signature?.isActive && (
                            <div className="signatureBtnWrapper">
                              <div className="d-flex justify-content-between align-items-center">
                                <strong>Signature</strong>
                              </div>
                              <div
                                style={{
                                  minHeight: signature?.image ? "0px" : "120px",
                                  display: signature?.image ? "block" : "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                {signature?.image && (
                                  <>
                                    <div className="signatueImgWrapper border">
                                      <img
                                        src={signature?.image}
                                        alt="Signed"
                                        style={{ width: "160px" }}
                                      />
                                    </div>

                                    <div>
                                      <div className="form-group">
                                        <label
                                          className="form-label"
                                          htmlFor="signatureLabel"
                                        >
                                          Signature Label
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="signatureLabel"
                                          onChange={(e) => { }}
                                          disabled
                                          defaultValue={
                                            signature?.label ||
                                            "Authorised Signatory"
                                          }
                                        />
                                      </div>
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                          )}
                        </Row>
                      </div>
                    </Panel>
                    <Panel header="Other Information" key="3">
                      <Descriptions
                        title=""
                        className="custom-description-title"
                      >
                        <Descriptions.Item label="Instructions">
                          <span
                            style={{
                              color: "#2263b3",
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                            onClick={() => setInstructionsVisible(true)}
                          >
                            View
                          </span>
                        </Descriptions.Item>
                        <Descriptions.Item label="Terms and Conditions">
                          <span
                            style={{
                              color: "#2263b3",
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                            onClick={() => setTermsVisible(true)}
                          >
                            View
                          </span>
                        </Descriptions.Item>

                        <Descriptions.Item label="">
                          <div>
                            <strong
                              className=""
                              style={{
                                display: "flex",
                                whiteSpace: "nowrap",
                              }}
                            >
                              Attachments &nbsp; <PaperClipOutlined />
                              {attachments?.length === 0 &&
                                newAttachments?.length === 0 && (
                                  <div> : N/A</div>
                                )}
                            </strong>
                            <div>
                              {attachments?.length > 0 &&
                                attachments?.map(
                                  (attachment: any, index: number) => (
                                    <div
                                      key={index}
                                      className="w-100 d-flex justify-content-between"
                                    >
                                      <div>
                                        <strong>{index + 1}.</strong>
                                        &nbsp;
                                        {attachment.name}
                                        &nbsp; &nbsp; &nbsp; &nbsp;
                                      </div>
                                      <div>
                                        <a
                                          href={attachment.link}
                                          download={attachment.link}
                                          target="_blank" // Opens in a new tab
                                          rel="noopener noreferrer" // Adds security
                                          style={{
                                            color: "black",
                                            fontSize: "18px",
                                          }}
                                        >
                                          <DownloadOutlined />
                                        </a>
                                        &nbsp; &nbsp;
                                        {["Pending Approval", "Rejected"].includes(
                                          poStatus
                                        ) && allowedActions?.edit == 1 ? (
                                          <a
                                            style={{
                                              color: "red",
                                              fontSize: "16px",
                                            }}
                                            onClick={() => {
                                              setDeletedAttachments(
                                                (prev: any) => [
                                                  ...prev,
                                                  { docId: attachment?.docId },
                                                ]
                                              );
                                              let updatedAttachmentsList =
                                                attachments?.filter(
                                                  (item: any, i: number) =>
                                                    i != index
                                                );
                                              setAttachments(
                                                updatedAttachmentsList
                                              );
                                              setShowSubmitBtm(true);
                                            }}
                                          >
                                            <DeleteOutlined />
                                          </a>
                                        ) : (
                                          <></>
                                        )}
                                      </div>
                                    </div>
                                  )
                                )}
                              {newAttachments?.map(
                                (attachment: any, index: number) => (
                                  <div
                                    key={index}
                                    className="w-100 d-flex justify-content-between"
                                  >
                                    <div>
                                      <strong>
                                        {attachments?.length + index + 1}.
                                      </strong>
                                      &nbsp;
                                      {attachment?.name}
                                      &nbsp; &nbsp; &nbsp; &nbsp;
                                    </div>
                                    <div>
                                      <a
                                        href={attachment.link}
                                        download={attachment.link}
                                        style={{
                                          color: "black",
                                          fontSize: "18px",
                                        }}
                                      >
                                        <DownloadOutlined />
                                      </a>
                                      &nbsp; &nbsp;
                                      <a
                                        style={{
                                          color: "red",
                                          fontSize: "16px",
                                        }}
                                        onClick={() => {
                                          setNewAttachments((prev: any) =>
                                            prev.filter(
                                              (item: any, i: number) =>
                                                i != index
                                            )
                                          );
                                          setShowSubmitBtm(true);
                                        }}
                                      >
                                        <DeleteOutlined />
                                      </a>
                                    </div>
                                  </div>
                                )
                              )}
                              {["Pending Approval", "Rejected"].includes(poStatus) &&
                                allowedActions?.edit == 1 ? (
                                <div className="mt-1">
                                  <Dragger
                                    beforeUpload={beforeUpload}
                                    fileList={[]}
                                    onChange={handleAttachmentChange}
                                  >
                                    <a
                                      onClick={() => { }}
                                      className="addNewItem"
                                    >
                                      <Icon name="plus-round" />
                                      <span>Add Attachment</span>
                                    </a>
                                  </Dragger>
                                </div>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        </Descriptions.Item>
                      </Descriptions>
                    </Panel>
                  </AntCollapse>

                  <Block>
                    {showSignatureModel && (
                      <SignatureModal
                        modal={showSignatureModel}
                        toggle={() => {
                          setShowSignatureModel(false);
                          if (activeSignatureContext === "APPROVE") {
                            setIsModalApproveVisible(true);
                            setDisableApprove(false);
                          } else if (activeSignatureContext === "REJECT") {
                            setIsModalRejectedVisible(true);
                            setDisableReject(false);
                          }
                        }}
                        onSave={(data: string) => {
                          if (activeSignatureContext === "APPROVE") {
                            setApproveSignature((prev: any) => ({ ...prev, image: data }));
                            setIsModalApproveVisible(true);
                            setDisableApprove(false);
                          } else if (activeSignatureContext === "REJECT") {
                            setRejectSignature((prev: any) => ({ ...prev, image: data }));
                            setIsModalRejectedVisible(true);
                            setDisableReject(false);
                          }
                          setShowSignatureModel(false);
                        }}
                      />
                    )}
                    {showCropModel && (
                      <CropperComponent
                        modal={showCropModel}
                        toggle={() => {
                          setShowCropModel(false);
                          if (activeSignatureContext === "APPROVE") {
                            setIsModalApproveVisible(true);
                            setDisableApprove(false);
                          } else if (activeSignatureContext === "REJECT") {
                            setIsModalRejectedVisible(true);
                            setDisableReject(false);
                          }
                        }}
                        onSave={(data: string) => {
                          if (activeSignatureContext === "APPROVE") {
                            setApproveSignature((prev: any) => ({ ...prev, image: data }));
                            setIsModalApproveVisible(true);
                            setDisableApprove(false);
                          } else if (activeSignatureContext === "REJECT") {
                            setRejectSignature((prev: any) => ({ ...prev, image: data }));
                            setIsModalRejectedVisible(true);
                            setDisableReject(false);
                          }
                          setShowCropModel(false);
                        }}
                      />
                    )}
                    {addNewRowModel && (
                      <MaterialModal
                        modal={addNewRowModel}
                        closeModal={() => {
                          setAddNewRowModel(false);
                          setEditLineRow(null);
                        }}
                        materialCategoryOptions={materialCategoryOptions}
                        status={materialData?.orderStatus}
                        formData={{
                          action: editLineRow == null ? "add" : "edit",
                          index: editLineRow?.uuid,
                          item: editLineRow,
                        }}
                        taxConfiguration={taxConfiguration}
                        append={(data: any) => {
                          // Check if we're in Transfer PO drawer context
                          if (transferPoDrawerVisible) {
                            // Add to invoiceableLines for Transfer PO drawer
                            const _data = invoiceableLines.find((item: any) => {
                              if (
                                item.materialId == data.materialId &&
                                item.siteStructureUnitId == data.siteStructureUnitId &&
                                item.floorNo == data.floorNo &&
                                item.siteStructureSubUnitId == data.siteStructureSubUnitId &&
                                item.locationId == data.locationId &&
                                dayjs(item.needByDate).format("DD-MMM-YYYY") ==
                                dayjs(data.needByDate).format("DD-MMM-YYYY") &&
                                item.deliveryAddressId == data.deliveryAddressId
                              )
                                return true;
                            });

                            if (_data) {
                              Swal.fire({
                                icon: "error",
                                title: "Error",
                                text: "Material Already Added",
                              });
                              return;
                            }

                            setInvoiceableLines([...invoiceableLines, { ...data, key: data.uuid }]);
                            setAddNewRowModel(false);
                            setEditLineRow(null);
                            return;
                          }

                          // Original logic for main PO editing
                          let newLineItems = materialData?.lineItems;
                          const _data = newLineItems.find((item: any) => {
                            if (
                              item.materialId == data.materialId &&
                              item.siteStructureUnitId == data.siteStructureUnitId &&
                              item.floorNo == data.floorNo &&
                              item.siteStructureSubUnitId == data.siteStructureSubUnitId &&
                              item.locationId == data.locationId &&
                              dayjs(item.needByDate).format("DD-MMM-YYYY") ==
                              dayjs(data.needByDate).format("DD-MMM-YYYY") &&
                              item.deliveryAddressId == data.deliveryAddressId
                            )
                              return true;
                          });

                          if (_data) {
                            Swal.fire({
                              icon: "error",
                              title: "Error",
                              text: "Material Already Added",
                            });
                            return;
                          }

                          setMaterialData((pre: any) => {
                            let { lineItems } = pre;
                            lineItems?.push(data);
                            return { ...pre, lineItems };
                          });
                          setShowSubmitBtm(true);
                        }}
                        update={(id: any, data: any) => {
                          // Check if we're in Transfer PO drawer context
                          if (transferPoDrawerVisible) {
                            // Update invoiceableLines for Transfer PO drawer
                            const updatedInvoiceableLines = invoiceableLines.map((item: any, index: number) => {
                              // Match by uuid or key (id is the uuid from MaterialModal)
                              if (item.uuid == id || (editLineRow && editLineRow.uuid == item.uuid) || (editLineRow && editLineRow === item)) {
                                // Preserve the key and important fields (quantityInvoiced, originalQuantityTransferred, original quantity)
                                return { 
                                  ...item, // Preserve all original fields first
                                  ...data, // Then apply updates
                                  key: item.key !== undefined ? item.key : index,
                                  uuid: data.uuid || item.uuid || id,
                                  // Preserve quantityInvoiced from original item
                                  quantityInvoiced: item.quantityInvoiced !== undefined ? item.quantityInvoiced : (data.quantityInvoiced || 0),
                                  // Preserve originalQuantityTransferred from original item
                                  originalQuantityTransferred: item.originalQuantityTransferred !== undefined ? item.originalQuantityTransferred : (data.originalQuantityTransferred !== undefined ? data.originalQuantityTransferred : 0),
                                  // Preserve original quantity (not the available quantity that was edited)
                                  quantity: item.quantity !== undefined ? item.quantity : (data.quantity || 0),
                                  // Update quantityTransferred with the new value from form (available qty that user edited)
                                  quantityTransferred: data.quantityTransferred !== undefined ? data.quantityTransferred : item.quantityTransferred,
                                };
                              }
                              return item;
                            });
                            setInvoiceableLines(updatedInvoiceableLines);
                            setAddNewRowModel(false);
                            setEditLineRow(null);
                            return;
                          }

                          // Original logic for main PO editing
                          let newLineItems = materialData?.lineItems;
                          const _data = newLineItems
                            .filter((item: any) => item.uuid != id)
                            .find((item: any) => {
                              console.log(
                                item.materialId,
                                data.materialId,
                                item.needByDate,
                                data.needByDate,
                                item.deliveryAddressId,
                                item.deliveryAddressId
                              );

                              if (
                                item.materialId == data.materialId &&
                                item.siteStructureUnitId == data.siteStructureUnitId &&
                                item.floorNo == data.floorNo &&
                                item.siteStructureSubUnitId == data.siteStructureSubUnitId &&
                                item.locationId == data.locationId &&
                                dayjs(item.needByDate).format("DD-MMM-YYYY") ==
                                dayjs(data.needByDate).format(
                                  "DD-MMM-YYYY"
                                ) &&
                                item.deliveryAddressId == data.deliveryAddressId
                              )
                                return true;
                            });

                          if (_data) {
                            Swal.fire({
                              icon: "error",
                              title: "Error",
                              text: " Material Already Added",
                            });
                            return;
                          }

                          newLineItems = newLineItems.map((item: any) => {
                            if (item.uuid == id) {
                              return data;
                            }
                            return item;
                          });
                          setMaterialData((pre: any) => {
                            let newData = { ...pre, lineItems: newLineItems };
                            return newData;
                          });
                          setShowSubmitBtm(true);
                        }}
                        materialsList={
                          transferPoDrawerVisible
                            ? invoiceableLines
                            : materialData?.lineItems
                        }
                        needByDateType={materialData?.needByDateType}
                        deliveryAddressType={materialData?.deliveryAddressType}
                        siteId={materialData?.siteId}
                        segmentLevel={materialData?.segmentLevel}
                        isTransferPoContext={transferPoDrawerVisible}
                        boqData={boqData}
                      />
                    )}
                    {changeToBuyerData && (
                      <ChangeToBuyerDrawer
                        changeToBuyerData={changeToBuyerData}
                        needByDateType={materialData?.needByDateType}
                        drawerVisible={changeToBuyerData != null}
                        closeDrawer={() => {
                          setChangeToBuyerData(null);
                        }}
                        FormatCurrency={(value: any) =>
                          FormatCurrency(value, currency?.currency_code)
                        }
                      />
                    )}
                  </Block>
                </div>
              </div>
            )}
          </div>
        </Card>
      </Content>
      {showEmailModal && (
        <EmailCreationModal
          modal={showEmailModal}
          toggle={() => setShowEmailModal(!showEmailModal)}
          sendEmail={TriggerEmail}
          body={
            <div className="w-100 p-2">
              <div className="m-auto">
                <img
                  src={currentUser?.orgLogo}
                  alt={currentUser?.orgName}
                  width="200"
                  style={{ marginTop: "20px" }}
                />
                {/* <p style={{ fontStyle: "italic", color: "#2263b3" }}>
                    Simplifying Complexities
                  </p> */}
                <div style={{ backgroundColor: "#fff", padding: "15px" }}>
                  {/* <h2 style={{ color: "#2263b3" }}>New Purchase Order</h2> */}
                  <p style={{ color: "#1ee0ac", fontSize: "20px" }}>
                    Dear {OriginalData?.supplierName},
                  </p>
                  <p>
                    We are pleased to inform you that a new Purchase Order (
                    <strong>{OriginalData?.orderId}</strong>) has been generated
                    for your review.
                  </p>

                  <p>
                    <strong>Order Summary: </strong>
                  </p>
                  <p>
                    <strong>PO Number: </strong>
                    {OriginalData?.orderId}
                  </p>
                  <p>
                    <strong>Order Date: </strong>
                    {dayjs(OriginalData?.orderDate).format("DD-MMM-YYYY")}
                  </p>
                  <p>
                    <strong>Delivery Address: </strong>{" "}
                    {returnPoDetails()?.deliveryAddressString}
                  </p>
                  <p>
                    <strong>Total Amount: </strong>{" "}
                    {FormatCurrency(
                      OriginalData?.lineItems?.reduce(
                        (a: any, b: any) => a + Number(b.grossTotal || 0),
                        0
                      ) || 0,
                      currency?.currency_code
                    )}
                  </p>

                  <p>
                    Please review the attached document for full order details
                    and confirm receipt.
                  </p>
                  <p>
                    If you have any questions or need further assistance, feel
                    free to reach out to us at{" "}
                    <a href={`mailto:{${currentUser?.email}}}`}>
                      {currentUser?.email}
                    </a>
                    .
                  </p>

                  <p>
                    This is an automatically generated email. Please do not
                    reply directly to this email.
                  </p>
                </div>
                {/* <p
                  style={{
                    marginTop: "20px",
                    fontSize: "12px",
                    color: "#000",
                  }}
                >
                  Copyright © {dayjs().format("DD-MMM-YYYY")} Procurex
                  Technologies PVT LTD. All rights reserved.
                </p> */}
              </div>
            </div>
          }
          defaultAttachments={Object.assign({}, pdfBlobData.current, {
            name: OriginalData?.orderId + ".pdf",
            type: "application/pdf",
          })}
        />
      )}

      <AntModal
        title={undefined}
        visible={instructionsVisible}
        footer={null}
        onCancel={() => {
          setIsInstructionsChanged(false);
          setInstructionsVisible(false);
        }}
        width="60%"
        bodyStyle={{ maxHeight: "70vh", overflowY: "auto" }}
      >
        <div className="d-flex">
          <h5 className="m-3">Instructions </h5>
          {!isInstructionsChanged &&
            ["Pending Approval", "Rejected"].includes(poStatus) &&
            allowedActions?.edit == 1 && (
              <EditOutlined onClick={() => setIsInstructionsChanged(true)} />
            )}
        </div>
        {["Pending Approval", "Rejected"].includes(poStatus) &&
          allowedActions?.edit == 1 &&
          isInstructionsChanged ? (
          <FormProvider {...methods}>
            <form>
              <div className="mt-1 mb-3">
                <FormTextArea
                  name="instructions"
                  label=""
                  placeholder="Enter Instructions"
                  required
                  rows={10}
                  defaultValue={newInstructions}
                />
              </div>
            </form>
          </FormProvider>
        ) : instructions ? (
          <pre className="m-3">{instructions || ""}</pre>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "200px",
            }}
          >
            <Empty description="No Instructions Available for this Purchase Order" />
          </div>
        )}
        {isInstructionsChanged && (
          <ul className="actions clearfix d-flex">
            <li>
              <Button
                color="primary"
                type="submit"
                onClick={() => {
                  setInstructionsVisible(false);
                  setIsInstructionsChanged(true);
                  setShowSubmitBtm(true);
                }}
              >
                Submit
              </Button>
            </li>
            <li className="m-3 mt-0">
              <Button
                color="primary"
                onClick={() => {
                  setIsInstructionsChanged(false);
                  setNewInstructions(instructions);
                }}
                className="btn-dim btn btn-secondary"
              >
                Cancel
              </Button>
            </li>
          </ul>
        )}
      </AntModal>
      <AntModal
        title={undefined}
        visible={termsVisible}
        footer={null}
        onCancel={() => {
          setIsTermsAndConditionsChanged(false);
          setTermsVisible(false);
        }}
        width="60%"
        bodyStyle={{ maxHeight: "70vh", overflowY: "auto" }}
      >
        <div className="d-flex">
          <h5 className="m-3">Terms and Conditions</h5>
          {!isTermsAndConditionsChanged &&
            ["Pending Approval", "Rejected"].includes(poStatus) &&
            allowedActions?.edit == 1 && (
              <EditOutlined
                onClick={() => setIsTermsAndConditionsChanged(true)}
              />
            )}
        </div>
        {["Pending Approval", "Rejected"].includes(poStatus) &&
          allowedActions?.edit == 1 &&
          isTermsAndConditionsChanged ? (
          <FormProvider {...methods}>
            <form>
              <div className="mt-1 mb-3">
                <FormTextArea
                  defaultValue={newTermsAndConditions}
                  name="termsAndConditions"
                  label=""
                  placeholder="Enter Terms and Conditions"
                  required
                  rows={10}
                />
              </div>
            </form>
          </FormProvider>
        ) : termsAndConditions ? (
          <pre className="m-3">{termsAndConditions || ""}</pre>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "200px",
            }}
          >
            <Empty description="No Terms and Conditions Available for this Purchase Order" />
          </div>
        )}

        {isTermsAndConditionsChanged && (
          <ul className="actions clearfix d-flex">
            <li>
              <Button
                color="primary"
                type="submit"
                onClick={() => {
                  setTermsVisible(false);
                  setIsTermsAndConditionsChanged(true);
                  setShowSubmitBtm(true);
                }}
              >
                Submit
              </Button>
            </li>
            <li className="m-3 mt-0">
              <Button
                color="primary"
                onClick={() => {
                  setIsTermsAndConditionsChanged(false);
                  setNewTermsAndConditions(termsAndConditions);
                }}
                className="btn-dim btn btn-secondary"
              >
                Cancel
              </Button>
            </li>
          </ul>
        )}
      </AntModal>

      {transferPoDrawerVisible && (
        <Drawer
          title={
            <div className="d-flex justify-content-between align-items-center">
              <strong>Transfer PO</strong>
              <div style={{ textAlign: "right" }}>
                {disableSubmit ? (
                  <Button color="primary" type="button">
                    <Spinner size="sm" color="light" />
                  </Button>
                ) : (
                  <Button
                    type="submit"
                    form="transferPoForm"
                    color="primary"
                    className="m-3 mt-0 mb-0"
                  >
                    Transfer
                  </Button>
                )}
              </div>
            </div>
          }
          placement="right"
          onClose={closeTransferPoDrawer}
          open={transferPoDrawerVisible}
          width="85vw"
          style={{
            position: "absolute",
            zIndex: 1100,
          }}
          styles={{
            body: { paddingBottom: 80, paddingTop: 20 },
            header: { padding: "8px 24px" },
          }}
        >
          <FormProvider {...drawerMethods}>
            <form
              id="transferPoForm"
              onSubmit={handleDrawerSubmit(async (formData) => {
                setDisableSubmit(true);
                Swal.fire({
                  title: "Are you sure?",
                  text: "You are about to transfer this PO!",
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#3085d6",
                  cancelButtonColor: "#d33",
                  confirmButtonText: "Yes, Transfer PO!",
                }).then(async (result) => {
                  if (result.isConfirmed) {
                    try {
                      // Determine if orderNumber field is shown (sequence not available)
                      const isOrderNumberFieldShown =
                        (sequenceAccess?.level == "Site" &&
                          !sequenceAccess?.siteIds?.includes(
                            OriginalData?.siteId?.toString()
                          )) ||
                        sequenceAccess?.module == "";

                      // Format lineItems from invoiceableLines to match orderData structure
                      // Filter out lines with available quantity = 0 and use Available Qty value
                      const lineItems = invoiceableLines
                        ?.filter((item: any) => {
                          // If user has edited quantity in modal, use that edited quantity (quantityTransferred) directly
                          if (item?.quantityTransferred !== undefined && item?.quantityTransferred !== null) {
                            return Number(item.quantityTransferred) > 0;
                          }
                          // Otherwise calculate available qty
                          const qty = Number(item.quantity) || 0;
                          const invoicedQty = Number(item.quantityInvoiced) || 0;
                          const originalTransferredQty = Number(item.originalQuantityTransferred !== undefined ? item.originalQuantityTransferred : 0) || 0;
                          const availableQty = qty - invoicedQty - originalTransferredQty;
                          return availableQty > 0;
                        })
                        ?.map((item: any, index: number) => {
                          // If user has edited quantity in modal, use that edited quantity (quantityTransferred) directly
                          // This is the quantity that should be transferred
                          if (item?.quantityTransferred !== undefined && item?.quantityTransferred !== null) {
                            return {
                              lineNo: item.lineNo || index + 1,
                              materialId: Number(item.materialId),
                              hsnCode: item.hsnCode ? Number(item.hsnCode) : undefined,
                              quantity: Number(item.quantityTransferred) > 0 ? Number(item.quantityTransferred) : 0, // Use edited quantity from modal
                              unitPrice: Number(item.unitPrice),
                            };
                          }
                          // Otherwise calculate available qty (fallback for items not edited)
                          const qty = Number(item.quantity) || 0;
                          const invoicedQty = Number(item.quantityInvoiced) || 0;
                          const originalTransferredQty = Number(item.originalQuantityTransferred !== undefined ? item.originalQuantityTransferred : 0) || 0;
                          const availableQty = qty - invoicedQty - originalTransferredQty;
                          
                          return {
                            lineNo: item.lineNo || index + 1,
                            materialId: Number(item.materialId),
                            hsnCode: item.hsnCode ? Number(item.hsnCode) : undefined,
                            quantity: availableQty > 0 ? availableQty : 0, // Use calculated Available Qty value
                            unitPrice: Number(item.unitPrice),
                          };
                        }) || [];

                      // Format filesData for attachments and signature
                      const filesData: any[] = [];
                      const files: File[] = [];
                      let fileIndex = 0;

                      // Add invoice attachments
                      invoiceAttachments?.forEach((attachment: any) => {
                        if (attachment?.originFileObj) {
                          filesData.push({
                            indexOfFileLocated: fileIndex++,
                            module: "po",
                            level: "Header Level",
                            purpose: "attachments",
                            action: "Create",
                            docId: null,
                          });
                          files.push(attachment.originFileObj);
                        }
                      });

                      // Add signature if present
                      if (invoiceSignature?.image) {
                        const signatureFile = dataURLToFile(
                          invoiceSignature.image,
                          "signature.png"
                        );
                        files.push(signatureFile);
                        filesData.push({
                          indexOfFileLocated: fileIndex++,
                          module: "po",
                          level: "Header Level",
                          purpose: "signature",
                          action: "Create",
                          docId: null,
                          signatureLabel: invoiceSignature?.label || "Authorised Signatory",
                        });
                      }

                      // Get orderNumber from the previous view (orderNumber prop) and convert to number
                      const orderNumberFromView = orderNumber ? Number(orderNumber) : null;
                      if (orderNumberFromView !== null && isNaN(orderNumberFromView)) {
                        throw new Error("Invalid order number format");
                      }

                      // Determine orderId value - prioritize formData.orderNumber if provided
                      // Order ID can be either a number or a string (alphanumeric like "TRS/2026/22-1")
                      let orderIdValue: number | string | null = null;
                      
                      // First check if formData.orderNumber has a value (including 0)
                      if (formData.orderNumber !== undefined && formData.orderNumber !== null && formData.orderNumber !== "") {
                        const orderNumberStr = String(formData.orderNumber).trim();
                        if (orderNumberStr !== "") {
                          // Try to parse as number first
                          const parsed = Number(orderNumberStr);
                          if (!isNaN(parsed)) {
                            // If it's a valid number, use it as number
                            orderIdValue = parsed;
                          } else {
                            // If it's not a valid number (alphanumeric string), use it as string
                            orderIdValue = orderNumberStr;
                          }
                        }
                      }
                      
                      // If formData doesn't have a value and field is not shown, use OriginalData.orderId
                      if (orderIdValue === null && !isOrderNumberFieldShown) {
                        orderIdValue = OriginalData?.orderId || null;
                      }

                      // Build orderData matching API specification
                      const orderData: any = {
                        orderNumber: orderNumberFromView,
                        supplierId: Number(formData.transferTo),
                        transferDate: formData.transferDate
                          ? dayjs(formData.transferDate).format("YYYY-MM-DD")
                          : null,
                        transferReason: formData.reason,
                        filesData: filesData,
                        lineItems: lineItems,
                      };

                      // Add signatureLabel to orderData if signature is present
                      // signatureLabel must be a non-empty string when signature is uploaded
                      if (invoiceSignature?.image) {
                        orderData.signatureLabel = invoiceSignature?.label || "Authorised Signatory";
                      }

                      // Add orderId if sequence is not available at site level or if formData has orderNumber
                      if (orderIdValue !== null) {
                        orderData.orderId = orderIdValue;
                      } else if (
                        sequenceAccess?.level == "Site" &&
                        !sequenceAccess?.siteIds?.includes(
                          OriginalData?.siteId?.toString()
                        )
                      ) {
                        orderData.orderId = OriginalData?.orderId || null;
                      }

                      // Create FormData with orderData and files
                      const formDataToSend = new FormData();
                      formDataToSend.append("orderData", JSON.stringify(orderData));
                      
                      // Append files to FormData
                      files.forEach((file) => {
                        formDataToSend.append("files", file);
                      });

                      const res = await purchaseOrderApis.transferOrder(formDataToSend);
                      const { status, message, data: responseData } = res;

                      if (status) {
                        const orderNumberToShow =
                          responseData?.orderNumber ||
                          orderData.orderNumber ||
                          orderNumber;
                        Swal.fire(
                          "Transferred!",
                          `${message}\n\nOrder Number: ${orderNumberToShow}`,
                          "success"
                        );
                        closeTransferPoDrawer();
                        fetchOrderDetails();
                      } else {
                        Swal.fire(
                          "Error!",
                          message || "Failed to transfer PO.",
                          "error"
                        );
                      }
                    } catch (error: any) {
                      console.error("Transfer error:", error);
                      Swal.fire(
                        "Error!",
                        error?.message ||
                        "Something went wrong while transferring PO.",
                        "error"
                      );
                    } finally {
                      setDisableSubmit(false);
                    }
                  } else {
                    setDisableSubmit(false);
                  }
                });
              })}
              autoComplete="off"
            >
              <div className="">
                <h6>Billing & Other Information</h6>
                <div className="w-100">
                  <div className="justify-start w-100  flex-wrap pt-0">
                    <div className={` w-30 p-3 pt-0 pb-0`}>
                      <div className=" pt-1 d-flex">
                        <div className="data-label w-60">Billing Address</div>
                        <div className="data-value ">
                          <Popover
                            content={
                              <ShowBillingAddress
                                address={materialData?.billingAddress}
                              />
                            }
                          >
                            <span
                              style={{
                                color: "#2263b3",
                                textDecoration: "underline",
                                cursor: "pointer",
                              }}
                            >
                              View
                            </span>
                          </Popover>
                        </div>
                      </div>
                    </div>
                    {materialData?.deliveryAddressType != "Line Level" &&
                      materialData?.deliveryAddressId && (
                        <div className="w-30 p-3 pt-0 pb-0">
                          <div className="pt-1 d-flex">
                            <div className="data-label w-60">
                              Delivery Address
                            </div>
                            <div className="data-value">
                              <Popover
                                content={
                                  <ShowDeliveryAddress
                                    address={materialData?.deliveryAddress}
                                  />
                                }
                              >
                                <span
                                  style={{
                                    color: "#2263b3",
                                    textDecoration: "underline",
                                    cursor: "pointer",
                                  }}
                                >
                                  View
                                </span>
                              </Popover>
                            </div>
                          </div>
                        </div>
                      )}
                    {materialData?.deliveryAddressType == "Line Level" && (
                      <div className="w-30 p-3 pt-0 pb-0 ">
                        <div className=" pt-1 d-flex">
                          <div className="data-label w-60">
                            Delivery Address
                          </div>
                          <div className="data-value">
                            <Popover
                              content={
                                <ShowDeliveryAddress
                                  address={transferPoDeliveryAddressList?.find(
                                    (item: any) =>
                                      item?.id == selectedDeliveryAddress
                                  )}
                                />
                              }
                            >
                              <span
                                style={{
                                  color: "#2263b3",
                                  textDecoration: "underline",
                                  cursor: "pointer",
                                }}
                              >
                                View
                              </span>
                            </Popover>
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="w-30 p-3 pt-0 pb-0">
                      <div className="pt-1 d-flex">
                        <div className="data-label w-60">Approvals</div>
                        <div className="data-value">
                          <ApprovalTimelineContent
                            approvals={OriginalData?.orderApprovals}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="w-100" style={{ marginTop: "24px" }}>
                  <div
                    className="d-flex justify-content-start w-100 flex-wrap pt-3"
                    style={{ gap: "16px" }}
                  >
                    {((sequenceAccess?.level == "Site" &&
                      !sequenceAccess?.siteIds?.includes(
                        OriginalData?.siteId?.toString()
                      )) ||
                      sequenceAccess?.module == "") && (
                      <div
                        style={{
                          flex: "1 1 calc(33.333% - 12px)",
                          minWidth: "250px",
                          maxWidth: "calc(33.333% - 12px)",
                        }}
                        className="p-2 pt-0 pb-0"
                      >
                        <FormInput
                          name="orderNumber"
                          label="Order Number"
                          placeholder="Order Number"
                          required
                        />
                      </div>
                    )}
                    <div
                      style={{
                        flex: "1 1 calc(33.333% - 12px)",
                        minWidth: "250px",
                        maxWidth: "calc(33.333% - 12px)",
                      }}
                      className="p-3 pt-0 pb-0"
                    >
                      <FormDatePicker
                        name="transferDate"
                        label="Transfer Date"
                        placeholder="Transfer Date"
                        required
                        minDate={
                          OriginalData?.orderDate
                            ? new Date(OriginalData.orderDate)
                            : undefined
                        }
                        maxDate={new Date()}
                      />
                    </div>
                    <div
                      style={{
                        flex: "1 1 calc(33.333% - 12px)",
                        minWidth: "250px",
                        maxWidth: "calc(33.333% - 12px)",
                      }}
                      className="p-3 pt-0 pb-0"
                    >
                      <FormSelect
                        name="transferTo"
                        label="Transfer To"
                        placeholder="Select Transfer To"
                        required
                        options={
                          supplierOptions?.filter(
                            (option) =>
                              option.value !==
                              OriginalData?.supplierId?.toString()
                          ) || []
                        }
                      />
                    </div>
                    <div
                      style={{ flex: "1 1 100%", minWidth: "250px" }}
                      className="p-2 pt-0 pb-0"
                    >
                      <FormTextArea
                        name="reason"
                        label="Reason"
                        placeholder="Reason"
                        required
                        rows={2}
                      />
                    </div>
                  </div>
                </div>
                {grnRequired === "false" && (
                  <>
                    <h6>Transport Information</h6>
                    <div className="w-100">
                      <div className="justify-start w-100  flex-wrap pt-3">
                        <div className="w-30 p-3 paddingLeft10 pt-0 pb-0">
                          <FormInput
                            name="grnId"
                            label="GRN Number"
                            placeholder="GRN Number"
                            required
                          />
                        </div>
                        <div className="w-30 p-3 paddingLeft10 pt-0 pb-0">
                          <FormDatePicker
                            name="grnCreatedDate"
                            label="GRN Date"
                            placeholder="GRN Date"
                            dateFormat="DD/MM/YYYY"
                            required
                          />
                        </div>
                        <div className="w-30 p-3 paddingLeft10 pt-0 pb-0">
                          <FormInput
                            name="gateEntryNo"
                            label="Gate Entry No."
                            placeholder="Gate Entry No."
                            required
                          />
                        </div>
                        <div className="w-100" style={{ padding: "5px 0" }}>
                          <Button
                            type="button"
                            color=""
                            outline
                            style={{
                              backgroundColor: "transparent",
                              border: "1px solid #d0d0d0",
                              color: "#2263b3",
                            }}
                            onClick={() =>
                              setShowMoreTransportFields(
                                !showMoreTransportFields
                              )
                            }
                          >
                            {showMoreTransportFields ? (
                              <>
                                <Icon name="minus" />
                              </>
                            ) : (
                              <>
                                <Icon name="plus-round" />
                                <span>Add More</span>
                              </>
                            )}
                          </Button>
                        </div>
                        {showMoreTransportFields && (
                          <>
                            <div className="w-30 p-3 paddingLeft10 pt-0 pb-0">
                              <FormInput
                                name="vehicleNumber"
                                label={
                                  <>
                                    Vehicle Number {"("}
                                    <span className="small">
                                      {" "}
                                      eg: MH 12 AB 1234
                                    </span>{" "}
                                    {")"}
                                  </>
                                }
                                placeholder="Vehicle Number"
                              />
                            </div>
                            <div className="w-30 p-3 paddingLeft10 pt-0 pb-0">
                              <FormInput
                                name="driverName"
                                label="Driver Name"
                                placeholder="Driver Name"
                              />
                            </div>
                            <div className="w-30 p-3 paddingLeft10 pt-0 pb-0">
                              <FormInput
                                name="driverContact"
                                label="Driver Contact"
                                placeholder="Driver Contact"
                                type="text"
                                pattern="^[0-9]+$"
                                patternErrorMessage="Only numbers are allowed"
                                onKeyDown={(event: any) => {
                                  if (
                                    !/^[0-9]+$/.test(event.key) &&
                                    ![
                                      "Backspace",
                                      "Delete",
                                      "ArrowLeft",
                                      "ArrowRight",
                                      "Tab",
                                    ].includes(event.key)
                                  ) {
                                    event.preventDefault();
                                  }
                                }}
                              />
                            </div>
                            <div className="w-30 p-3 paddingLeft10 pt-0 pb-0">
                              <FormSelect
                                name="vehicleType"
                                label="Vehicle Type"
                                placeholder="Select Vehicle Type"
                                options={[
                                  {
                                    value: "tipper truck",
                                    label: "Tipper truck",
                                  },
                                  {
                                    value: "concrete truck",
                                    label: "Concrete truck",
                                  },
                                  {
                                    value: "pickup truck",
                                    label: "Pickup truck",
                                  },
                                  {
                                    value: "small truck",
                                    label: "Small truck",
                                  },
                                  { value: "box truck", label: "Box truck" },
                                  {
                                    value: "boat haulage",
                                    label: "Boat haulage",
                                  },
                                  {
                                    value: "flatbed truck",
                                    label: "Flatbed truck",
                                  },
                                  { value: "tow truck", label: "Tow truck" },
                                  {
                                    value: "chiller truck or reefers",
                                    label: "Chiller truck or reefers",
                                  },
                                  {
                                    value: "crane trucks or mobile cranes",
                                    label: "Crane trucks or mobile cranes",
                                  },
                                  {
                                    value: "logging truck",
                                    label: "Logging truck",
                                  },
                                  {
                                    value: "tanker truck",
                                    label: "Tanker truck",
                                  },
                                  {
                                    value: "furniture truck",
                                    label: "Furniture truck",
                                  },
                                  { value: "snow plows", label: "Snow plows" },
                                  {
                                    value: "trailer Truck",
                                    label: "Trailer Truck",
                                  },
                                  {
                                    value: "off-road Truck",
                                    label: "Off-road Truck",
                                  },
                                ]}
                              />
                            </div>
                            <div className="w-30 p-3 paddingLeft10 pt-0 pb-0">
                              <FormInput
                                name="driverEmail"
                                label="Driver Email"
                                placeholder="Driver Email"
                                type="email"
                                patternErrorMessage="Please enter a valid email address"
                              />
                            </div>
                            <div className="w-30 p-3 paddingLeft10 pt-0 pb-0">
                              <FormInput
                                name="dharamkantaReceiptNo"
                                label="Dharamkanta Receipt No."
                                placeholder="Dharamkanta Receipt No."
                              />
                            </div>
                            <div className="w-30 p-3 paddingLeft10 pt-0 pb-0">
                              <FormInput
                                name="dmrNo"
                                label="DMR No."
                                placeholder="DMR No."
                              />
                            </div>
                            <div className="w-30 p-3 paddingLeft10 pt-0 pb-0">
                              <FormInput
                                name="weighbridgeSlipNo"
                                label="Weighbridge Slip No."
                                placeholder="Weighbridge Slip No."
                              />
                            </div>
                            <div className="w-30 p-3 paddingLeft10 pt-0 pb-0">
                              <FormInput
                                name="ticketNo"
                                label="Ticket No."
                                placeholder="Ticket No."
                              />
                            </div>
                            <div className="w-30 p-3 paddingLeft10 pt-0 pb-0">
                              <FormInput
                                name="youtubeLink"
                                label="You Tube link"
                                placeholder="You Tube link"
                              />
                            </div>
                            <div className="w-30 p-3 paddingLeft10 pt-0 pb-0">
                              <FormInput
                                name="loadTruckWeight"
                                label="Load Truck Weight"
                                placeholder="Load Truck Weight"
                                type="number"
                                min={0}
                                onKeyDown={(event: any) => {
                                  const regex = /^[0-9\b\.]+$/;
                                  if (
                                    !regex.test(event.key) &&
                                    ![
                                      "Backspace",
                                      "Delete",
                                      "ArrowLeft",
                                      "ArrowRight",
                                      "Tab",
                                    ].includes(event.key)
                                  ) {
                                    event.preventDefault();
                                  }
                                }}
                              />
                            </div>
                            <div className="w-30 p-3 paddingLeft10 pt-0 pb-0">
                              <FormInput
                                name="emptyTruckWeight"
                                label="Empty Truck Weight"
                                placeholder="Empty Truck Weight"
                                type="number"
                                min={0}
                                onKeyDown={(event: any) => {
                                  const regex = /^[0-9\b\.]+$/;
                                  if (
                                    !regex.test(event.key) &&
                                    ![
                                      "Backspace",
                                      "Delete",
                                      "ArrowLeft",
                                      "ArrowRight",
                                      "Tab",
                                    ].includes(event.key)
                                  ) {
                                    event.preventDefault();
                                  }
                                }}
                              />
                            </div>
                            <div className="w-30 p-3 paddingLeft10 pt-0 pb-0">
                              <FormInput
                                name="netWeight"
                                label="Net Weight"
                                placeholder="Net Weight"
                                type="number"
                                min={0}
                                onKeyDown={(event: any) => {
                                  const regex = /^[0-9\b\.]+$/;
                                  if (
                                    !regex.test(event.key) &&
                                    ![
                                      "Backspace",
                                      "Delete",
                                      "ArrowLeft",
                                      "ArrowRight",
                                      "Tab",
                                    ].includes(event.key)
                                  ) {
                                    event.preventDefault();
                                  }
                                }}
                              />
                            </div>
                            <div className="w-30 p-3 paddingLeft10 pt-0 pb-0">
                              <FormTimePicker
                                name="vehicleInTime"
                                label="Vehicle InTime"
                                placeholder="Select Time"
                                format="hh:mm A"
                              />
                            </div>
                            <div className="w-30 p-3 paddingLeft10 pt-0 pb-0">
                              <FormTimePicker
                                name="vehicleOutTime"
                                label="Vehicle OutTime"
                                placeholder="Select Time"
                                format="hh:mm A"
                              />
                            </div>
                            <div className="w-30 p-3 paddingLeft10 pt-0 pb-0">
                              <FormInput
                                name="loadTruckWeightInHouse"
                                label="Load Truck Weight In House"
                                placeholder="Load Truck Weight"
                                type="number"
                                min={0}
                                onKeyDown={(event: any) => {
                                  const regex = /^[0-9\b\.]+$/;
                                  if (
                                    !regex.test(event.key) &&
                                    ![
                                      "Backspace",
                                      "Delete",
                                      "ArrowLeft",
                                      "ArrowRight",
                                      "Tab",
                                    ].includes(event.key)
                                  ) {
                                    event.preventDefault();
                                  }
                                }}
                              />
                            </div>
                            <div className="w-30 p-3 paddingLeft10 pt-0 pb-0">
                              <FormInput
                                name="emptyTruckWeightInHouse"
                                label="Empty Truck Weight In House"
                                placeholder="Empty Truck Weight"
                                type="number"
                                min={0}
                                onKeyDown={(event: any) => {
                                  const regex = /^[0-9\b\.]+$/;
                                  if (
                                    !regex.test(event.key) &&
                                    ![
                                      "Backspace",
                                      "Delete",
                                      "ArrowLeft",
                                      "ArrowRight",
                                      "Tab",
                                    ].includes(event.key)
                                  ) {
                                    event.preventDefault();
                                  }
                                }}
                              />
                            </div>
                            <div className="w-30 p-3 paddingLeft10 pt-0 pb-0">
                              <FormInput
                                name="netWeightInHouse"
                                label="Net Weight In House"
                                placeholder="Net Weight"
                                type="number"
                                min={0}
                                onKeyDown={(event: any) => {
                                  const regex = /^[0-9\b\.]+$/;
                                  if (
                                    !regex.test(event.key) &&
                                    ![
                                      "Backspace",
                                      "Delete",
                                      "ArrowLeft",
                                      "ArrowRight",
                                      "Tab",
                                    ].includes(event.key)
                                  ) {
                                    event.preventDefault();
                                  }
                                }}
                              />
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </div>
              <AntCollapse defaultActiveKey={["1", "2"]} className="mt-3">
                <Panel header={<h6>Material Information</h6>} key="1">
                  <div className="table-responsive poTable">
                    <div
                      style={{
                        width:
                          screenSize -
                          (extra?.reduceTableWidth || 380) +
                          "px",
                        margin: "15px auto",
                      }}
                    >
                      <Table
                        className="customTable"
                        columns={
                          configColumns(
                            taxConfiguration,
                            currency,
                            poStatus,
                            invoiceableLines,
                            OriginalData
                          ).map((col: any) => {
                            if (col.dataIndex === "invoiceQuantity") {
                              return {
                                ...col,
                                hidden: true,
                              };
                            } else if (col.key === "operation" || col.title === "Action") {
                              // Show edit button in Transfer PO drawer - always allow editing
                              return {
                                ...col,
                                hidden: false,
                                render: (text: any, record: any, index: any) => {
                                  // Always show edit button in Transfer PO drawer
                                  if (record?.key === "lastRow") {
                                    return null;
                                  }
                                  return (
                                    <Button
                                      size="sm"
                                      color=""
                                      onClick={() => {
                                        setEditLineRow(record);
                                      }}
                                    >
                                      <Icon name="edit" />
                                    </Button>
                                  );
                                },
                              };
                            } else if (col.dataIndex === "quantityDelivered" || col.key === "quantityDelivered") {
                              // Hide Delivered Qty column in Transfer PO drawer
                              return {
                                ...col,
                                hidden: true,
                              };
                            } else if (col.key === "quantityTransferred" || col.dataIndex === "quantityTransferred") {
                              // Always show Transfer Qty column in Transfer PO drawer
                              // Show original transferred quantity, not the pre-populated value
                              return {
                                ...col,
                                hidden: false,
                                render: (text: any, record: any) => {
                                  if (record?.key == "lastRow") {
                                    const total = invoiceableLines.reduce((a: any, b: any) => {
                                      // Use originalQuantityTransferred if available, otherwise use 0
                                      const value = Number(b.originalQuantityTransferred !== undefined ? b.originalQuantityTransferred : 0) || 0;
                                      return +a + value;
                                    }, 0);
                                    return (
                                      <div className="justify-end">{Number(total).toFixed(2)}</div>
                                    );
                                  }
                                  // Show original transferred quantity, not the pre-populated value
                                  const value = Number(record?.originalQuantityTransferred !== undefined ? record?.originalQuantityTransferred : 0) || 0;
                                  return (
                                    <div className="justify-end">
                                      {Number(value).toFixed(2)} {record?.uom || record?.uomLabel}
                                    </div>
                                  );
                                },
                              };
                            } else if (col.dataIndex == "grossTotal") {
                              return {
                                ...col,
                                fixed: "right",
                              };
                            }
                            return {
                              ...col,
                            };
                          }).filter((col: any) => col.hidden !== true).reduce((acc: any[], col: any, index: number, array: any[]) => {
                            // Add the current column
                            acc.push(col);
                            // Insert Available Qty column after Transferred Qty column in Transfer PO drawer
                            if (col.key === "quantityTransferred" || col.dataIndex === "quantityTransferred") {
                              acc.push({
                                title: "Available Qty",
                                key: "availableQuantity",
                                width: 150,
                                render: (text: any, record: any) => {
                                  if (record?.key == "lastRow") {
                                    const total = invoiceableLines.reduce((a: any, b: any) => {
                                      const qty = Number(b.quantity) || 0;
                                      const invoicedQty = Number(b.quantityInvoiced) || 0;
                                      // Use quantityTransferred (updated value from user edit) instead of originalQuantityTransferred
                                      const transferredQty = Number(b?.quantityTransferred !== undefined ? b.quantityTransferred : (b?.originalQuantityTransferred || 0)) || 0;
                                      const availableQty = qty - invoicedQty - transferredQty;
                                      // If user has edited quantity in modal, use that edited quantity (quantityTransferred) directly
                                      // Otherwise calculate available qty
                                      const value = (b?.quantityTransferred !== undefined && b?.quantityTransferred !== null) 
                                        ? Number(b.quantityTransferred) 
                                        : (availableQty > 0 ? availableQty : 0);
                                      return +a + value;
                                    }, 0);
                                    return (
                                      <div className="justify-end">{Number(total).toFixed(2)}</div>
                                    );
                                  }
                                  const qty = Number(record?.quantity) || 0;
                                  const invoicedQty = Number(record?.quantityInvoiced) || 0;
                                  // Use quantityTransferred (updated value from user edit) instead of originalQuantityTransferred
                                  // This reflects the quantity that user edited in the modal
                                  const transferredQty = Number(record?.quantityTransferred !== undefined ? record?.quantityTransferred : (record?.originalQuantityTransferred || 0)) || 0;
                                  const availableQty = qty - invoicedQty - transferredQty;
                                  // If user has edited quantity in modal, use that edited quantity (quantityTransferred) directly
                                  // Otherwise calculate available qty
                                  const value = (record?.quantityTransferred !== undefined && record?.quantityTransferred !== null) 
                                    ? Number(record?.quantityTransferred) 
                                    : (availableQty > 0 ? availableQty : 0);
                                  return (
                                    <div className="justify-end">
                                      {Number(value).toFixed(2)} {record?.uom || record?.uomLabel}
                                    </div>
                                  );
                                },
                                onCell: (record: any) => {
                                  if (record?.key == "lastRow") {
                                    return {};
                                  }
                                  return {};
                                },
                              });
                            }
                            return acc;
                          }, []) as any
                        }
                        dataSource={[
                          ...invoiceableLines?.map(
                            (item: any, index: any) => ({
                              ...item,
                              key: index,
                            })
                          ),
                          {
                            key: "lastRow",
                            materialName: "Total",
                            quantity: 0,
                            unitPrice: 0,
                            amount: 0,
                          },
                        ]}
                        scroll={{ x: 1000 }}
                        expandable={{
                          expandedRowRender: (record: any) => {
                            if (record?.key == "lastRow") {
                              return <></>;
                            }
                            return (
                              <div className="expandableBody">
                                <div style={{ flex: 1, textAlign: "left" }}>
                                  <p style={{ margin: 0 }}>
                                    {record.description}
                                  </p>
                                  {record.attachment && (
                                    <div>
                                      <PaperClipOutlined /> &nbsp;
                                      {record?.file[0]?.name ? (
                                        <a
                                          href={URL.createObjectURL(
                                            record.file[0]
                                          )}
                                          download={record.file[0]?.name}
                                        >
                                          {record.file[0]?.name}
                                        </a>
                                      ) : (
                                        <a
                                          href={record?.file?.filePath}
                                          download={record?.file?.filePath}
                                          target="_blank"
                                        >
                                          {record?.file?.fileName}
                                        </a>
                                      )}
                                    </div>
                                  )}
                                </div>
                              </div>
                            );
                          },
                        }}
                        locale={{
                          emptyText: (
                            <span
                              style={{
                                height: "300px",
                                color: "#333",
                                fontSize: "16px",
                              }}
                            >
                              Please click on "Add New Item" to add purchase
                              order lines.
                            </span>
                          ),
                        }}
                        bordered
                        size="middle"
                        pagination={false}
                      />
                    </div>
                  </div>
                  <Row
                    style={{
                      margin: "20px",
                    }}
                  >
                    <Col
                      className={`${poStatus == "Pending Approval" &&
                        allowedActions?.edit == 1
                        ? "justify-between"
                        : "justify-end"
                        }`}
                    >
                      {(poStatus == "Pending Approval" || poStatus == "Rejected") &&
                        allowedActions?.edit == 1 ? (
                        <a
                          onClick={() => {
                            setAddNewRowModel(true);
                            setEditLineRow(null);
                          }}
                          href="#add"
                          className="addNewItem"
                        >
                          <Icon name="plus-round" />
                          <span>Add New Item</span>
                        </a>
                      ) : (
                        <></>
                      )}
                      <div className="w-40">
                        <div className="d-flex justify-content-between">
                          <div className="w-50 justify-end">
                            <strong>Taxable Amount</strong>
                          </div>
                          <span className="r_align">
                            {FormatCurrency(
                              invoiceableLines?.reduce(
                                (a: any, b: any) =>
                                  a +
                                  Number(b.quantity) *
                                  Number(b.unitPrice),
                                0
                              ),
                              currency?.currency_code
                            )}
                          </span>
                        </div>
                        {taxConfiguration?.gstType == "CGST+SGST" ? (
                          <>
                            <div className="d-flex justify-content-between">
                              <div className="w-50 justify-end">
                                <strong>CGST</strong>
                              </div>
                              <span className="r_align">
                                {FormatCurrency(
                                  invoiceableLines?.reduce(
                                    (a: any, b: any) =>
                                      a + Number(b.cgst),
                                    0
                                  ),
                                  currency?.currency_code
                                )}
                              </span>
                            </div>
                            <div className="d-flex justify-content-between">
                              <div className="w-50 justify-end">
                                <strong>SGST</strong>
                              </div>
                              <span className="r_align">
                                {FormatCurrency(
                                  invoiceableLines?.reduce(
                                    (a: any, b: any) =>
                                      a + Number(b.sgst),
                                    0
                                  ),
                                  currency?.currency_code
                                )}
                              </span>
                            </div>
                          </>
                        ) : (
                          <div className="d-flex justify-content-between">
                            <div className="w-50 justify-end">
                              <strong>IGST</strong>
                            </div>
                            <span className="r_align">
                              {FormatCurrency(
                                invoiceableLines?.reduce(
                                  (a: any, b: any) => a + Number(b.igst),
                                  0
                                ),
                                currency?.currency_code
                              )}
                            </span>
                          </div>
                        )}
                        <div
                          className="d-flex justify-content-between"
                          style={{
                            fontSize: "18px",
                            marginTop: "10px",
                          }}
                        >
                          <div className="w-50 justify-end">
                            <strong>Total</strong>
                          </div>
                          <strong className="r_align">
                            {FormatCurrency(
                              invoiceableLines?.reduce(
                                (a: any, b: any) =>
                                  a + Number(b.grossTotal),
                                0
                              ),
                              currency?.currency_code
                            )}
                          </strong>
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row className="m-4 justify-content-end ">
                    {invoiceSignature?.isActive ? (
                      <div className="signatureBtnWrapper">
                        <div className="d-flex justify-content-between align-items-center">
                          <strong>Signature</strong>
                          <a
                            style={{
                              fontSize: "14px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setInvoiceSignature({
                                isActive: false,
                                image: null,
                                label: "Authorised Signatory",
                              });
                            }}
                          >
                            <Icon
                              name="cross"
                              className="pointer"
                              onClick={() => {
                                setInvoiceSignature({
                                  isActive: false,
                                  image: null,
                                  label: "Authorised Signatory",
                                });
                              }}
                            />
                          </a>
                        </div>
                        <div
                          style={{
                            minHeight: invoiceSignature?.image ? "0px" : "120px",
                            display: invoiceSignature?.image ? "block" : "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {!invoiceSignature?.image && (
                            <Button
                              color="btn-dim btn"
                              onClick={() => {
                                setShowCropModel(true);
                              }}
                            >
                              <Icon
                                name="upload-cloud"
                                className="pointer"
                                onClick={() => {
                                  setShowCropModel(true);
                                }}
                              />
                              <span>Upload</span>
                            </Button>
                          )}
                          {invoiceSignature?.image && (
                            <>
                              <div className="signatueImgWrapper border">
                                <img
                                  src={invoiceSignature?.image}
                                  alt="Signed"
                                  style={{ width: "160px" }}
                                />
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                }}
                              >
                                <Button
                                  color="btn-dim btn"
                                  onClick={() => {
                                    setInvoiceSignature((pre: any) => {
                                      return { ...pre, image: null };
                                    });
                                  }}
                                >
                                  <span>Reset</span>
                                  <Icon
                                    name="redo"
                                    className="pointer"
                                    onClick={() => {
                                      setInvoiceSignature((pre: any) => {
                                        return { ...pre, image: null };
                                      });
                                    }}
                                  />
                                </Button>
                              </div>
                              <div>
                                <div className="form-group">
                                  <label
                                    className="form-label"
                                    htmlFor="signatureLabel"
                                  >
                                    Signature Label
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="signatureLabel"
                                    onChange={(e) => {
                                      setInvoiceSignature((pre: any) => {
                                        return {
                                          ...pre,
                                          label: e.target.value,
                                        };
                                      });
                                    }}
                                    defaultValue={
                                      invoiceSignature?.label ||
                                      "Authorised Signatory"
                                    }
                                  />
                                </div>
                              </div>
                            </>
                          )}
                        </div>

                        {!invoiceSignature?.image && (
                          <>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                flexDirection: "column",
                              }}
                            >
                              <Button
                                color="btn-dim btn"
                                onClick={() => setShowSignatureModel(true)}
                              >
                                <Icon name="pen" />
                                <span>Use Signature Pad</span>
                              </Button>
                            </div>
                          </>
                        )}
                      </div>
                    ) : (
                      <div
                        style={{
                          border: "1px solid #e5ecf7",
                          backgroundColor: "#f7faff",
                          padding: "10px",
                          marginLeft: "10px",
                          width: "22%",
                          borderRadius: "5px",
                          textAlign: "center",
                        }}
                      >
                        <Button
                          color="btn-dim btn"
                          onClick={() => {
                            setInvoiceSignature((pre: any) => {
                              return { ...pre, isActive: true };
                            });
                          }}
                        >
                          <Icon
                            name="edit"
                            className="pointer"
                            onClick={() => {
                              setInvoiceSignature((pre: any) => {
                                return { ...pre, isActive: true };
                              });
                            }}
                          />
                          <span>Add Signature</span>
                        </Button>
                      </div>
                    )}
                  </Row>
                </Panel>
                <Panel header={<h6>Attachments (If Any) </h6>} key="3">
                  <Dragger
                    beforeUpload={beforeUploadTransferPO}
                    onChange={handleInvoiceAttachmentChange}
                    fileList={invoiceAttachments}
                    maxCount={3}
                    multiple={true}
                    accept=".pdf,.jpg,.jpeg,.png"
                    customRequest={({ onSuccess }) => {
                      // Prevent auto-upload - files will be uploaded on form submit
                      if (onSuccess) {
                        setTimeout(() => onSuccess("ok"), 0);
                      }
                    }}
                    showUploadList={{ showPreviewIcon: false }}
                    itemRender={(originNode, file, fileList, actions) => {
                      // Customize the rendering of each file to remove the tooltip
                      return React.cloneElement(originNode, {
                        title: null, // Removes the tooltip entirely
                      });
                    }}
                  >
                    <p className="ant-upload-text">
                      Click or drag file to this area to upload
                    </p>
                  </Dragger>
                </Panel>
              </AntCollapse>
              {showCropModel && (
                <CropperComponent
                  modal={showCropModel}
                  toggle={() => setShowCropModel(false)}
                  onSave={(data: string) => {
                    setInvoiceSignature((pre: any) => {
                      return {
                        ...pre,
                        image: data,
                        isActive: true,
                        label: pre?.label || "Authorised Signatory",
                      };
                    });
                    setShowCropModel(false);
                  }}
                />
              )}
              {showSignatureModel && (
                <SignatureModal
                  modal={showSignatureModel}
                  toggle={() => setShowSignatureModel(false)}
                  onSave={(data: string) => {
                    setInvoiceSignature((pre: any) => {
                      return {
                        ...pre,
                        image: data,
                        isActive: true,
                        label: pre?.label || "Authorised Signatory",
                      };
                    });
                    setShowSignatureModel(false);
                  }}
                />
              )}
            </form>
          </FormProvider>
        </Drawer>
      )}
    </>
  );
};

const RejectCR = ({ isModalVisible, setIsModalVisible, rejectCR, onRestore }: any) => {
  const [form] = Form.useForm();

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        const reason = values.reason;
        rejectCR(reason); // Call your reject function here
        form.resetFields();
        setIsModalVisible(false);
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  return (
    <AntModal
      title="Reject Change Request"
      visible={isModalVisible}
      footer={null} // Remove the default footer buttons
      onCancel={handleCancel}
    >
      <Form form={form} layout="vertical" name="rejectForm">
        <Form.Item
          name="reason"
          label="Reason for rejection"
          rules={[{ required: true, message: "Please input your reason!" }]}
        >
          <Input.TextArea placeholder="Type your reason here..." />
        </Form.Item>
        <div className="actions clearfix">
          <ul>
            <li>
              <Button color="primary" type="submit" onClick={handleOk}>
                Submit
              </Button>
            </li>
            <li>
              <Button
                color="primary"
                onClick={handleCancel}
                className="btn-dim btn btn-secondary"
              >
                Cancel
              </Button>
            </li>
          </ul>
        </div>
      </Form>
    </AntModal>
  );
};

const RejectPo = ({ isModalVisible, setIsModalVisible, rejectPo, onRestore }: any) => {
  const [form] = Form.useForm();
  const [rejectSignature, setRejectSignature] = useState({
    isActive: false,
    label: "Authorised Signatory",
    image: null as string | null,
  });
  const [showSignatureModel, setShowSignatureModel] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(false);

  // Helper function to convert data URL to File
  const dataURLToFile = (dataUrl: string, fileName: string): File => {
    const arr = dataUrl.split(",");
    const mimeMatch = arr[0].match(/:(.*?);/);
    const mime = mimeMatch ? mimeMatch[1] : "image/png";
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], fileName, { type: mime });
  };

  const handleCancel = () => {
    form.resetFields();
    setRejectSignature({ isActive: false, label: "Authorised Signatory", image: null });
    setIsModalVisible(false);
  };

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        const reason = values.reason;

        if (!rejectSignature.image) {
          Swal.fire({
            icon: "info",
            title: "Signature Required",
            text: "Please add your signature before rejecting.",
          });
          return;
        }

        Swal.fire({
          title: "Confirm Rejection?",
          text: "This action cannot be undone!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, Reject it!",
          cancelButtonText: "Cancel",
          allowOutsideClick: false,
          allowEscapeKey: false,
        }).then(async (result) => {
          if (result.isConfirmed) {
            setIsLoading(true);
            const file = dataURLToFile(rejectSignature.image as string, "signature.png");
            await rejectPo(reason, [file]); // Pass both reason and signature file
            setIsLoading(false);
            form.resetFields();
            setRejectSignature({ isActive: false, label: "Authorised Signatory", image: null });
            setIsModalVisible(false);
          }
        });
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  return (
    <>
      <AntModal
        title="Reject Purchase Order"
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        width={700}
      >
        <Form form={form} layout="vertical" name="rejectForm">
          <Form.Item
            name="reason"
            label="Reason for rejection"
            rules={[{ required: true, message: "Please input your reason!" }]}
          >
            <Input.TextArea
              placeholder="Type your reason here..."
              rows={4}
              maxLength={500}
              showCount
            />
          </Form.Item>

          <div className="mb-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <span style={{ fontSize: 14, fontWeight: 600 }}>Signature</span>
              {rejectSignature.image && (
                <button
                  type="button"
                  onClick={() =>
                    setRejectSignature({
                      isActive: true,
                      label: "Authorised Signatory",
                      image: null,
                    })
                  }
                  style={{
                    border: "none",
                    background: "transparent",
                    padding: 0,
                    cursor: "pointer",
                  }}
                >
                  <EditOutlined style={{ color: "#2263b3" }} />
                </button>
              )}
            </div>

            {rejectSignature.image ? (
              <>
                <div
                  className="border mb-3 d-flex justify-content-center align-items-center"
                  style={{
                    padding: 16,
                    borderRadius: 8,
                    background: "#fff",
                    minHeight: 150,
                  }}
                >
                  <img
                    src={rejectSignature.image}
                    alt="Signed"
                    style={{ maxWidth: 220, maxHeight: 120, objectFit: "contain" }}
                  />
                </div>

                <div className="d-flex justify-content-between align-items-center mb-3">
                  <Button
                    size="sm"
                    color="outline-secondary"
                    onClick={() =>
                      setRejectSignature({
                        isActive: true,
                        label: "Authorised Signatory",
                        image: null,
                      })
                    }
                  >
                    Reset Signature
                  </Button>
                </div>
              </>
            ) : (
              <div
                style={{
                  width: "100%",
                  minHeight: 220,
                  border: "2px dashed #dee2e6",
                  borderRadius: 8,
                  backgroundColor: "#f8f9fa",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: 24,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: 12,
                    justifyContent: "center",
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <ImageUploadCropper
                    onOpenCrop={() => {
                      setIsModalVisible(false);
                    }}
                    onCloseCrop={() => {
                      setIsModalVisible(true);
                      onRestore && onRestore();
                    }}
                    onSave={(data: string) => {
                      setRejectSignature((prev: any) => ({ ...prev, image: data }));
                      setIsModalVisible(true);
                      onRestore && onRestore();
                    }}
                  >
                    <Button
                      color="primary"
                      size="sm"
                      outline
                      style={{ minWidth: 140 }}
                      onClick={() => { }}
                    >
                      <Icon name="upload-cloud" className="me-1" />
                      Upload Image
                    </Button>
                  </ImageUploadCropper>

                  <Button
                    color="outline-primary"
                    size="sm"
                    style={{ minWidth: 140 }}
                    onClick={() => {
                      setIsModalVisible(false);
                      setShowSignatureModel(true);
                    }}
                  >
                    <Icon name="pen" className="me-1" />
                    Signature Pad
                  </Button>
                </div>
              </div>
            )}
          </div>

          <div className="actions clearfix">
            <ul className="d-flex justify-content-end" style={{ gap: "10px" }}>
              <li>
                <Button color="primary" type="submit" onClick={handleOk}>
                  Submit
                </Button>
              </li>
              <li>
                <Button
                  color="primary"
                  onClick={handleCancel}
                  className="btn-dim btn btn-secondary"
                >
                  Cancel
                </Button>
              </li>
            </ul>
          </div>
        </Form>
      </AntModal>

      {showSignatureModel && (
        <SignatureModal
          modal={showSignatureModel}
          toggle={() => {
            setShowSignatureModel(false);
            setIsModalVisible(true);
            onRestore && onRestore();
          }}
          onSave={(data: string) => {
            setRejectSignature((prev: any) => ({ ...prev, image: data }));
            setIsModalVisible(true);
            onRestore && onRestore();
            setShowSignatureModel(false);
          }}
        />
      )}


    </>
  );
};

export default ViewOrderDetails;